export const English = {
  lang: 'en',
  wizard: {
    createAccount: 'Create new account',
    noCreditCard: 'No credit card needed, cancel any time',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    role: 'Role',
    dialCode: 'Country',
    fullNumber: 'Country and phone number',
    password: 'Password',
    saveButton: 'Send',
    captchaError: 'Captcha has not been validated',
    inputError: 'Complete field',
    emailExistsError: 'Email address is already in use',
    emailCheckUnavailable:
      'We could not check this email address. Try again in a moment.',
    passwordError: 'Must be at least 6 characters long',
    emailError: 'Invalid email',
    emailInfo: 'With this email you can login into app and web platform',
    privacyMessage: 'Upon clicking you agree that you accept our ',
    privacy: 'Privacy Policy',
    preparingForm: 'We are creating your account and preparing the form',
    preparingForm2: 'This could take a few seconds',
    preparingForm3: 'We are preparing the form',
    userHasAccount: 'Already have an account?',
    login: 'Login',
    onboardingVideo:
      'Watch this brief video and discover how Datascope can transform your processes and make your work easier',
    onboardingVideoTitle: 'What can Datascope do for you?',
    onboardingVideoSkip: 'Continue',
    onboardingResetModal: {
      title: 'Aún no terminas de configurar tu cuenta',
      message:
        'No terminaste de configurar tu cuenta. ¿Quieres continuar donde la dejaste o empezar desde cero?',
      cancelButtonText: 'Comenzar de nuevo',
      confirmButtonText: 'Continuar',
      error: 'Error resetting account information',
    },
    onboardingLogoutModal: {
      title: 'Are you sure you want to logout from the onboarding process?',
      message: 'If you logout, you can resume the onboarding process later by logging in again.',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Logout',
    },
    back: 'Back',
    intro: "Hello! Let's start with the basics",
    introDescription:
      'Help us get to know you better so we can personalize your experience and offer you exactly what you need.',
    companyName: 'Your company name',
    industry: 'Your industry',
    phoneNumber: 'Your phone number',
    next: 'Next',
    firstNameError: 'First name is required',
    lastNameError: 'Last name is required',
    companyNameError: 'Company name is required',
    industryError: 'Industry is required',
    phoneNumberError: 'Phone number must have at least 8 digits',
    noResults: 'No results',
    searchCountry: 'Search country...',
    selectOption: 'Select an option',
    namePlaceholder: 'Write your name',
    companyPlaceholder: 'Write your company name',
    search: 'Search',
    formErrors: 'Please complete all required fields',
    industries: {
      agriculture: 'Agriculture',
      food: 'Food',
      automotive: 'Automotive',
      construction: 'Construction',
      consulting: 'Consulting',
      energy: 'Energy',
      facility: 'Facility Services',
      forestry: 'Forestry',
      engineering: 'Engineering',
      cleaning: 'Cleaning and Maintenance',
      logistics: 'Logistics',
      machinery: 'Machinery',
      manufacturing: 'Manufacturing',
      mining: 'Mining',
      retail: 'Retail',
      public: 'Public Sector',
      environment: 'Environmental Services',
      health: 'Health Services',
      communication: 'Telecommunications',
      transport: 'Transportation and Loading',
      wine: 'Wine',
    },
    roles: {
      management: 'Management',
      consulting: 'Consulting',
      owner: 'Owner',
      leadership: 'Leadership',
      student: 'Student',
      independent: 'Independent',
      analyst: 'Analyst',
      other: 'Other',
    },
    roleRequired: 'Please select a role',
    roleQuestion: 'Now tell us, what is your role in the organization?',
    roleQuestionDescription: 'This will help us provide you with a better experience',
    areas: {
      security: 'Security and hygiene',
      quality: 'Quality',
      operations: 'Operations/Services (WO/SO)',
      audit: 'Audit',
      general: 'General use',
    },
    areaRequired: 'Please select an area',
    areaQuestion: 'In which area would you like to focus today?',
    areaQuestionDescription: 'Select the area that most interests you',
    selectOptions: 'Select the options that interest you',
    selectRequired: 'Please select at least one option',
    interests: {
      security: {
        question: 'What would you like to manage in security and hygiene?',
        options: {
          register_talks: 'Register talks',
          fatality_risks: 'Fatality risks',
          risks_matrices: 'Risk matrices',
          safety_work_analysis: 'Safety work analysis',
          accidents: 'Accidents and incidents',
          inspection_checklist: 'Inspection checklist',
          training_records: 'Training records',
        },
      },
      quality: {
        question: 'What aspect of quality would you like to manage?',
        options: {
          standard_procedures: 'Standard Operating Procedures (SOP)',
          preoperational_verifications: 'Pre-operational verifications',
          quality_control: 'Quality control',
          audit_plans: 'Audit plans',
          non_conformity_records: 'Non-conformity records',
          legal_records: 'Legal records',
        },
      },
      operations: {
        question: 'What operations would you like to manage?',
        options: {
          maintenance_programs: 'Maintenance programs',
          calibrations: 'Calibrations',
          installations: 'Installations',
          failure_records: 'Failure records',
          daily_reports: 'Daily reports',
          certifications: 'Certifications',
          warranties: 'Warranties',
          consumption_records: 'Consumption records',
          progress_records: 'Progress records',
        },
      },
      audit: {
        question: 'What type of audit would you like to manage?',
        options: {
          quality_audits: 'Quality audits',
          safety_audits: 'Safety and hygiene audits',
          equipment_audits: 'Equipment audits',
          norms_compliance: 'Compliance with norms',
          register_audits: 'Audit records',
          performance_evaluations: 'Performance evaluations',
        },
      },
      general: {
        question: 'What general functionality would you like to use?',
        options: {
          polls: 'Polls',
          inventory: 'Inventory control',
          attendance: 'Attendance control',
        },
      },
    },
    moreThan: 'More than',
    selectOneOption: 'Please select one option',
    personnelCount: 'Currently, how many people work on this process?',
    personnelCountDescription: 'Select the number of people who will use the platform',
    complete: 'Finish',
  },
  wizardFinish: {
    buildYourFirstForm: 'Build your first form',
    yourPick: 'Your pick',
    formTemplates: 'Form templates',
    createForm: 'Create form from scratch',
    importForm: 'Import Google Form',
    welcome: 'Welcome!',
    welcomeDescription1: 'Starting now, you can ',
    welcomeDescription2:
      'use the Web App and the Mobile App using the credentials you just entered.',
    welcomeDescription3:
      'Remember, to begin collecting data, simply download the App from App Store or Play Store on your phone or tablet.',
  },
  onboardingTemplates: {
    title: 'We recommend these forms based on your use',
    subtitle: 'Select one to start working immediately',
    answerNow: 'Answer now',
    exploreOthers: 'Explore other templates',
    aiFormBuilderCta: 'Create your form with AI in seconds.',
    aiFormBuilderLink: 'Open AI form builder',
    aiFormBuilderTitle: 'Create your form with AI in seconds',
    aiFormBuilderSubtitle: 'Describe the form you need and our agent will create it in seconds.',
    aiFormBuilderButton: 'Create with AI',
    recentlyViewedLabel: 'Recently viewed',
    aiFormBuilderRecommendationsTitle: 'Recommendations you can create and use',
    aiFormBuilderNoMatchText: "Can't find the right one?",
    aiFormBuilderNoMatchButton: 'Create a custom form with AI',
  },
  plannings: {
    integrations: {
      title: 'Planning Integration',
      gsheetsIntegrationLabel: 'Go to Google Sheets',
      gsheetsNewLinkUrl: 'https://sheets.new/',
      infoTextPart1:
        'To ensure a proper, private and secure integration, share your document with edit permissions to',
      infoTextPart2: 'editor',
      infoTextPart3: 'only to',
      inputLabel: 'New link',
      inputPlaceholder: 'Enter the document link to integrate',
      optional: '(Optional)',
      save: 'Save',
      cancel: 'Cancel',
      copyUrl: 'URL copied!',
      copyEmail: 'Email copied!',
      created: 'Integration set up successfully!',
      saved: 'Changes saved successfully!',
      deleted: 'Integration removed successfully',
      savingError: 'Error setting up the integration',
      removeTitle: 'Remove the Google Sheets integration?',
      removeBody:
        'The sheet will stop receiving planning updates from DataScope. The document in Google Drive will not be deleted.',
      removeConfirm: 'Remove integration',
      removeCancel: 'Cancel',
    },
    title: 'Plannings',
    subtitle: 'Manage recurring task plans with supervisors and progress tracking.',
    new: 'New planning',
    create: 'Create',
    planningTypes: 'Templates',
    import: 'Import',
    export: 'Export',
    search: 'Search by planning name',
    clearFilters: 'Clear filters',
    actions: 'Actions',
    of: 'of',
    loading: 'Loading plannings…',
    pricing: {
      inUse: 'in use',
      quotaTooltip:
        'Active, late and paused plannings count. Drafts and archived ones do not use up quota.',
      legend:
        'Your plan includes {limit} plannings in use at a time (active, late or paused). Drafts and archived ones do not use up quota.',
      nearLimitWarning:
        'You have 1 planning left in your plan. Completed or archived ones free up quota.',
      limitModal: {
        title: 'Planning limit reached',
        description:
          'Your Professional plan includes up to {limit} plannings in use at a time (active, late or paused). Drafts and archived ones do not use up quota.',
        feature1: 'Unlimited plannings with the Enterprise plan',
        feature2: 'Cover your whole operation without freeing up quota each time',
        feature3: 'Your team keeps operating without interruptions',
        upgradeButton: 'Unlock unlimited plannings',
        continueButton: 'Stay on my current plan',
        upgradeIntercomMessage: 'Hi, I want to upgrade my plan to get unlimited plannings.',
      },
      landing: {
        title: 'Plan and track your operation',
        question: 'Why use Plannings?',
        intro: 'With this feature you can:',
        bullet1:
          'Group tasks under a safety, maintenance, audit or quality plan, with assignees and a defined period.',
        bullet2:
          'See each plan progress in real time, without chasing anyone or building spreadsheets.',
        bullet3: 'Spot late plannings in time, before they become a problem.',
        knowPlans: 'See the plans',
        contactSales: 'Talk to sales',
        availability: 'Available on the Professional and Enterprise plans.',
        contactSalesIntercomMessage:
          'Hi, I want to know more about Plannings and the plans that include it.',
        demoTitle: 'How it works in your operation',
        demoMobileTitle: 'Your team executes from the mobile app',
        demoMobileBody:
          'Each plan task reaches the field team app. Every response updates the plan progress automatically.',
        demoWebTitle: 'You track progress from the web',
        demoWebBody:
          'The plannings view shows progress, assignees and the status of each plan in real time. Late ones are flagged automatically.',
        previous: 'Previous',
        next: 'Next',
        webImageAlt: 'Plannings view on the web',
        mobileTasksAlt: 'Plan tasks in the mobile app',
        mobileDoneAlt: 'Completed plan in the mobile app',
      },
    },
    createMenu: {
      planning: 'Create planning',
      planningType: 'Create template',
    },
    stateTabs: {
      all: 'All',
      active: 'Active',
      completed: 'Completed',
      archived: 'Archived',
      late: 'Overdue',
      draft: 'Drafts',
      paused: 'Paused',
    },
    filterChips: {
      date: 'Date',
      datePopover: 'Select date range',
      location: 'Location',
      locationPopover: 'Filter by location',
      supervisor: 'Supervisor',
      supervisorPopover: 'Filter by supervisor',
      planningType: 'Type',
      planningTypePopover: 'Filter by type',
      planningTypeSearch: 'Search type',
      asset: 'Asset',
      assetPopover: 'Filter by asset',
      assetSearch: 'Search asset',
      empty: 'No results',
      allTab: 'All',
      groupTab: 'Groups',
    },
    columns: {
      code: 'ID',
      name: 'Planning',
      asset: 'Asset',
      period: 'Period',
      progress: 'Progress',
      state: 'Status',
      supervisor: 'Supervisor',
      planningType: 'Template',
    },
    assetsView: {
      viewLabel: 'View:',
      toggleGeneral: 'General',
      toggleAssets: 'Assets',
      activePlanningOne: '1 active planning',
      activePlanningOther: '{count} active plannings',
      next: 'Next:',
      nextPlanning: 'Next planning:',
      nextPlanningToday: 'Today',
      nextPlanningInDaysOne: 'In 1 day',
      nextPlanningInDaysOther: 'In {days} days',
      unassignedPlanning: 'Planning without an asset',
      temporalCycleType: 'Temporal',
      columns: {
        type: 'Type',
        id: 'ID',
        projectedDate: 'Projected date',
        executionDate: 'Execution date',
        completion: 'Completion',
        state: 'Status',
      },
      cycleStates: {
        completed: 'Completed',
        pending: 'Scheduled',
        in_progress: 'In progress',
        draft: 'Draft',
        active: 'Active',
        paused: 'Paused',
        late: 'Late',
        archived: 'Archived',
      },
    },
    timeline: {
      toggleTable: 'Table',
      toggleTimeline: 'Timeline',
      today: 'Today',
      emptyState: {
        title: 'You have no plannings available',
        hint: 'Create one or adjust the filters',
      },
      loadError: {
        title: 'We could not load the timeline',
        hint: 'Something went wrong. Please try again.',
      },
      tooltip: {
        stateScheduled: 'Status: Scheduled',
        stateInProgress: 'Status: In progress',
        stateCompleted: 'Status: Completed',
        stateCompletedLate: 'Status: Completed late',
        stateOverdue: 'Status: Overdue',
        statePaused: 'Status: Paused',
        statePausedMeterInactive: 'No meter activity',
        statePausedAssetDeactivated: 'Asset deactivated',
        pendingTasksOne: '1 pending task',
        pendingTasksOther: '{count} pending tasks',
        windowLabel: 'Window',
        realizedLabel: 'Completed',
      },
      enterprise: {
        badge: 'Enterprise feature',
        title: 'View your whole monthly plan in a single screen',
        description:
          'Leave scattered spreadsheets behind and keep your whole maintenance plan organized in one view.',
        bullet1: 'See every maintenance job for the month in a single view.',
        bullet2: 'Spot delays and overlapping maintenance before they affect operations.',
        bullet3: 'Share the plan with your team as a PDF.',
        cta: 'Upgrade plan',
      },
      export: {
        pdf: 'PDF',
        excel: 'Excel',
        generating: 'Generating timeline PDF...',
        ready: 'Your file is ready. The download will start in a few seconds.',
        failed: 'We could not generate the file. Please try again.',
        noResultsToExport: 'No results to export',
      },
      drawer: {
        openPlanning: 'Open planning',
        close: 'Close',
      },
      rowsHeaderGeneral: 'Plannings',
      rowsHeaderActivos: 'Assets',
      legend: {
        temporal: 'Temporal',
      },
      print: {
        title: 'Plannings schedule',
        assetTypesLabel: 'Asset type',
        locationsLabel: 'Location',
        joinTwo: '{first} and {second}',
        andMore: '{first} and {count} more',
        pageFooterLabel: 'Page',
      },
    },
    editedIndicator: 'Edited',
    rowActions: {
      detail: 'View detail',
      edit: 'Edit',
      continueEditing: 'Continue editing',
      pause: 'Pause',
      resume: 'Resume',
      archive: 'Archive',
      unarchive: 'Unarchive',
      delete: 'Delete',
    },
    editPublished: {
      title: 'Edit planning',
      back: 'Back to Plannings',
      backLink: 'Back',
      nameLabel: 'Name',
      save: 'Save changes',
      cancel: 'Cancel',
      next: 'Next',
      stepBack: 'Back',
      confirmTitle: 'Edit planning',
      appliesNow: 'The name and supervisors are updated immediately.',
      appliesNextCycle: 'Frequency and the task template apply from the next cycle.',
      step1AlertTemporal:
        'When you save, the name and supervisors are updated immediately. Frequency and end date apply from the next cycle.',
      step1AlertTemporalNoFreq:
        'When you save, the name and supervisors are updated immediately. Frequency and end date cannot be changed for this planning type.',
      step1AlertMeter:
        'When you save, the name and supervisors are updated immediately. The prediction engine will recalculate automatically with the new configuration.',
      step2Alert:
        'Task changes apply from the next cycle. To add or remove responsibles for the current cycle, do it from the planning detail.',
      step2AlertShared:
        'Responsibles are edited once in the list and the change applies to every task: adding a person applies from now; removing them takes effect from the next cycle and does not erase completed work.',
      tasksSectionTitle: 'Planning tasks',
      lockedTypeTooltip: 'The planning type cannot be changed once published.',
      lockedStartDateTooltip: 'The start date cannot be changed once the planning is published.',
      lockedAssetTooltip: 'The asset cannot be changed once the planning is published.',
      lockedEntryPointTooltip:
        'The declared last maintenance is set at creation and cannot change once published.',
      confirmSupervisorsImmediate:
        'Supervisor changes apply immediately, including the cycle currently in progress.',
      confirmScheduleNextCycle:
        'Changes to frequency and end date apply from the next cycle of the planning.',
      confirmMeterImmediate: 'Changes to the name and supervisors apply immediately.',
      confirmMeterEngineNextRecalc:
        'Changes to the prediction engine configuration are considered from the next recalculation of the planning.',
      confirmMeterImmediateAndEngine:
        'Supervisor changes apply immediately. Changes to the prediction engine configuration are considered when computing upcoming plannings, from the next recalculation.',
      responsibles: {
        title: 'Task responsibles',
        subtitle: 'Set once and applied to every task of this planning.',
        empty: 'No responsibles. The planning stops generating tasks until someone is added.',
        add: 'Add responsible',
        addLink: 'Add responsibles',
        groupSuffix: 'group',
        groupsNote:
          'One group is chosen. The task is assigned to the group (one response per group); it is not mixed with individual users.',
        removeTitle: 'Remove responsible',
        removeExplanation: 'Stops receiving tasks from the next cycle. Completed work is kept.',
        cancelOpenTasks: 'Also cancel their pending tasks in the current cycle',
        remove: 'Remove',
        confirmNameSupervisorsImmediate: 'Changes to the name and supervisors apply immediately.',
        confirmFrequencyNextCycle: 'Frequency changes apply from the next cycle.',
        addedNote:
          '{names} added. It applies from now to every task of this planning, in the current cycle and upcoming ones.',
        removedNote:
          '{names} will stop receiving tasks from this planning starting next cycle. Already completed tasks are not affected.',
        cancelPendingLabel: 'Also cancel the pending tasks of this cycle',
        cancelPendingHint: 'Tasks will be marked as Cancelled and kept in the history.',
      },
    },
    toasts: {
      archived: '"{name}" archived',
      unarchived: '"{name}" is active again',
      deleted: 'Planning deleted',
      savedChanges: 'Changes saved',
      error: 'The action could not be completed.',
    },
    states: {
      all: 'All',
      draft: 'Draft',
      active: 'Active',
      paused: 'Paused',
      late: 'Late',
      archived: 'Archived',
    },
    counts: {
      total: 'Total plannings',
      active: 'Active',
      paused: 'Paused',
      late: 'Late',
      archived: 'Archived',
      draft: 'Drafts',
    },
    frequencies: {
      daily: 'Daily',
      weekly: 'Weekly',
      biweekly: 'Biweekly',
      monthly: 'Monthly',
      quarterly: 'Quarterly',
      semiannual: 'Semiannual',
    },
    cycleWord: {
      daily: 'Day',
      weekly: 'Week',
      biweekly: 'Cycle',
      monthly: 'Month',
      quarterly: 'Quarter',
      semiannual: 'Semester',
    },
    pagination: {
      results: 'Results',
      previous: 'Previous',
      next: 'Next',
    },
    empty: {
      title: 'No plannings yet',
      hint: 'Create your first planning or adjust the filters.',
    },
    filters: {
      state: 'Status',
      asset: 'Asset',
      planningType: 'Template',
      supervisor: 'Supervisor',
      dateFrom: 'From',
      dateTo: 'To',
      anyType: 'Any template',
      anyAsset: 'Any asset',
    },
    error: {
      loadList: 'Could not load plannings',
      createPlanning: 'Could not create the planning',
      createTaskAssign: 'Could not create the task',
      publish: 'Could not publish the planning',
    },
    wizard: {
      title: 'Create planning',
      cancel: 'Cancel',
      back: 'Back',
      next: 'Next',
      saveDraft: 'Save draft',
      publish: 'Create',
      details: {
        planningType: 'Template',
        planningTypeStandalone: 'Standard planning (No preset)',
        name: 'Planning name',
        namePlaceholder: 'Write the name',
        startDate: 'Start date',
        startDatePlaceholder: 'Select the date',
        frequency: 'Planning frequency',
        ends: 'Ends:',
        endsNever: 'Never',
        endsDate: 'Date:',
        endsDatePlaceholder: 'DD/MM/YYYY',
        endsMaxReps: 'After:',
        endsMaxRepsUnit: 'repetitions',
        supervisor: 'Supervisor',
        supervisorPlaceholder: 'Select supervisors',
        asset: 'Asset',
        assetRequired: 'This type requires an asset',
        location: 'Location',
        locationPlaceholder: 'Select a location',
      },
      meter: {
        strategyPreviewTitle: 'Strategy preview',
        cumulativeLabel: 'Use cumulative scheduling',
        asset: 'Asset',
        assetPlaceholder: 'Select an asset',
        planningConfigTitle: 'Planning configuration',
        predictionConfigTitle: 'Prediction engine configuration',
        predictionSubtitle: "Assignees are notified when each planning's execution window opens",
        assetMeterHelper: 'You will only see assets that have an associated meter',
        noAssetsForMeter: 'There are no assets with {meter} configured.',
        configureAssets: 'Configure assets',
        locationLabel: 'Location',
        locationFromAsset: 'Filled from the asset',
        predictionTitle: 'Prediction engine',
        modeAutomatic: 'Automatic calculation',
        modeAutomaticDesc: 'Uses the meter reading history to project the dates',
        modeAutomaticDisabledDesc:
          'This asset does not have enough hour-meter readings to calculate the average automatically.',
        modeManual: 'Enter average manually',
        modeManualDesc: 'You set the daily usage average',
        calculationWindowLabel: 'Calculation range',
        calculationWindowSuffix: 'months back',
        perDay: '{unit}/day',
        manualDailyAverageLabel: 'Usage average',
        currentValueLabel: 'Current reading',
        rateLine:
          'Rate: {rate} {unit}/day, based on {reading_count} readings over the last {effective_window_months} months',
        projectionTitle: 'Next plannings projection',
        projectedDateLabel: 'Projected date',
        entryTitle: 'Last executed maintenance',
        entrySubtitle:
          'Optional. Declare where the asset is coming from so the cycle starts there instead of assuming everything before it was done.',
        entryClear: 'Clear',
        entryMilestoneLabel: 'Executed milestone',
        entryMilestonePlaceholder: 'Select a milestone',
        entryMilestoneHint: 'Pick the asset first to see the available milestones.',
        entryReadingLabel: 'Reading when executed',
        entryLockedSubtitle: 'Declared at creation and frozen once published.',
        entryRejectedByServer: 'The server rejected this declaration. Pick the milestone again.',
        entryRejectedByServerReading: 'The server rejected this declaration. Check the reading.',
        entryReadingOutOfRange: 'Must be between {min} and {max} for this milestone.',
        entryAboveCurrentNote:
          'The declared reading is above the current meter reading ({current}). That is accepted: it usually means the recorded reading is behind.',
        entryDueCount: 'The asset enters with {count} maintenances still to be carried out: {list}.',
        entryDueCountOne: 'The asset enters with 1 maintenance still to be carried out: {list}.',
        entryNoneDue: 'The asset enters up to date: the meter passed no maintenance left undone.',
        entryNotDeclaredHint:
          'With no last maintenance declared, everything before {value} is assumed done.',
        recalcNote:
          'Dates and windows are recalculated automatically based on recent meter activity.',
        clampWarning:
          'The requested range exceeds the asset available history. The readings recorded between {start} and {end} will be used.',
        emptyState: 'Not enough data; enter a manual average',
        windowTooNarrow: 'There are not enough readings in the selected range. Widen the calculation window.',
        manualPending:
          'These projections will adjust automatically once there is enough real meter data.',
        errorState: 'The projection could not be computed.',
        retry: 'Retry',
        levelEvery: 'Every {interval} {unit}',
        ownCount: '{count} tasks on this level',
        inheritedCount: '{count} inherited',
        inheritedSuffix: ' (Inherited)',
        inheritedFrom: '(Inherited from {code})',
        editForLevel: 'Edit task only for {code}',
        createTask: 'Create task',
        taskCreated: 'Task created',
        estimatedDate: 'Estimated task date',
        estimatedStart: 'Estimated start',
        estimatedEnd: 'Estimated end',
        basedOnTitle: 'Based on:',
        basedOnAverage: 'Meter average usage',
        basedOnHistory: 'Asset history',
        basedOnStrategy: 'Planning megacycle strategy',
        estimatedDatePending: 'No estimated date available',
        readOnlyTitle: 'Estimated date',
        readOnlySubtitle: 'Dates are computed from the meter projection and are not editable.',
        levelsEmpty: 'Select a strategy to see its levels',
        emptyLevel: 'This level has no forms associated',
      },
      tasks: {
        introStandalone:
          'To create this planning, you must assign forms and create tasks with them',
        introPreset: 'To create this planning, assign the following forms as tasks',
        addForm: 'Add form',
        createTask: 'Create task',
        taskCreated: 'Task created',
        editTask: 'Edit task',
        editTaskOf: 'Edit task for:',
        nextCycle: 'Next cycle:',
        dateSeparator: 'to',
        dateSeparatorSameDay: 'to',
        notifySuccess: 'Notification sent',
        loadingPlanning: 'Creating planning…',
        removeForm: 'Remove form',
        emptyTypeTitle: 'This template has no forms assigned yet',
        emptyTypeLink: 'Assign forms to the type',
        sharedResponsiblesRequired: 'Add responsibles first. Tasks inherit that list.',
        sharedResponsiblesSaving: 'Saving responsibles…',
      },
      taskDialog: {
        title: 'Create task',
        mobileUser: 'Assignee',
        location: 'Location',
        cycleDay: 'Day of cycle',
        durationHours: 'Duration (hours)',
        description: 'Description',
        scheduledSendDaysBefore: 'Schedule send (days before)',
        submit: 'Save task',
        cancel: 'Cancel',
      },
      validation: {
        required: 'Required',
        invalid: 'Invalid value',
        endDateRequired: 'The end date is required.',
        publishMismatch: 'Missing or extra tasks for the closed form set.',
        publishMissingForms: 'Add at least one form before publishing.',
        publishGeneric: 'Could not publish the planning.',
        formSyncError: "We couldn't save the form changes. Please try again.",
        publishNoAccess: 'Your plan does not include Plannings. See the plans that include it.',
      },
    },
    detail: {
      back: 'Back to Plannings',
      actionsMenu: 'More actions',
      history: {
        title: 'Change history',
        close: 'Close',
        empty: 'No changes recorded.',
        addedResponsible: 'Added',
        removedResponsible: 'Removed',
        updatedResponsibles: 'Updated responsibles',
        effect: {
          immediate: 'Applies immediately',
          next_cycle: 'Applies from the next cycle',
          next_recalc: 'Applies on the next recalculation',
        },
        fields: {
          name: 'Name',
          frequency: 'Frequency',
          ends: 'Ending',
          end_date: 'End date',
          max_reps: 'Repetitions',
          supervisors: 'Supervisors',
          cumulative: 'Cumulative schedule',
          manual_daily_average: 'Manual daily average',
          calculation_window_months: 'Calculation window',
          prediction_mode: 'Prediction mode',
        },
        endsValues: {
          never: 'Never',
          end_date: 'On a date',
          max_reps: 'After N repetitions',
        },
      },
      meter: {
        nextPlanning: 'Next planning',
        available: 'available',
        overdue: 'overdue',
        remaining: 'Remaining',
        daysRemaining: '~{days} days',
        cumulative: 'Cumulative schedule',
        closed: 'Fixed schedule',
        currentReading: 'Current reading',
        currentReadingDynamic: 'Current {meter}',
        lastCompletedLabel: 'Last completed cycle',
        lastCompletedAt: 'Executed at {value}',
        lastReading: 'Last reading: {when}',
        projectedDate: 'Projected date',
        lastRecalc: 'Last recalculated: {when}',
        usageRate: 'Usage rate',
        ratePerDay: '{value}/day',
        rateWindow: 'average of last {months} months',
        rateManual: 'manual rate',
        noRate: 'No rate available',
        responsibles: 'Supervisors',
        asset: 'Asset',
        strategyTitle: 'Strategy {name} - {total}',
        tasksCount: '{count} tasks',
        tasksCountOne: '1 task',
        projectionTitle: 'Planning projection',
        columns: {
          id: 'ID',
          type: 'Type',
          reading: 'Reading',
          date: 'Date',
          projectedDate: 'Projected date',
          tasks: 'Tasks',
          participants: 'Participants',
          state: 'Status',
          milestone: 'Period',
        },
        tasksInherited: '{count} tasks + {inherited} inherited',
        tasksOnly: '{count} tasks',
        inheritedFrom: 'Inherited from {code}',
        status: {
          pending: 'Pending',
          in_progress: 'In progress',
          completed: 'Completed',
        },
        noEstimate: 'No estimated date',
        notAvailable: 'Not available',
        pausedChip: 'Paused',
        assetDeactivated: 'Deactivated',
        assetInactive: 'No activity for {days} days',
        pausedBannerAssetDeactivated:
          'The planning projection is paused until the asset is reactivated',
        pausedBannerMeterInactive:
          'The planning projection is paused until the asset records activity again.',
        pausedBannerManual: 'The planning projection is paused.',
        projectedDateTooltip: 'Last projected date before the planning was paused',
        emptyMilestones: 'No projection available',
        unassignedTask: 'Unassigned',
        inheritedSuffix: ' (Inherited)',
        configTitle: 'Projection settings',
        windowLabel: 'Calculation window',
        windowHelp: 'Historical readings used to compute the usage rate',
        windowValue: '{months} months',
        rateLabel: 'Usage rate',
        rateHelp: "Equipment's daily average usage",
        lastUpdate: 'Last updated: {when}',
        recalcAuto: '(automatic recalculation)',
        readingsTitle: 'Recent meter readings',
        readingsColumns: {
          date: 'Date',
          origin: 'Source',
          value: 'Value',
        },
        viewAll: 'View full history',
        emptyReadings: 'No readings recorded',
        today: 'Today',
        yesterday: 'Yesterday',
      },
      cycleNav: 'Cycle',
      sectionInfo: 'Planning information',
      sectionTasks: 'Plan tasks',
      updatedAgo: 'Updated {when} ago',
      newTask: 'New task',
      searchTasks: 'Search by form name',
      emptyTasks: 'No tasks available',
      tasksCompleted: '{completed}/{total} tasks completed',
      planCompleted: 'Congratulations! Your team has completed every task successfully',
      cycleLabel: {
        daily: 'Day',
        weekly: 'Week',
        biweekly: 'Biweek',
        monthly: 'Month',
        quarterly: 'Quarter',
        semiannual: 'Semester',
      },
      cycleList: {
        searchPlaceholder: 'Search by date or period',
        goToCurrent: 'Go to current period',
        empty: 'No cycles to show',
        noResults: 'No results',
      },
      columns: {
        id: 'ID',
        form: 'Form',
        user: 'User',
        userAndGroups: 'Users and groups',
        startDate: 'Start date',
        state: 'State',
        responses: 'Responses',
        actions: 'Actions',
        duration: 'Duration: {value}',
      },
      responses: '{count}/{total} responded',
      userFilter: {
        title: 'Users',
        popover: 'Filter by user',
        empty: 'No users',
      },
      tabs: {
        all: 'All',
        pending: 'Assigned',
        accepted: 'Accepted',
        completed: 'Completed',
        incomplete: 'Incomplete',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
      },
      taskStatus: {
        sent: 'Assigned',
        pending: 'Assigned',
        in_progress: 'Accepted',
        accepted: 'Accepted',
        completed: 'Completed',
        rejected: 'Rejected',
        incomplete: 'Incomplete',
        cancelled: 'Cancelled',
        scheduled: 'Scheduled',
        deleted: 'Deleted',
      },
      rowActions: {
        menuLabel: 'Task actions',
        detail: 'Edit',
        viewAnswer: 'View response',
        reassign: 'Reassign task',
        notify: 'Notify',
        cancel: 'Cancel',
        delete: 'Delete',
      },
      cancel: {
        title: 'Cancel task',
        subtitle: 'This action is irreversible. Provide a reason for the cancellation.',
        reason: 'Reason',
        reasonPlaceholder: 'Write the reason here…',
        confirm: 'Cancel task',
        keep: 'Back',
        errorAlreadyCompleted: 'You cannot cancel a completed task.',
        errorAlreadyCancelled: 'This task was already cancelled.',
        errorMissingReason: 'A reason is required.',
        errorGeneric: 'Could not cancel the task.',
      },
      reassign: {
        title: 'Reassign task',
        subtitle: 'Pick a new assignee.',
        confirm: 'Reassign',
        groupLabel: 'Group',
        errorGeneric: 'Could not reassign the task.',
        selectResponsible: 'Select assignee',
        selectPlaceholder: 'Select an assignee',
        search: 'Search',
        bannerText:
          'This change applies only to this cycle of the task. Upcoming cycles will stay assigned to',
        rowTooltipLead: 'Assignee changed for this cycle.',
        rowTooltipOriginal: 'Original: {name}',
      },
      pause: {
        title: 'Pause planning',
        body: 'Current cycle tasks stay visible. No new cycles will be created until you resume.',
        confirm: 'Pause',
      },
      resume: {
        title: 'Resume planning',
        body: 'The planning becomes active again. The end date will be extended by the paused days.',
        confirm: 'Resume',
      },
      archive: {
        title: 'Archive planning',
        body: 'The planning moves to Archived and its pending tasks freeze. You can unarchive it anytime.',
        confirm: 'Archive',
      },
      delete: {
        title: 'Delete planning',
        body: 'You are about to remove "{name}" from your view. This action is irreversible: its data is kept in the system, but you will not be able to restore it from here.',
        confirm: 'Delete',
      },
      lifecycleErrors: {
        not_in_draft: 'This planning has already been published.',
        missing_forms: 'Add at least one form before publishing.',
        forms_mismatch: 'Cycle 0 does not cover exactly the required forms.',
        already_paused: 'This planning is already paused.',
        not_paused: 'Only paused plannings can be resumed.',
        already_archived: 'This planning has already been archived.',
        not_archived: 'Only archived plannings can be unarchived.',
        rule_completed:
          'Cannot unarchive: the planning schedule is already complete. Extend the schedule before unarchiving.',
        generic: 'Could not complete the action.',
      },
    },
    importDrawer: {
      title: 'Import plannings',
      close: 'Close',
      step1: {
        title: 'Step 1: Download the file',
        description:
          'Download the sample file. It will contain one sheet to configure plannings and another sheet to configure their tasks. Make sure to fill the fields marked with * to import correctly.',
        download: 'Download template',
      },
      step2: {
        title: 'Step 2: Edit the file',
        description: 'Fill Sheet 1 (Plannings) and Sheet 2 (Tasks) following the format.',
      },
      step3: {
        title: 'Step 3: Upload the file',
        dropZone: 'Drag and drop your file here or select it from your computer.',
        browse: 'Select file',
        upload: 'Upload',
      },
      result: {
        title: 'Import result',
        plannings_created: 'Plannings created',
        plannings_published: 'Plannings published',
        tasks_created: 'Tasks created',
        failed: 'Failed',
        skipped: 'Skipped',
        back: 'Try again',
        errors: 'Errors',
        details: 'Skipped and warnings',
        sheet: 'Sheet',
        row: 'Row',
        message: 'Message',
        statuses: {
          pending: 'Pending',
          processing: 'Processing',
          completed: 'Completed',
          failed: 'Failed',
        },
        entryStatuses: {
          skipped: 'Skipped',
          warning: 'Warning',
        },
        sheets: {
          plannings: 'Plannings',
          tasks: 'Tasks',
        },
        errors_global: {
          file_unreadable:
            "We couldn't read the file. Make sure it's a valid Excel (.xlsx) created from the template.",
          missing_tasks_sheet:
            'The "Tasks" sheet is missing from the file. Download the template and use it as a base.',
          s3_download_failed: 'The file could not be retrieved. Please upload it again.',
          unknown_error:
            'An unexpected error occurred during the import. If it persists, contact support.',
        },
        draftsCreatedWarningOne:
          '{count} planning was created as a draft before the import failed. You can review and publish it manually from the list, or delete it.',
        draftsCreatedWarningOther:
          '{count} plannings were created as drafts before the import failed. You can review and publish them manually from the list, or delete them.',
      },
      errors: {
        upload: 'Could not upload the file.',
        emptyFile: 'Select a file first.',
      },
    },
    types: {
      title: 'Templates',
      back: 'Back to plannings',
      createType: 'Create template',
      editAction: 'Edit',
      deleteAction: 'Delete',
      deleteConfirm: 'Delete this template?',
      defaultBadge: 'Default',
      genericName: 'Generic planning (Not customized)',
      form: {
        createTitle: 'Create template',
        editTitle: 'Edit template',
        subtitle: 'Define the information that will be preset when creating a planning',
        formsTitle: 'Forms',
        formsSubtitle: 'Define what must be executed in this planning',
        addForms: 'Add forms',
        iconLabel: 'Icon',
        iconsLabel: 'Icons',
        colorsLabel: 'Colors',
        name: 'Name',
        namePlaceholder: 'Type the name',
        prefix: 'ID prefix',
        prefixHelper:
          'Define a prefix to easily identify plannings of this type. It will be prepended to the ID (e.g. PLAN-1)',
        prefixExample: 'Plannings of this type will be numbered as {prefix}-1',
        supervisor: 'Supervisor',
        supervisorPlaceholder: 'Select supervisors',
        frequency: 'Planning frequency',
        allowFrequencyOverride: 'Allow overriding frequency when creating a planning',
        allowFrequencyOverrideHelp:
          'When enabled, users can change the frequency while creating a planning of this type.',
        assetRequired: 'Requires an asset to create a planning',
        assetRequiredHelp:
          'When enabled, an asset must be selected when creating a planning of this type.',
        allowEdit: 'Allow editing the planning after creation',
        allowEditHelp:
          'Lets you update the configuration of plannings created from this type. Changes only apply to upcoming runs and do not affect cycles already in progress.',
        sharedResponsibles: 'Same responsibles for every task',
        sharedResponsiblesHelp:
          'Tasks of plannings of this type share a single responsibles list: it is set once when creating the planning and editing it applies to every task. Adding a person applies from now; removing one takes effect next cycle and keeps what is already done.',
        cancel: 'Cancel',
        create: 'Create',
        save: 'Save',
        meter: {
          cycleCardTitle: 'Cycle configuration',
          cycleCardSubtitle: 'Define how each planning cycle is triggered',
          cycleTemporalTitle: 'Temporal',
          cycleTemporalDesc: 'The cycle is scheduled by calendar or every X days',
          cycleMeterTitle: 'Meter (Requires asset)',
          cycleMeterDesc: 'The cycle is scheduled when the meter reaches a defined value',
          meterLabel: 'Meter',
          meterPlaceholder: 'Select a meter',
          meterHelper:
            'You will only be able to associate assets with this meter configured when creating the planning',
          strategyLabel: 'Planning strategy',
          strategyPlaceholder: 'Select a strategy',
          previewTitle: 'Strategy preview',
          inactivityPause: {
            title: 'Enable automatic pause on inactivity',
            subtitle:
              'Pauses the planning when the meter records no new readings and resumes it automatically when they resume.',
            checkboxLabel: 'Automatically pause on equipment inactivity',
            tooltip:
              'If no new readings are recorded during the configured period, the planning pauses automatically. The supervisor receives an email notification and the planning resumes when readings resume.',
            daysPrefix: 'After',
            daysSuffix: 'days without readings',
          },
          strategyEditor: {
            createStrategy: '+ Create strategy',
            title: 'Create planning strategy',
            nameLabel: 'Strategy name',
            namePlaceholder: 'e.g. Strategy 200/600 hours',
            levelsTitle: 'Planning levels',
            codeLabel: 'Name',
            codePlaceholder: 'e.g. Inspection',
            intervalLabel: 'Threshold',
            intervalPlaceholder: 'e.g. 200',
            addLevel: 'Add level',
            removeLevel: 'Remove level',
            deleteStrategy: 'Delete strategy',
            save: 'Create',
            cancel: 'Close',
            createSuccess: 'Strategy created',
            createError: 'We could not create the strategy. Please try again.',
            deleteError: 'We could not delete the strategy. It may be in use by a planning type.',
            validation: {
              nameRequired: 'Enter a name for the strategy.',
              atLeastOne: 'Add at least one level.',
              codeRequired: 'Each level needs a name.',
              positive: 'The threshold must be greater than 0.',
              ascending: 'Thresholds must be strictly ascending.',
              unique: 'Thresholds cannot repeat.',
            },
          },
          previewEmpty: 'Select a strategy to see the megacycle',
          executionWindowTitle: 'Execution window',
          executionWindowSubtitle:
            'Define when the planning tasks will be assigned and how long they will be available.',
          windowStartLabel: 'Planning start:',
          windowStartOptions: {
            one_day_before: '1 day before',
            three_days_before: '3 days before',
            one_week_before: '1 week before',
            fifteen_days_before: '15 days before',
            on_projected_date: 'On the projected date',
          },
          durationValueLabel: 'Available duration',
          durationUnits: { days: 'Days', weeks: 'Weeks' },
          executionSummary:
            'Tasks will be assigned {startLabel} of the projected date and will be available for {value} {unit}.',
          executionSummaryOnDate:
            'Tasks will be assigned on the projected date and will be available for {value} {unit}.',
          accumulateLabel: 'Accumulate tasks between levels',
          accumulateTooltip:
            'Each level automatically includes the tasks of the previous levels. (A level 3 will include the tasks of levels 1 and 2)',
          levelEvery: 'Every {interval} {unit}',
          ownCount: 'Tasks of this level: {count}',
          inheritedCount: 'Inherited tasks: {count}',
          inheritedSuffix: ' (Inherited)',
          addFormToLevel: 'Add form',
          levelsEmpty: 'Select a strategy to configure the levels',
          removeInheritedTitle: 'Remove inherited form',
          removeInheritedBody:
            'Removing an inherited form is a template-level change and will affect future plannings. Do you want to continue?',
          removeInheritedCancel: 'Cancel',
          removeInheritedConfirm: 'Remove',
        },
      },
      errors: {
        prefixTaken: 'This prefix is already in use by another template.',
        deleteHasPlannings: 'You cannot delete a type that has live plannings.',
        deleteLastType: 'You cannot delete the last template.',
        generic: 'Could not save the type.',
      },
    },
  },
  task_assigner: {
    planning_task_tooltip: 'Part of: {planning}',
    pricing: {
      landing: {
        availability: 'Available on Professional and Enterprise',
        title: 'Assign tasks to your team and track their progress',
        intro:
          'Coordinate your team\'s work, monitor progress and stay on top of every task from DataScope.',
        bullet1: 'Assign tasks to people or groups.',
        bullet2: 'Track progress and due dates from DataScope.',
        bullet3: 'Export results and keep a compliance trail.',
        knowPlans: 'See the plans',
        contactSales: 'Talk to sales',
        contactSalesIntercomMessage:
          'Hi, I want to know more about Assigned tasks and the plans that include it.',
        demoTitle: 'What can you do with Assigned tasks?',
        demoWebTitle: 'Assign tasks and monitor their status',
        demoWebBody:
          'Create tasks for people or groups and check their progress from one place. See pending, overdue and completed tasks with metrics updated in real time.',
        demoAppTitle: 'Everyone gets their tasks in the app',
        demoAppBody:
          'Tasks reach each assignee\'s app directly. They can be completed in the field, with or without connection, and every response is logged for tracking.',
        previous: 'Previous',
        next: 'Next',
        illustrationAlt: 'Assigned tasks illustration',
        webImageAlt: 'Task assignment view on the web',
        appImageAlt: 'Assigned tasks in the mobile app',
      },
    },
    planningSection: {
      title: 'Date and time',
      subtitle: 'Set when in the cycle the task runs and how long it stays available',
      cycleDayField: 'Day and time of execution in the cycle',
      hourField: 'Hour of execution',
      timeField: 'Start time',
      ofDays: 'Of {total} days',
      ofHours: 'Of {total} hours',
      durationField: 'Available duration',
      day: 'day',
      hour: 'hour',
      units: { hours: 'Hours', days: 'Days' },
      infoBanner:
        'The task will be available on {cycleWord} {cycleDay} of the cycle and will stay open for {duration} {unit}',
      currentCycle: 'Cycle {cycle}: Available from {from} to {to}',
      nextCycle: 'Cycle {cycle}: Will be rescheduled from {from} to {to}',
      allowLate: 'Allow answers after the due date',
      scheduleTitle: 'Schedule task delivery',
      scheduleSubtitle: 'Set how many days before the start the task is sent to the assignee',
      scheduleOptions: {
        start: 'At task start',
        oneDay: '1 day before',
        threeDays: '3 days before',
        oneWeek: '1 week before',
      },
    },
    only_once: 'Only once',
    working_days: 'Working days',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    custom: 'Custom',
    task_frequency: 'Task frequency',
    task_frequency_info: 'The task frequency option is available only when assigning a single date',
    assigned: 'Assigned',
    completed: 'Completed',
    pending: 'Accepted',
    incomplete: 'Incomplete',
    states: {
      completed: 'Completed',
      inProgress: 'Accepted',
      pending: 'Pending',
      incomplete: 'Incomplete',
      rejected: 'Rejected',
      scheduled: 'Scheduled',
      sent: 'Assigned',
      cancelled: 'Cancelled',
      deleted: 'Deleted',
      projected: 'Projected',
    },
    cards: {
      totalTasks: 'Total tasks',
      completed: 'Completed',
      pending: 'Accepted',
      incomplete: 'Incomplete',
      rejected: 'Rejected',
      scheduled: 'Scheduled',
      sent: 'Assigned',
    },
    your_assigned_tasks: 'Your assigned tasks',
    filtersTitle: 'Filters',
    filters: {
      clearFilters: 'Clear filters',
      dateRange: {
        title: 'Date',
        popoverTitle: 'Filter by execution date',
      },
      location: {
        title: 'Location',
        popoverTitle: 'Filter by location',
        noLocations: 'No locations found',
      },
      form: {
        title: 'Form',
        popoverTitle: 'Filter by forms',
        inactive: 'Inactive',
        deleted: 'Deleted',
        forms: 'Forms',
        folders: 'Folders',
        noForms: 'No forms found',
      },
      status: {
        title: 'Status',
        popoverTitle: 'Filter by status',
      },
      user: {
        title: 'Users',
        popoverTitle: 'Filter by users',
        noUsers: 'No users found',
        noGroups: 'No groups found',
        deactivated: 'Deactivated',
        allTab: 'Users',
        groupTab: 'Groups',
      },
      taskId: {
        title: 'Task ID',
        popoverTitle: 'Filter by task ID',
        label: 'Task ID',
        placeholder: 'Enter the ID',
      },
      origin: {
        title: 'Origin',
        popoverTitle: 'Filter by origin',
        individual: 'Individual',
        planning: 'Planning',
        group: 'Group',
      },
    },
    searchBarPlaceholder: 'Search by form name...',
    new_task: 'New Task',
    edit_task: 'Edit Task',
    edit_group_task: 'Edit group task',
    createForm: {
      title: 'Create new task',
      usersField: {
        label: 'Users',
        editLabel: 'User',
        groupLabel: 'Group',
        addCta: '+ Add users',
        addCtaMore: '+ Add users',
        editAddCta: '+ Add user',
        sharedModeNotice: 'Responsibles are set at the planning level and apply to every task.',
        editResponsiblesLink: 'Edit responsibles',
      },
      usersDrawer: {
        title: 'Add users',
        searchPlaceholder: 'Search user or user group',
        allUsersLabel: 'Users',
        allGroupsLabel: 'User groups',
        noUsersFound: 'No users found',
        noGroupsFound: 'No groups found',
        groupMemberSingular: 'member',
        groupMembersPlural: 'members',
        alreadyAssignedTooltip: 'Already assigned to this form',
        close: 'Close',
        selectTypeDescription:
          'Choose how you want to assign this task. You can assign it to users or user groups.',
        usersCardTitle: 'Users',
        usersCardDescription: 'Select one or more users to assign the task',
        groupsCardTitle: 'User groups',
        groupsCardDescription: 'Select one or more groups to assign the task',
        selectedSingular: 'selected',
        selectedPlural: 'selected',
        usersBlockedTooltip: 'To assign users, remove the selected groups.',
        groupsBlockedTooltip: 'To assign groups, remove the selected users.',
        usersLockedTooltip: 'This planning assigns by group and cannot be changed to users.',
        groupsLockedTooltip: 'This planning assigns by users and cannot be changed to a group.',
        changeSelection: 'Change selection',
      },
      formsField: {
        label: 'Forms',
        editLabel: 'Form',
        addCta: '+ Select forms',
        addCtaMore: '+ Select forms',
        editAddCta: '+ Select form',
      },
      formsDrawer: {
        title: 'Forms',
        infoBanner:
          'If you select multiple forms, you will create multiple tasks with the selected ones',
        searchPlaceholder: 'Search form, folder...',
        tabs: {
          forms: 'Forms',
          folders: 'Folders',
        },
        noForms: 'No forms found',
        deleted: 'Deleted',
        inactive: 'Inactive',
        close: 'Close',
      },
      otherFields: {
        locationLabel: 'Location',
        locationPlaceholder: 'Select a location',
        assetLabel: 'Asset',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Write a task description',
      },
      subtasksField: {
        label: 'Tasks to do',
        placeholder: 'Write a task',
        addCta: '+ Add task',
        enterHelper: 'Press Enter to add another task',
        removeAriaLabel: 'Remove task',
      },
      infoContainer: {
        title: 'Task information',
        subtitle: 'Define the general task details, assignees and where it will be performed.',
      },
      scheduleContainer: {
        title: 'Date and time',
        subtitle: 'Define when the task will be performed and how long it will be available.',
        dateFieldLabel: 'Date and time',
        gapFieldLabel: 'Task duration in hours',
        gapPlaceholder: 'e.g. 24',
        lateResponseLabel: 'Allow response after the due date',
        duration: {
          prefix: 'Duration: ',
          year: 'year',
          years: 'years',
          month: 'month',
          months: 'months',
          week: 'week',
          weeks: 'weeks',
          day: 'day',
          days: 'days',
          hour: 'hour',
          hours: 'hours',
          minute: 'minute',
          minutes: 'minutes',
          and: 'and',
        },
      },
      participationContainer: {
        title: 'Participation',
        subtitle:
          'Indicate whether the task must be answered mandatorily or whether users can decide to perform it.',
        mandatoryTitle: 'Mandatory',
        mandatoryDescription: 'All users must respond to the task',
        voluntaryTitle: 'Voluntary',
        voluntaryDescription: 'All users can accept/reject the task',
        forOneTitle: 'Only one response per group',
        forOneDescription:
          'The first person to accept the task will complete it for the whole group',
      },
      remindersContainer: {
        title: 'Reminders',
        subtitle: 'Notifications will be sent automatically based on the task due date.',
        question: 'How long before the due date would you like to receive a reminder?',
        channelsLabel: 'Notification channel',
        disabledChipTooltip:
          'This option cannot be selected given the current task date and time configuration',
        timePresets: {
          min15: '15 min',
          min30: '30 min',
          hour1: '1 hour',
          day1: '1 day',
          day3: '3 days',
          week1: '1 week',
        },
        channels: {
          notification: 'In-app notification',
          email: 'Email',
        },
      },
    },
    tasks: 'Tasks',
    massive_search: 'Search by user, form or place ...',
    user: 'User',
    form: 'Form',
    place: 'Place',
    date: 'Date',
    date_and_time: 'Date and Time',
    gap: 'Gap',
    state: 'State',
    save: 'Save',
    users: 'Users',
    users_and_groups: 'Users and groups',
    description: 'Description',
    hour: 'Hour',
    alert: 'alert',
    delete: 'Delete',
    cancel: 'cancel',
    accept: 'agree',
    notify: 'Notify',
    view_group_detail: 'View group detail',
    view_group: 'View group',
    group_label: 'Group',
    notify_user: 'Do you want to notify to ',
    sure: 'Are you sure?',
    delete_task: 'You will delete a task',
    delete_tasks: 'Do you want to delete this tasks: ',
    reset: 'Reset',
    old_version: 'Old Version',
    task_created: 'Task Created',
    our_problem: 'We have problem',
    task_update: 'Task updated successfully',
    export: 'Export',
    date_necessary: 'A date is required',
    required: 'Required',
    blanck: 'There are empty fields',
    notification_sent: 'Notification sent successfully',
    notification_skipped: 'The task cannot be notified in its current state',
    notifications_sent: 'Notifications sent successfully',
    tasks_delete: 'Tasks deleted successfully. Please wait a few seconds for them to be reflected',
    task_delete: 'Task deleted successfully',
    new_place: 'New Place',
    start: 'Start',
    end: 'End',
    history: 'History',
    actions: 'Actions',
    dobleClick: 'Double click on task = open details',
    shiftMouse: 'shift + mousewheel = move timeline left/right',
    altMouse: 'alt + mousewheel = zoom in/out',
    timeline: 'Timeline',
    taskAssignID: 'Task assign ID',
    selected_range: 'Selected range',
    notifications: 'Add notifications',
    add_notification: 'Add a notification',
    seconds: 'seconds',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years',
    notification: 'Notification',
    email: 'Email',
    max_one_date: 'Maximum 1 date in edit mode',
    max_one_user: 'Maximum 1 user in edit mode',
    no_location_warning: 'A location has not been specified, or may have been erased.',
    showing_results_for: 'Showing results for',
    task: 'Task',
    no_tasks_available: 'No tasks available at this moment',
    gap_hours: 'Duration of tasks in hours',
    allow_late_submission: 'Allow the task to be answered after the due date has been reached',
    add_tasks: 'Add tasks',
    add_tasks_caption:
      'You can quickly add tasks by separating them with commas "," or pressing Enter',
    configuration: 'Configuration',
    voluntary_task: 'Make this task voluntary (All users can accept/reject the task)',
    mandatory_task: 'Make this task mandatory (All users must answer to the task)',
    notification_type: 'Notification type',
    notification_time: 'Time',
    notification_period: 'Time period',
    app_notification: 'App notification',
    confirmation_title_prefix: 'Are you sure you want to create ',
    confirmation_title_suffix: ' tasks?',
    confirmation_title_suffix_singular: ' task?',
    confirmation_title_suffix_one: 'tasks for',
    confirmation_title_suffix_one_singular: 'task for',
    confirmation_title_suffix_two: 'days?',
    edit_confirmation_title: 'Are you sure you want to edit this task?',
    success_message:
      'Tasks created successfully! Please wait a few seconds for them to be reflected. Remember to refresh the page to view them.',
    update_success_message: 'Task updated successfully!',
    forms_info:
      'If you select multiple forms, you will create multiple tasks with the selected ones.',
    asset: 'Asset',
    asset_autocomplete_hint: 'The assigned asset will be auto-filled in the form if applicable',
    filters_asset_title: 'Asset',
    edit: 'Edit',
    show_answer: 'Show answer',
    notify_title: 'Are you sure you want to notify the following user?',
    bulk_notify_title: 'Are you sure you want to notify the following users?',
    notify_group_title: 'Are you sure you want to notify the users of the following group?',
    edit_group_title: 'Are you sure you want to edit this task?',
    edit_group_description:
      'This task can only be edited for users that have not started it yet. Do you want to continue?',
    continue_action: 'Continue',
    delete_title: 'Are you sure you want to delete this task?',
    delete_description: 'It will be deleted and you will not be able to recover it',
    delete_group_description:
      'It will be deleted for every user and you will not be able to recover it',
    delete_member_description:
      "If you delete it, it will disappear from the user's list of pending tasks and they will not be able to answer it",
    bulk_delete_title_one: 'Are you sure you want to delete',
    bulk_delete_title_two: 'tasks?',
    bulk_delete_description:
      'If you delete them, they will disappear from the list of pending tasks of the users and they will not be able to answer them',
    bulk_actions: 'Bulk Actions',
    creation_date: 'Creation Date',
    start_date: 'Start Date',
    answers: 'Answers',
    backToTasks: 'Back to Tasks',
    groupDetail: {
      searchPlaceholder: 'Search by user or email',
      emailColumn: 'Email',
      onTimeColumn: 'On time',
      onTimeYes: 'Yes',
      onTimeNo: 'No',
      emptyMembers: 'This group task has no members assigned',
      answerDrawerTitle: 'Member response',
      bulkSelectedSingular: 'selected',
      bulkSelectedPlural: 'selected',
      bulkDeleteTitle: 'Delete selected members',
      bulkDeleteText:
        'Are you sure you want to remove %{count} members from this group task? Members who already responded will not be removed.',
      bulkDeleteSummary: '%{deleted} removed, %{skipped} skipped',
      bulkNotifyTitle: 'Notify selected members',
      bulkNotifyText:
        'Are you sure you want to notify the %{count} selected members? Only pending members will receive the notification.',
      mandatoryBanner: {
        for_everyone: 'This task is configured as: Mandatory response',
        for_nobody: 'This task is configured as: Voluntary response',
        for_one: 'This task is configured as: Only one response per group',
      },
    },
    duration: 'Duration:',
    answered: 'answered',
    out_of_time: 'Out of time',
    late: 'late',
    no_location: 'No location',
    task_does_not_exist: 'The task does not exist',
    location_copied: 'Location copied to clipboard',
    completed_tasks_cannot_be_deleted: 'Completed tasks cannot be deleted',
    some_tasks_skipped_due_to_answers:
      '%{count} task(s) were skipped because they already have answers and cannot be deleted',
    no_tasks_were_modified: 'No tasks were modified',
    complete_task: 'Complete task',
    complete_task_description: 'Do you want to complete this task now?',
    complete_task_button: 'Complete',
    reject_task_button: 'Reject',
    accept_task_button: 'Accept',
    accept_reject_confirmation:
      'You can accept it and complete it, or reject it if you cannot perform it.',
    import: {
      title: 'Import Tasks',
      step1Title: 'Step 1: Download template',
      step1Description:
        'Download the Excel template example. Make sure to complete the fields marked with * to import your file correctly.',
      downloadExample: 'Download example',
      step2Title: 'Step 2: Edit the file',
      step2Description:
        'Fill in the template with your task data. Make sure all required fields are completed.',
      step2MoreInfo: 'Learn more here',
      step3Title: 'Step 3: Upload your file',
      step3Description:
        'Drag and drop your file here or select it from your computer. It may take a few minutes to process.',
      dragDropText: 'Drag and drop your Excel file here',
      browseText: 'or browse for file',
      replaceText: 'Replace',
      fileUploadedText: 'Your file has been uploaded',
      fileUploadError: 'Your file could not be uploaded',
      invalidFileType: 'Please select a valid Excel file (.xlsx)',
      importError: 'Error importing tasks',
      importButton: 'Import',
      cancel: 'Cancel',
      importing: 'Importing...',
      success: 'Tasks imported successfully. Please wait a few seconds for them to be reflected.',
      errorTitle: 'We detected an error.',
      templateDownloadError: 'Failed to download template',
      downloadingTemplate: 'Downloading...',
      baseTemplateUrl: 'https://s3-us-west-2.amazonaws.com/data-scope/templates/',
      templateFileLegacy: `task_assign_en3_v1.xlsx`,
      templateFileV5: `task_assign_en_v5.xlsx`,
      templateFileLegacyV6: `task_assign_en3_v2.xlsx`,
      templateFileV6: `task_assign_en_v6.xlsx`,
      // v6 template including the group columns (assignment type + group
      // name). Used when the GroupTaskAssign flag is on. Hosted on S3.
      templateFileGroupV6: `task_assign_en_v6_group.xlsx`,
      requirements: {
        title: 'File requirements',
        uniqueIds: "Avoid duplicate 'ID' values.",
        duplicateIdMessage: "ID '{id}' is duplicated. The last value will be used.",
        formNameComplete: "'Form Name' column complete.",
        missingFormNameMessage: "Missing form name in '{cell}'.",
        missingFormNameColumn: "Column 'Form Name' was not found.",
        userEmailComplete: "If individual task, 'User Email' complete.",
        userEmailCompleteLegacy: "'User Email' column complete.",
        missingUserEmailMessage: "Missing user email in '{cell}'.",
        missingUserEmailColumn: "Column 'User Email' was not found.",
        groupFieldsComplete: "If group task, 'Group Name' and 'Assignment Type' complete.",
        missingGroupNameMessage: "Missing group name in '{cell}'.",
        missingAssignmentTypeMessage: "Missing assignment type in '{cell}'.",
        dateAndGapComplete: "'Datetime' and 'Time Gap' columns complete.",
        missingStartDateMessage: "Missing start date in '{cell}'.",
        missingStartDateColumn: "Column 'Datetime' was not found.",
        missingGapMessage: "Missing time gap in '{cell}'.",
        missingGapColumn: "Column 'Time Gap' was not found.",
        seeMore: 'See {count} more',
        seeLess: 'See less',
      },
      confirmIncomplete: {
        title: 'Some rows are incomplete',
        body: '{skipped} of {total} row(s) are missing required fields. Those rows will be skipped and {valid} valid row(s) will be imported. Do you want to continue?',
        cancel: 'Cancel',
        confirm: 'Import {valid} row(s)',
      },
      helpUrl: 'https://help.mydatascope.com/en/articles/2852072-how-to-import-tasks-massively',
      errors: {
        invalidFileType: 'Please select a valid Excel file (.xlsx)',
        importError: 'Error importing tasks. Please check that your data has the correct format.',
        templateDownloadError: 'Failed to download template',
        errorTitle: 'We detected an error.',
      },
    },
    import_audit: {
      title: 'Import history',
      tab: 'History',
      menuImportNow: 'Import now',
      menuViewHistory: 'View history',
      genericImportError:
        'There was a problem processing this import. If the issue persists, contact support.',
      taskImportsTab: 'Task imported',
      backToTasks: 'Back to Task Assignments',
      rowsTitle: 'Rows',
      emptyState: 'No recent imports',
      viewDetails: 'View details',
      back: 'Back to history',
      retrySuccess: 'Task created successfully',
      retryError: 'Could not create the task',
      statuses: {
        pending: 'Pending',
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed',
        created: 'Created',
        updated: 'Updated',
        skipped: 'Skipped',
        resolved_manually: 'Resolved',
      },
      error_codes: {
        task_form_not_found: 'Form not found',
        mobile_user_not_found: 'User not found',
        date_unparseable: 'Invalid date',
        assign_id_in_use: 'ID in use (task in progress or completed)',
        validation_failed: 'Validation error',
      },
      columns: {
        file: 'File',
        date: 'Date',
        triggeredBy: 'Imported by',
        status: 'Status',
        summary: 'Summary',
        rowNumber: 'Row',
        assignId: 'Task ID',
        task: 'Form',
        user: 'User',
        error: 'Error',
        actions: 'Actions',
      },
      summary: {
        read: '%{n} read',
        created: '%{n} created',
        updated: '%{n} updated',
        failed: '%{n} failed',
        skipped: '%{n} skipped',
      },
      fixAndRetry: 'Fix',
      resolvedBy: 'Resolved by',
      resolvedByHelp: 'User who manually fixed and retried this row',
      resolvedAssignId: 'Assigned ID',
      locationCreated: 'Location auto-created',
      idReplaced: 'Requested ID: %{requested} - used: %{used}',
      changedFields: 'Changes',
      fixModal: {
        title: 'Fix row %{row}',
        submit: 'Create task',
        cancel: 'Cancel',
        submitting: 'Creating...',
      },
    },
    exportModal: {
      title: 'Export assigned tasks',
      bannerWithRange: 'Tasks with an execution date within %{from} - %{to} will be exported',
      bannerWithoutRange: 'Tasks matching the current filters will be exported',
      filenameLabel: 'File name',
      filenameHelp: 'You can change the name before exporting',
      cancel: 'Cancel',
      submit: 'Export',
      defaultFilenamePrefix: 'assigned-tasks-export',
    },
    integrations: {
      button: 'Google Sheets',
      title: 'Assigned Tasks Integration',
      gsheetsIntegrationLabel: 'Go to Google Sheets',
      gsheetsNewLinkUrl: 'https://sheets.new/',
      infoTextPart1:
        'To ensure a proper, private and secure integration, share your document with edit permissions to',
      infoTextPart2: 'editor',
      infoTextPart3: 'only to',
      inputLabel: 'New link',
      inputPlaceholder: 'Enter the document link to integrate',
      optional: '(Optional)',
      save: 'Save',
      cancel: 'Cancel',
      copyUrl: 'URL copied!',
      copyEmail: 'Email copied!',
      created: 'Integration set up successfully!',
      saved: 'Changes saved successfully!',
      deleted: 'Integration removed successfully',
      savingError: 'Error setting up the integration',
      removeTitle: 'Remove the Google Sheets integration?',
      removeBody:
        'The sheet will stop receiving task assignment updates from DataScope. The document in Google Drive will not be deleted.',
      removeConfirm: 'Remove integration',
      removeCancel: 'Cancel',
    },
  },
  form_answer: {
    answer_again: 'Submit another answer',
    success_message: 'We have received your answer correctly',
    submit_button: 'Submit',
    edit_button: 'Edit',
    edit_form: 'Edit form',
    incomplete_edit_alert: 'You must answer all required questions',
    incomplete_submit_alert: "You haven't entered any answer yet",
    error_submit_alert: 'There was an error uploading your answer',
    error_edit_alert: 'There was an error editing your answer',
    sync_pending_message:
      'This response is still synchronizing. Editing will be available in a few moments.',
    no_edit_alert: "You haven't edited the original answer yet",
    no_answer_alert: 'Your answer is empty',
    required_question: 'This question is required',
    withinMarginRangeError: 'Enter a reading between {min} and {max}.',
    withinMarginMinimumError: 'Enter a reading greater than or equal to {min}.',
    withinMarginExactError: 'Enter exactly {min}.',
    no_options: 'No options',
    invalid_question_type_1: 'Question of type  ',
    invalid_question_type_2:
      'This type of question cannot be answered/edited in our web platform. Please download our mobile application',
    some_invalid_question_types:
      'Warning: This form has question types that are not supported by the web version of DataScope.',
    download_mobile: 'Download our mobile application here',
    download_mobile_link: 'https://datascope.page.link/H3Ed',
    answer_placeholder: 'Your answer',
    simple_text_placeholder: 'Your text answer',
    text_rut_placeholder: 'Your RUT answer',
    text_container_placeholder: 'Your container ID',
    invalidRutError: 'Invalid RUT',
    invalidContainerError: 'Invalid container ID',
    text_email_placeholder: 'Your email answer',
    select_your_date: 'Select a date',
    select_your_datetime: 'Select a datetime',
    select_your_time: 'Select a time',
    datetime_errors: {
      invalidDate: 'Invalid date',
      minDate: 'The date is less than the minimum allowed',
      maxDate: 'The date is greater than the maximum allowed',
    },
    add_repeatable_questions: 'Add another group of questions',
    signature_type: 'Signature',
    photo_type: 'Photo',
    barcode_type: 'Barcode',
    filter_elements: 'Search elements...',
    exact_match: 'Exact match',
    exact_match_tooltip: 'Searches the text exactly as written',
    search_suggestions_title: 'Search suggestions',
    search_action: 'Search',
    search_general_hint: 'General search in questions and answers',
    search_exact_hint: 'Exact phrase match',
    upload_image: 'Upload Image',
    no_image_loaded: 'No image has been uploaded yet',
    image_max_size_exceeded: 'One or more of your files exceed the maximum allowed size of',
    image_max_amount_exceeded_part_one: 'You can upload up to',
    image_max_amount_exceeded_part_two: 'images per comment',
    image_upload_error: 'There was an error uploading the files, please try again',
    photo_gps_notice: 'Images uploaded from the browser may not include GPS location.',
    no_signature_loaded: 'No signature has been uploaded yet',
    save_canvas: 'Save',
    clear: 'Clear',
    modify_signature: 'Modify',
    next: 'Next',
    previous: 'Back',
    upload_file: 'Upload File',
    uploading_file: 'Uploading...',
    unsupported_file_type: 'This file type is not allowed in this question',
    exceeded_max_number_files:
      'You have exceeded the maximum number of files allowed for this question',
    download_app_suggestion: 'Looking for a better and faster way to answer your forms?',
    confirm_section_change:
      "This section has a required question which you haven't answered correctly yet. Do you want to continue anyway?",
    load_more_data: 'Load more data',
    no_data_left: 'There is no data left to load',
    clear_all: 'Clear all',
    no_header_warning:
      'The creator of this question did not specify the list headers for the related lists.',
    more_answers_alert: 'Scroll to see more',
    subform_limit: 'Question group limit reached',
    subform_min: 'Please add the minimum number of answers',
    multi_option_placeholder: 'Select an option',
    locked_asset_hint: 'This asset was assigned in the task',
    image: 'Image',
    download: 'Download',
    multiple_options: 'Select multiple options',
    group: 'Group',
    start: 'Start',
    end: 'End',
    invalid_date: 'Invalid date',
    invalid_time: 'Invalid time',
    invalid_datetime: 'Invalid date and time',
    locationUpdate: {
      description: 'You must select to change its location',
      lastLocationLabel: 'Last location',
      currentLocationLabel: 'Current location',
      currentLocationPlaceholder: 'Select a location',
    },
    optionComments: {
      addNote: 'Add a note',
      removeNote: 'Remove note',
      writeComment: 'Write a comment',
      requiredNote: 'Comment required',
      addNoteMobile: 'Note',
      addImage: 'Attach Image',
      addImageMobile: 'Image',
      removeNoteMobile: 'Remove',
      requiredImage: 'Image required',
      requiredFinding: 'Finding required',
      deleteImageWarningTitle: 'Are you sure you want to delete this image?',
      deleteImageWarningSubTitle: "Once you delete it, you won't be able to get it back",
      cancel: 'Cancel',
      delete: 'Delete',
    },
    drag_drop_file: 'Drag and drop your files here',
    or_browse_for_file: 'or browse for them on your computer',
    missingRequiredAnswersAlert:
      'Oops! It seems there are still some questions left to answer. Please complete all the required questions to proceed.',
    totalPercentage: 'Total percentage',
    enterSampleTotal: 'Enter the sample total',
    forbidden_access:
      "It seems you don't have permission to edit this form. Request it to make changes",
    automated_signature_on_response:
      'This form has automatic signature configured. The request will be sent to the users assigned when the form is finished.',
    electronic_signature: 'Electronic signature',
    sign_now: 'Sign now',
    sign_later: 'Sign later',
    sign_modal_description: 'This form requires your signature, do you want to sign now?',
    signature_creation_failed: 'There was an error signing the form',
    saveSuccessAndRedirect: 'Answer saved correctly! Redirecting to your signatures...',
    saveAndSignSuccessAndRedirect:
      'Answer saved and signed correctly! Redirecting to your signatures...',
    subtasks: 'Tasks',
    editingActivity: 'Editing activity',
    selectActivityAndDuration: 'Select activity and duration',
    update: 'Update',
    add: 'Add',
    to: 'to',
    activityPlaceholder: 'Activity',
    durationPlaceholder: 'Duration',
    durationExceedsLimit: 'The duration exceeds the remaining time',
    cancel: 'Cancel',
    requiredQuestionIncomplete: 'All working time must be allocated',
    deleteActivityMessage: 'Are you sure you want to delete this activity?',
    allActivitiesRegistered: 'All time allocated',
    workingTimeNotSet: 'Working time not set',
    remainingTimePrefix: 'You still need to assign',
    activityNotSelected: 'Activity missing',
    editActivity: 'Edit',
    insertBelow: 'Insert below',
    deleteActivity: 'Delete',
    addActivity: 'Add Activity',
    leave_form_title: 'You are leaving the form',
    leave_form_message:
      'You have unsaved changes in this response. If you leave this view now, your changes will be lost. Do you want to leave and discard them?',
    leave_stay_button: 'Keep editing',
    leave_confirm_button: 'Leave and discard',
    exit_form_title: 'Exit incomplete form',
    exit_form_message: 'Are you sure you want to leave the form?',
    exit_cancel_button: 'Cancel',
    exit_confirm_button: 'Yes',
    draft_found_title: 'Draft found',
    draft_found_message:
      'You have saved answers from a previous session on this form. How would you like to continue?',
    draft_continue_button: 'Continue with draft',
    draft_start_fresh_button: 'Start a new one',
    draft_recovered_banner:
      'Draft recovered. Please check the attachments and signature fields if applicable.',
    noAssignedLocations:
      'You have no assigned locations for this form. Contact your administrator.',
    filterAssetsByLocationBlocked: 'Select a location first to see the available assets.',
    filterAssetsByLocationNoAssets: 'The selected location has no assets assigned.',
  },
  percentage: 'Percentage',
  date_fns: 'enGB',
  build_your_own_form: 'Build your own form with DataScope',
  back_to_taskForms: 'Return to form list',
  ok: 'OK',
  yes: 'Yes',
  no: 'No',
  insert_value: 'Insert a value',
  and: 'And',
  invalidEmail: 'Invalid Email',
  group: 'Group',
  folder: 'Folder',
  users: 'Users',
  forms: 'Forms',
  clearAll: 'Clear All',
  actions: 'Actions',
  select: 'Select',
  selectAll: 'Select All',
  form_builder: {
    formName: 'Form name',
    saveForm: 'Save',
    title: 'Title',
    titleDescription: 'Short title to identify the question. Appears when exporting data.',
    instruction: 'Description',
    instructionDescription:
      'Longer text to display in the app. Does not appear when exporting data (Optional).',
    questionType: 'Change question type',
    copy: 'Duplicate question',
    delete: 'Delete question',
    add: 'Add new question',
    advanced: 'Advanced Options',
    type: 'Type',
    date: 'Date',
    dateAndTime: 'Date and Time',
    time: 'Time',
    alternativeColumns: 'Alternative columns',
    addOption: 'Add option',
    dataListSource: 'Data list source',
    changeDataList: 'Change data list',
    listValues: 'List values',
    addListValue: 'Add list value',
    deleteAlternative: 'Delete alternative',
    required: 'Required',
    validateRutChile: 'RUT (Chile)',
    validateMail: 'E-mail',
    validateContainer: 'Container ID',
    validate: 'Validate',
    codeType: 'Change code type',
    disableGallery: 'Disable gallery',
    maxImagesPerItem: 'Max images per item',
    moveUp: 'Move up',
    moveDown: 'Move down',
    alternative: 'Alternative',
    snackBarShared: 'invitations sent',
    snackBar: 'Your form has been saved successfully!',
    activityStartTimeRequired: 'Define the start time of the workday to continue.',
    newListData: 'New List Of Data',
    section: 'Add Section',
    sectionName: 'Unnamed section',
    duplicateSection: 'Duplicate section',
    deleteSection: 'Delete section',
    delSectionsQuestions: 'Delete section and questions',
    areYouSure: 'Are you sure?',
    cancel: 'Cancel',
    sectionAlertOne:
      'The section will be removed, but the questions will be added to the previous section.',
    sectionAlertTwo: 'The section will be deleted and also the questions inside it.',
    yesDelete: 'Yes, delete',
    questionAlert: 'This question will be permanently removed',
    questionAlertWithAssetLinksPrefix:
      'This question will be permanently deleted along with its ',
    questionAlertWithAssetLinksHighlight: 'asset data links',
    copyName: 'Copy',
    nameAlert: 'The questions must have different names.',
    isRepeated: 'is repeated.',
    if: 'if',
    is: 'is',
    to: 'to',
    goTo: 'go to',
    sectionNameTag: 'Section name',
    skipQuestions: 'Skip questions',
    equal: 'equal',
    dif: 'different',
    contains: 'contains',
    notContains: 'does not contain',
    empty: 'empty',
    notEmpty: 'not empty',
    skipOnlyMobile: 'Only applies for mobile use',
    disableSkip: 'This question type does not support skip logic.',
    next: 'next question',
    end: 'finish form',
    payingAlert:
      'This functionality is not available in the free plan, you must activate your plan in the configuration / billing.',
    showPercent: 'Show percent',
    showSamplingPercent: 'Show sampling percent',
    showPrice: 'Show price',
    showAvg: 'Show average',
    showFactor: 'Show factor',
    camQuality: 'Camera quality',
    high: 'High',
    mid: 'Mid',
    low: 'Low',
    recommended: 'recommended',
    photoAlert: 'synchronization might take longer',
    sectionNameAlert: 'There should be no sections with the same name. Please rename the section: ',
    formatType: 'Format types',
    audioDuration: 'Audio duration',
    secondsLabel: 'seconds',
    cannotCombineWithVoiceAudioRecording: 'Cannot be combined with audio recording',
    anyIncludeAllFormatsExceptVoiceAudioRecording:
      'Any includes all file types, except audio recording',
    voiceAudioRecording: 'Audio recording',
    any: 'Any',
    howToCreate: 'How to create forms',
    good: 'Good',
    regular: 'Regular',
    bad: 'Bad',
    newOption: 'New option',
    moveSection: 'Move section',
    oldShareForm: 'Share this form with a public link',
    shareForm: 'Form Link',
    shareEmail: 'Share by email',
    shareWhatsapp: 'Share by WhatsApp',
    shareWhatsappMessage: 'Share your form with a message by WhatsApp',
    shareWhatsappMessageApi: 'Hi, I invite you to complete the {form_name} form: ',
    formMadePublic: 'The public form link has been enabled',
    undoFormPublic: 'The public form link has been disabled',
    shareForm2: 'Share this form',
    shareFormTip:
      'Anyone, registered users and non-registered persons alike, will be able to fill out this web form if you share the public link with them. Their answers will be registered under the name of a generic user.',
    shareFormOn: 'Make this form public',
    shareFormOff: 'Remove public access',
    shareViaEmailTip: 'Include more emails with enter, space or comma',
    quantity: 'Maximum number of files',
    new: 'New!',
    warning: 'Temporarily only available for web forms',
    testYourForm1: 'Download our official App at ',
    testYourForm2: 'Later you can log in with these same credentials.',
    testYourForm3: 'Test your form on our app!',
    testYourForm4: 'Scan this QR code with your cellphone camera to view your form!',
    testYourForm5:
      'Scan this QR code with your cellphone camera to download our app and view your form!',
    copyLink: 'Copy link',
    visitForm: 'Visit',
    copiedLink: 'Copied!',
    accessYourForm: 'Access your form here',
    downloadApp: 'Download our app',
    ok: 'ok',
    and: 'and',
    greater: 'Greater than',
    greaterOrEqual: 'Greater than or equal to',
    less: 'Less than',
    lessOrEqual: 'Less than or equal to',
    between: 'Between',
    notBetween: 'Not between',
    betweenQuestionOffset: 'Between question and offset',
    withinMargin: 'Within the margin of the last reading',
    withinMarginBack: 'Backward margin',
    withinMarginForward: 'Forward margin',
    withinMarginLastReading: 'the last meter reading',
    withinMarginExactly: 'exactly',
    withinMarginRequiresMeter: 'Requires using this question to update a meter',
    withinMarginNotInRepeatable: 'Not available inside a repeatable question group',
    withinMarginUnlinkedWarning: 'This validation will not run until the question is linked to a meter again.',
    withinMarginInert: 'This validation is turned off for now. The configuration is kept and will apply again once it is re-enabled.',
    // Keys here are intentionally duplicated from form_builder's numeric-mode
    // keys rather than cross-read (see betweenQuestionOffset vs.
    // form_builder.betweenQuestionOffset above) — a numeric-mode rewording
    // should never silently change this panel. Divergent wording between the
    // two is deliberate per D19, not a typo to unify.
    dateValidation: {
      addValidation: 'Add validation',
      validationType: 'Validation type',
      fixedRange: 'Fixed range',
      fixedRangeDescription: 'In relation to the answer date',
      fixedRangeDescriptionTime: 'In relation to the answer time',
      relativeRange: 'Relative range',
      relativeRangeDescription: 'In relation to another date question in the form',
      relativeRangeDescriptionTime: 'In relation to another time question in the form',
      rangeCondition: 'Temporal condition',
      selectRangeCondition: 'Select an option',
      predefinedConditions: 'Predefined',
      customConditions: 'Custom',
      offset: 'Offset',
      hours: 'hours',
      days: 'days',
      day: 'day',
      hour: 'hour',
      timeModeWarning:
        'Time does not consider day changes. Use Date and time for ranges between days.',
      relativeTimeModeWarning:
        'Time does not account for day changes. Use Date and time to compare across days.',
      pickQuestion: 'Pick a Question',
      noQuestionsAvailable: 'No questions available for comparison',
      validationComparisonType: 'Comparison Type',
      betweenQuestionOffset: 'Between question and offset',
      minimumValue: 'Minimum value',
      maximumValue: 'Maximum value',
      and: 'and',
      minimumValueForOffsetIs: 'The minimum allowed offset is',
      maximumValueForOffsetIs: 'The maximum allowed offset is',
      onlyToday: 'Only today',
      noFutureDates: 'Do not allow future dates',
      noPastDates: 'Do not allow past dates',
      onlyCurrentTime: 'Only current time',
      noFutureTimes: 'Do not allow future times',
      noPastTimes: 'Do not allow past times',
      after: 'After',
      afterOrEqual: 'After or equal to',
      before: 'Before',
      beforeOrEqual: 'Before or equal to',
      between: 'Between',
      notBetween: 'Not between',
      rangeValidationErrorMessageForDate: 'The value must be at least 1 day.',
      rangeValidationErrorMessageForTime: 'The value must be between 1 and 23 hours.',
      rangeValidationErrorMessageForDateTime: 'The value must be at least 24 hours.',
      notBetweenTimeWindowTooWideMessage: 'The sum of both values must be less than 24 hours.',
      date_only_today: "Select today's date.",
      date_no_future: 'Enter a date equal to or before today.',
      date_no_past: 'Enter a date equal to or after today.',
      date_after_tomorrow: "Enter tomorrow's date.",
      date_after_days:
        'Enter a date from tomorrow to the next {{numOfOffsetDays}} {{stringOfOffsetDays}}.',
      date_after_or_equal_days:
        'Enter a date from today to {{numOfOffsetDays}} {{stringOfOffsetDays}} after.',
      date_before_yesterday: "Enter yesterday's date.",
      date_before_days:
        'Enter a date from yesterday to {{numOfOffsetDays}} {{stringOfOffsetDays}} ago.',
      date_before_or_equal_days:
        'Enter a date from today to {{numOfOffsetDays}} {{stringOfOffsetDays}} ago.',
      date_between_days:
        'Enter a date between {{numOfLeftDays}} {{stringOfLeftDays}} before and {{numOfRightDays}} {{stringOfRightDays}} after today.',

      time_only_now: 'Enter the current time.',
      time_no_future: 'Enter a time equal to or before now.',
      time_no_past: 'Enter a time equal to or after the current time.',
      time_after_next_hour: 'Enter a time within the next hour.',
      time_after_hours: 'Enter a time within the next {{hours}} {{stringOfOffsetHours}}.',
      time_after_or_equal_hours:
        'Enter a time from now or up to {{hours}} {{stringOfOffsetHours}} after.',
      time_before_last_hour: 'Enter a time within the last hour.',
      time_before_hours:
        'Enter a time up to {{numOfOffsetHours}} {{stringOfOffsetHours}} before this moment.',
      time_before_or_equal_hours:
        'Enter a time from now or up to {{numOfOffsetHours}} {{stringOfOffsetHours}} ago.',
      time_between_hours:
        'Enter a time from {{numOfLeftHours}} {{stringOfLeftHours}} before to {{numOfRightHours}} {{stringOfRightHours}} after this moment.',

      datetime_only_today: 'Select a date and time for today.',
      datetime_no_future: 'Enter a date and time equal to or before now.',
      datetime_no_past: 'Enter a date and time equal to or after the current time.',
      datetime_after:
        'Enter a date and time up to {{numOfOffsetDays}} {{stringOfOffsetDays}} and {{numOfOffsetHours}} {{stringOfOffsetHours}} after this moment.',
      datetime_after_days_only:
        'Enter a date and time up to {{numOfOffsetDays}} {{stringOfOffsetDays}} after this moment.',
      datetime_after_or_equal:
        'Enter a date and time from now to {{numOfOffsetDays}} {{stringOfOffsetDays}} and {{numOfOffsetHours}} {{stringOfOffsetHours}} after.',
      datetime_after_or_equal_days_only:
        'Enter a date and time from now to {{numOfOffsetDays}} {{stringOfOffsetDays}} after.',
      datetime_before:
        'Enter a date and time up to {{numOfOffsetDays}} {{stringOfOffsetDays}} and {{numOfOffsetHours}} {{stringOfOffsetHours}} ago.',
      datetime_before_days_only:
        'Enter a date and time up to {{numOfOffsetDays}} {{stringOfOffsetDays}} ago.',
      datetime_before_or_equal:
        'Enter a date and time from now to {{numOfOffsetDays}} {{stringOfOffsetDays}} and {{numOfOffsetHours}} {{stringOfOffsetHours}} before.',
      datetime_before_or_equal_days_only:
        'Enter a date and time from now to {{numOfOffsetDays}} {{stringOfOffsetDays}} before.',
      datetime_between:
        'Enter a date and time between {{numOfLeftDays}} {{stringOfLeftDays}} and {{numOfLeftHours}} {{stringOfLeftHours}} before and {{numOfRightDays}} {{stringOfRightDays}} and {{numOfRightHours}} {{stringOfRightHours}} after this moment.',
      datetime_between_days_only:
        'Enter a date and time between {{numOfLeftDays}} {{stringOfLeftDays}} before and {{numOfRightDays}} {{stringOfRightDays}} after this moment.',
      datetime_between_left_days_only:
        'Enter a date and time between {{numOfLeftDays}} {{stringOfLeftDays}} before and {{numOfRightDays}} {{stringOfRightDays}} and {{numOfRightHours}} {{stringOfRightHours}} after this moment.',
      datetime_between_right_days_only:
        'Enter a date and time between {{numOfLeftDays}} {{stringOfLeftDays}} and {{numOfLeftHours}} {{stringOfLeftHours}} before and {{numOfRightDays}} {{stringOfRightDays}} after this moment.',
      date_relative_after: 'Enter a date after {{limit}}.',
      date_relative_after_or_equal: 'Enter a date on or after {{limit}}.',
      date_relative_before: 'Enter a date before {{limit}}.',
      date_relative_before_or_equal: 'Enter a date on or before {{limit}}.',
      date_relative_between: 'Enter a date between {{minLimit}} and {{maxLimit}}.',
      date_relative_not_between:
        'Enter a date outside the range between {{minLimit}} and {{maxLimit}}.',
      date_relative_between_question_offset: 'Enter a date between {{minLimit}} and {{maxLimit}}.',
      datetime_relative_after: 'Enter a date and time after {{limit}}.',
      datetime_relative_after_or_equal: 'Enter a date and time on or after {{limit}}.',
      datetime_relative_before: 'Enter a date and time before {{limit}}.',
      datetime_relative_before_or_equal: 'Enter a date and time on or before {{limit}}.',
      datetime_relative_between: 'Enter a date and time between {{minLimit}} and {{maxLimit}}.',
      datetime_relative_not_between:
        'Enter a date and time outside the range between {{minLimit}} and {{maxLimit}}.',
      datetime_relative_between_question_offset:
        'Enter a date and time between {{minLimit}} and {{maxLimit}}.',
      time_relative_after: 'Enter a time after {{limit}}.',
      time_relative_after_or_equal: 'Enter a time on or after {{limit}}.',
      time_relative_before: 'Enter a time before {{limit}}.',
      time_relative_before_or_equal: 'Enter a time on or before {{limit}}.',
      time_relative_between: 'Enter a time between {{minLimit}} and {{maxLimit}}.',
      time_relative_not_between:
        'Enter a time outside the range between {{minLimit}} and {{maxLimit}}.',
      time_relative_between_question_offset: 'Enter a time between {{minLimit}} and {{maxLimit}}.',

      date_not_between_days:
        'Enter a date outside the range between {{numOfLeftDays}} {{stringOfLeftDays}} before and {{numOfRightDays}} {{stringOfRightDays}} after today.',
      time_not_between_hours:
        'Enter a time outside the range between {{numOfLeftHours}} {{stringOfLeftHours}} before and {{numOfRightHours}} {{stringOfRightHours}} after this moment.',
      datetime_not_between:
        'Enter a date and time outside the range between {{numOfLeftDays}} {{stringOfLeftDays}} and {{numOfLeftHours}} {{stringOfLeftHours}} before and {{numOfRightDays}} {{stringOfRightDays}} and {{numOfRightHours}} {{stringOfRightHours}} after this moment.',
      datetime_not_between_days_only:
        'Enter a date and time outside the range between {{numOfLeftDays}} {{stringOfLeftDays}} before and {{numOfRightDays}} {{stringOfRightDays}} after this moment.',
      datetime_not_between_left_days_only:
        'Enter a date and time outside the range between {{numOfLeftDays}} {{stringOfLeftDays}} before and {{numOfRightDays}} {{stringOfRightDays}} and {{numOfRightHours}} {{stringOfRightHours}} after this moment.',
      datetime_not_between_right_days_only:
        'Enter a date and time outside the range between {{numOfLeftDays}} {{stringOfLeftDays}} and {{numOfLeftHours}} {{stringOfLeftHours}} before and {{numOfRightDays}} {{stringOfRightDays}} after this moment.',

      datetime: {
        afterMessage:
          'The date and time must be after the moment the form is answered, with a maximum of {days} {daysUnit} and {hours} {hoursUnit} later.',
        afterOrEqualMessage:
          'The date and time must be equal to or after the moment the form is answered, with a maximum of {days} {daysUnit} and {hours} {hoursUnit} later.',
        beforeMessage:
          'The date and time must be before the moment the form is answered, with a maximum of {days} {daysUnit} and {hours} {hoursUnit} ago.',
        beforeOrEqualMessage:
          'The date and time must be the day the form is answered or up to {days} {daysUnit} and {hours} {hoursUnit} ago.',
        betweenMessage:
          'The date and time must be within the range from {daysBefore} {daysBeforeUnit} and {hoursBefore} {hoursBeforeUnit} before to {daysAfter} {daysAfterUnit} and {hoursAfter} {hoursAfterUnit} after the moment the form is answered.',
        notBetweenMessage:
          'The date and time must be outside the range from {daysBefore} {daysBeforeUnit} and {hoursBefore} {hoursBeforeUnit} before to {daysAfter} {daysAfterUnit} and {hoursAfter} {hoursAfterUnit} after the moment the form is answered.',
        relativeAfterMessage:
          'The date and time must be after {questionName} plus {days} {daysUnit} and {hours} {hoursUnit}.',
        relativeAfterOrEqualMessage:
          'The date and time must be on or after {questionName} plus {days} {daysUnit} and {hours} {hoursUnit}.',
        relativeBeforeMessage:
          'The date and time must be before {questionName} plus {days} {daysUnit} and {hours} {hoursUnit}.',
        relativeBeforeOrEqualMessage:
          'The date and time must be on or before {questionName} plus {days} {daysUnit} and {hours} {hoursUnit}.',
        relativeBetweenMessage:
          'The date and time must be between {minQuestionName} and {maxQuestionName}.',
        relativeNotBetweenMessage:
          'The date and time must not be between {minQuestionName} and {maxQuestionName}.',
        relativeBetweenQuestionOffsetMessage:
          'The date and time must be between {questionName} and {questionName} plus {days} {daysUnit} and {hours} {hoursUnit}.',
      },
      date: {
        afterMessage:
          'The date must be after the day the form is answered, with a maximum of {days} {daysUnit} later.',
        afterOrEqualMessage:
          'The date must be the day the form is answered or up to {days} {daysUnit} later.',
        beforeMessage:
          'The date must be before the day the form is answered, with a maximum of {days} {daysUnit} ago.',
        beforeOrEqualMessage:
          'The date must be the day the form is answered or up to {days} {daysUnit} ago.',
        betweenMessage:
          'The date must be within the range from {daysBefore} {daysBeforeUnit} before to {daysAfter} {daysAfterUnit} after the moment the form is answered.',
        notBetweenMessage:
          'The date must be outside the range from {daysBefore} {daysBeforeUnit} before to {daysAfter} {daysAfterUnit} after the moment the form is answered.',
        relativeAfterMessage: 'The date must be after {questionName} plus {days} {daysUnit}.',
        relativeAfterOrEqualMessage:
          'The date must be on or after {questionName} plus {days} {daysUnit}.',
        relativeBeforeMessage: 'The date must be before {questionName} plus {days} {daysUnit}.',
        relativeBeforeOrEqualMessage:
          'The date must be on or before {questionName} plus {days} {daysUnit}.',
        relativeBetweenMessage: 'The date must be between {minQuestionName} and {maxQuestionName}.',
        relativeNotBetweenMessage:
          'The date must not be between {minQuestionName} and {maxQuestionName}.',
        relativeBetweenQuestionOffsetMessage:
          'The date must be between {questionName} and {questionName} plus {days} {daysUnit}.',
      },
      time: {
        afterMessage:
          'The time must be after the moment the form is answered, with a maximum of {hours} {hoursUnit} later.',
        afterOrEqualMessage:
          'The time must be at the moment the form is answered or up to {hours} {hoursUnit} later.',
        beforeMessage:
          'The time must be at most {hours} {hoursUnit} before the moment the form is answered.',
        beforeOrEqualMessage:
          'The time must be at the moment the form is answered or up to {hours} {hoursUnit} ago.',
        betweenMessage:
          'The time must be within the range from {hoursBefore} {hoursBeforeUnit} before to {hoursAfter} {hoursAfterUnit} after the moment the form is answered.',
        notBetweenMessage:
          'The time must be outside the range from {hoursBefore} {hoursBeforeUnit} before to {hoursAfter} {hoursAfterUnit} after the moment the form is answered.',
        relativeAfterMessage: 'The time must be after {questionName} plus {hours} {hoursUnit}.',
        relativeAfterOrEqualMessage:
          'The time must be on or after {questionName} plus {hours} {hoursUnit}.',
        relativeBeforeMessage: 'The time must be before {questionName} plus {hours} {hoursUnit}.',
        relativeBeforeOrEqualMessage:
          'The time must be on or before {questionName} plus {hours} {hoursUnit}.',
        relativeBetweenMessage: 'The time must be between {minQuestionName} and {maxQuestionName}.',
        relativeNotBetweenMessage:
          'The time must not be between {minQuestionName} and {maxQuestionName}.',
        relativeBetweenQuestionOffsetMessage:
          'The time must be between {questionName} and {questionName} plus {hours} {hoursUnit}.',
      },
    },
    number: 'Number',
    noValidation: 'No validation',
    validNumberWarning: 'Enter a valid number',
    validSetWarning: 'Enter a valid range',
    separator: 'Separator',
    separatorWarning: 'Enter a valid separator',
    relatedList: 'Related list',
    updateAssetData: 'Update data',
    filterAssetsByLocation: 'Filter assets by location',
    filterAssetsByLocationTitle: 'Filter assets by location',
    filterAssetsByLocationPlaceholder: 'Select a location question',
    filterAssetsByLocationSameRow: 'Location inside the repeatable question',
    filterAssetsByLocationWholeForm: 'Location outside the repeatable question',
    filterAssetsByLocationCreateQuestion: 'Create location question',
    filterAssetsByLocationNewQuestionName: 'Location',
    selectData: 'Select the asset data to update',
    selectMeterQuestion: 'Select the question that will capture the data',
    meterConfigBannerMeter:
      'The system will automatically update the asset information with the data registered in this form.',
    addMeterQuestion: 'Add another question that captures data',
    addMeterConfiguration: 'Add meter',
    createNumberQuestion: 'Create a new number question',
    createSelectMetadataQuestion: 'Create a new single option data question',
    header: 'Header',
    headerPlaceholder: 'Country | City | Street',
    headerWarning: 'You must enter a header that contains the separator',
    headerDefault: 'List without header',
    deprecatedWarning: 'This type of question is no longer supported',
    combineAlert1: 'Questions can only be dragged into group of repeatable questions.',
    combineAlert2:
      'A group of repeatable questions cannot contain another group of repeatable questions.',
    combineAlertTitle: 'Error',
    emptySubform: 'Empty',
    emptySubformAlert:
      'Group of repeatable questions cannot be left empty, a question has been created automatically.',
    emptySubformAlertTitle: 'Warning',
    emptySubformTooltip: 'Remove all questions from group of repeatable questions',
    removeSubformQuestionTooltip: 'Remove question from group of repeatable questions',
    subformRemoveConfirm:
      'This question will be removed from this group of repeatable questions and added to the main form.',
    subformEmptyConfirm:
      'All questions will be removed from the group of repeatable questions and added to the main form.',
    confirm: 'Confirm',
    subformLimit: 'Limit repetitions',
    subformWarning: 'For more than 5 repetitions, upgrade your plan in configuration > billing',
    answer: 'Answer',
    includeComments: 'Comment',
    commentsFormLabel: 'Select the answers which require a comment.',
    textCommentBtnTooltip: 'Required Text',
    imageCommentBtnTooltip: 'Required Image',
    findingCommentBtnTooltip: 'Required Issue',
    imageCommentBtnTooltipDisabled: "You can't add over a max of 500 images in total",
    share: 'Share',
    mobileTab: 'Mobile',
    webTab: 'Computer',
    max: 'Máximum',
    min: 'Mínimum',
    asCount: 'Counter',
    dataListSearchModalTitle: 'My lists',
    editLists: 'Edit lists',
    editLocations: 'Edit locations',
    editAssets: 'Edit assets',
    use: 'Use',
    usedInThisForm: 'Used in this form',
    otherLists: 'Other lists',
    customLists: 'Custom',
    locations: 'Locations',
    selectAll: 'Select all',
    customLocations: 'Custom locations',
    searchInListPlaceholder: 'Search in this list...',
    locationAccessAlert:
      'Some users might not see this question if they do not have access to the selected locations',
    customListsDescription: 'Store any type of data you need to query (includes old locations)',
    locationsDescription: 'Centralize and control information about your physical spaces',
    assetsDescription: 'Manage assets with all their information, location and meters',
    selectDataListInstruction: 'Select the data list that best fits your question',
    multi_photo: 'Multiple photos',
    mobileOnlyAlert:
      'Available only in mobile forms. If this question is required, you can still answer the webform but this question will not appear.',
    oldLocationsListWarning:
      "You're using an old location list. Create a new one to take advantage of the benefits.",
    availableAppWeb: 'Available on web and mobile app',
    imageDisabledByLimit:
      'The option to upload images has been disabled. It is not possible to upload more than 500 images in total',
    formBuilderBlockedAlertPart1:
      'You do not have permission to edit this form. If you want to create or edit forms ',
    formBuilderBlockedAlertPart2: 'upgrade your plan',
    formBuilderBlockedAlertPart3: ' now and unlock unlimited productivity',
    formNameExists: 'This form name already exists',
    saveError: 'There was an error saving the form',
    formLockedForEditing: 'Form is locked for editing.',
    validationFixedRange: 'Fixed Range',
    validationRelativeRange: 'Relative Range(available only in app)',
    validationComparisonType: 'Comparison Type',
    validationSelectComparisonType: 'Select comparison type',
    minimumValue: 'Minimum Value',
    maximumValue: 'Maximum Value',
    offset: 'Offset',
    pickQuestion: 'Pick a Question',
    noQuestionsAvailable: 'No questions available for comparison',
    validationType: 'Validation Type',
    theNumberMustBe: 'The number must be',
    theNumberMustNotBe: 'The number must not be',
    than: 'than',
    plus: 'plus',
    minus: 'minus',
    hoursLabel: 'hrs',
    hourLabel: 'hr',
    andMinutesLabel: 'and',
    minuteLabel: 'minute',
    minutesLabel: 'minutes',
    activityStartTime: 'Select the start time of the working hours',
    activityDuration: 'Select the duration of the working hours',
    activityInterval: 'Select the time interval',
    activityDurationHours: 'Hours',
    activityDurationMinutes: 'Minutes',
    hourWord: 'hour',
    hoursWord: 'hours',
    workdayEndsAt: 'The working hours will end at {time}.',
    workdayEndsAtNextDay: 'The working hours will end at {time} the next day.',
    activityIntervalPlaceholderDisabled: 'Set the duration first',
    activityIntervalPlaceholderEmpty: 'Select an interval',
    activityIntervalHelperText: 'The available options depend on the configured duration.',
    activityIntervalRequired: 'Select an interval to be able to save.',
    activityPeriodTimeIncomplete:
      'Some activity questions have no duration or no interval. Complete them to save the form.',
    activityDurationInvalid: 'The duration must be at least 5 minutes.',
    every: 'Every',
    chooseSelectMetadataQuestion: 'Select a {select_metadata} question',
    chooseNumberQuestion: 'Select a {number} question',
    tabs: {
      builder: 'Form Builder',
      integrations: 'Integrations',
      signature: 'Signature',
      email: 'Email',
      pdf: 'PDF',
    },
    dynamicSignatureModificationAlert: {
      title: 'Some signatures might stop working',
      description:
        'The changes you are making could affect the electronic signatures associated with these questions.\nIf you continue, those signatures may be deactivated.',
      continue: 'Continue',
      cancel: 'Cancel',
    },
  },
  help: {
    multi_option: 'Select an option from a list of items',
    select_metadata: 'Select an option from a dynamic data list',
    select_option_metadata: 'Select an option for each item on the list',
    select_option_metadata_comments: 'Select fixed alternatives for each item of a custom list',
    track_code: 'Provide the option to change or select the tracking code of each form',
    static_text: 'Allows adding fixed text as a form instruction',
    select_check_metadata: 'Select multiple items in a dynamic data list',
    select_number_metadata: 'Select a number for each item in the dynamic data list',
    select_text_metadata: 'Write text for each item in a dynamic data list',
    table: 'Create a group of questions that you can answer more than once',
  },
  types: {
    text: 'Text',
    date: 'Date/Time',
    number: 'Number',
    signature: 'Signature',
    barcode: 'Scanner',
    photo: 'Photo',
    multi_photo: 'Photo',
    multi_option: 'Single Choice',
    select_option_metadata: 'Checklist',
    select_option_metadata_comments: 'Checklist',
    select_check_metadata: 'Checkbox',
    select_number_metadata: 'Number Data',
    select_text_metadata: 'Text Data',
    static_text: 'Instruction',
    select_metadata: 'Single Option Data',
    table: 'Group of Repeatable Fields',
    attachment: 'Attach File',
    deprecated: 'Deprecated',
    select_activity_period_time: 'Activity Data',
  },
  links: {
    appStore: 'https://itunes.apple.com/us/app/datascope-forms/id1132697668?l=en&ls=1&mt=8',
    playStore: 'https://app.datascope.io/apk',
    appLink: 'https://datascope.page.link/3N7P',
  },
  listManager: {
    dataListSource: 'Data source',
    name: 'Name',
    description: 'Description',
    code: 'Code',
    listItems: 'List Items',
    emptyList: 'This list has no items',
    attribute1: 'Attribute 1',
    attribute2: 'Attribute 2',
    listSubtitle:
      'You can use these lists in question types: Checklist, checkbox, data list number, data list text and data list selection',
    seeAll: 'See all lists',
    seeObj: 'See list items',
    edit: 'Edit list',
    editObj: 'Edit item',
    delete: 'Delete list',
    deleteAction: 'Delete',
    deleteObj: 'Delete item',
    nameInUse: 'Name already in use',
    codeInUse: 'Code already in use',
    nameEmpty: 'Name cannot be empty',
    itemsStillEditing: 'There are items being edited. Confirm or cancel them before saving.',
    deleteObjectWarning: 'Are you sure you want to remove this item from the list?',
    deleteYes: 'Yes, delete',
    confirmDeleteItemsTitle: 'Are you sure you want to delete {count} items?',
    confirmDeleteItemsDesc:
      'They will be deleted, but previously submitted responses will not be affected',
    saveChanges: 'Save',
    cancel: 'Cancel',
    itemsOf: 'Items of:',
    addNewItem: '+ New item',
    page: 'Page ',
    of: ' of ',
    close: 'Close',
    legacy: 'Go to full list manager',
    locations: 'Locations',
    assets: 'Assets',
    customLists: 'Custom lists',
    search: 'Search',
    searchPlaceholder: 'Search by list name, creator, form name',
    import: 'Import',
    importSuccess: 'Lists uploaded successfully. They may take a few seconds to appear',
    importError: 'Error importing list',
    importDescription: 'Upload an XLS, XLSX or CSV file with the list data. Maximum 5MB.',
    export: 'Export',
    newList: 'New list',
    switchToLegacy: 'Switch to previous version',
    switchToNew: 'Switch to new version',
    duplicate: 'Duplicate',
    createdAt: 'Created date',
    type: 'Type',
    items: 'Items',
    creator: 'Creator',
    usedIn: 'Used in',
    usedInDescription: 'Forms that use this list',
    notUsed: 'This list is not being used in any form.',
    noResults: 'No lists found',
    emptyTitle: 'You have no custom lists',
    emptyDescription: 'Create your first list to organize data you can use in your forms.',
    deleteConfirmTitle: 'Delete list',
    deleteSuccess: 'Lists deleted successfully',
    deleteError: 'Error deleting lists',
    duplicateSuccess: 'List duplicated successfully',
    duplicateError: 'Error duplicating list',
    createList: 'Create list',
    editList: 'Edit list',
    details: 'Details',
    listName: 'List name',
    listDescriptionOptional: 'List description (optional)',
    listType: 'List type',
    typeStandard: 'Standard',
    typePrice: 'Price',
    typePercent: 'Percentage',
    typeStandardDesc: "Uses the 'Data list' question",
    typePriceDesc: "Uses the 'Data list number' question",
    itemAttributes: 'Item attributes',
    attributesExportHelper: 'Will be reflected in the PDF export',
    attributeNamePlaceholder: 'Attribute name',
    listItemsSection: 'List items',
    addItemsHelper: 'Add the items this list will contain',
    addItem: 'Add item',
    noItemsYet: 'No items added yet',
    create: 'Create',
    update: 'Update',
    formInfoHelper:
      'In the form response you will only see the items from this list that have been selected',
    actions: 'Actions',
    newItem: 'New item',
    list: 'List',
    searchByNameCode: 'Search by name, code',
    lastResponse: 'Last response',
    results: 'Results',
    itemSelected: 'item selected',
    itemsSelected: 'items selected',
    confirmDeleteItems: 'Are you sure you want to delete {count} items?',
    confirmDeleteItem: 'Are you sure you want to delete "{name}"?',
    listNotFound: 'List not found',
    nameItem: 'Item name',
    textType: 'Text',
    imageType: 'Image',
    nameRequired: 'Name is required',
    codeOptional: 'Code (optional, auto-generated)',
    codeInvalid: 'Only letters, numbers, spaces and underscores',
    codeTooLong: 'Maximum 30 characters',
    auditLogsTitle: 'Import Logs',
    importsTab: 'Lists imported',
    menuImportNow: 'Import now',
    menuViewHistory: 'View history',
    statusStarted: 'Started',
    statusProcessing: 'Processing',
    statusCompleted: 'Completed',
    statusFailed: 'Error',
    typeSingle: 'Single',
    typeMassive: 'Massive',
    colDate: 'Date',
    colUser: 'User',
    colType: 'Type',
    colList: 'List',
    colFile: 'File',
    colStatus: 'Status',
    colResult: 'Result',
    colDuration: 'Duration',
    noImportsFound: 'No imports recorded',
    listsCount: 'lists',
    itemsDeleted: 'items deleted',
    deleteItemsError: 'Error deleting items',
    reorderError: 'Could not save the new order',
    reorderErrorListChanged: 'The list changed while reordering. Reload and try again',
    reorderItem: 'Reorder {name}',
    orderListNoticeTitle: 'Want to reorder the items?',
    orderListNoticeBody: 'Enable this option to drag them and change their position.',
    orderListButton: 'Enable',
    orderListSuccess: 'List ordered. You can now drag the items',
    orderListError: 'The list could not be ordered. Try again',
    noItemsInList: 'No items in this list',
    searchForm: 'Search form',
    noFormsFound: 'No forms found',
    lastResponseSent: 'Last response sent using this list',
    selectedList: 'list selected',
    selectedLists: 'lists selected',
    importTitle: 'Import custom lists',
    importStep1: 'Step 1: Download the file',
    importStep1Desc: 'Download the example Excel. Make sure the fields marked with',
    importStep1Desc2: 'to import your file correctly.',
    importStep2: 'Step 2: Edit the file',
    importStep3: 'Step 3: Upload the file',
    importStep3Desc: 'Drag and drop your file here or select it from your computer.',
    downloadTemplate: 'Download example',
    exportList: 'Export list',
    dragDropExcel: 'Drag and drop your Excel here',
    browseComputer: 'browse',
    fileUploaded: 'Your file has been uploaded',
    fileNotLoaded: 'Your file could not be loaded',
    replaceFile: 'Replace',
    fileRequirements: 'File requirements',
    reqNameColumn: "'Name' column complete.",
    reqUniqueValues: "'Name' and 'Code' columns must have unique values.",
    reqMaxItems: 'Maximum 10,000 items per list.',
    assignListNames: 'Assign a name for each loaded list',
    formatError: 'Incorrect format. The file must be .XLSX or .CSV',
    multiSheetError:
      'The file contains multiple sheets. To import multiple lists, use the importer from the main lists page.',
    importing: 'Importing...',
    invalidListId: 'Invalid list ID',
    duplicateCodeError: "Code '{key}' is repeated {count} times",
    duplicateNameError: "Name '{key}' is repeated {count} times",
    templateExampleItem: 'Example item',
    templateExampleDesc: 'Example description',
    inYourComputer: 'on your computer',
    orPrefix: 'or',
    listNameLabel: 'List name',
    sheetLabel: 'Sheet',
    deleteConfirmTitlePlural: 'Delete {count} lists',
    deleteConfirmDescSingle: 'Are you sure you want to delete "{name}"?',
    deleteConfirmDescPlural:
      'Are you sure you want to delete {count} lists? This action cannot be undone.',
    deleting: 'Deleting...',
    form: 'form',
    forms: 'forms',
  },
  locations: {
    summary: {
      tabs: { summary: 'Location summary', info: 'Location information' },
      header: {
        copyLink: 'Copy location link',
        copyLinkSuccess: 'Location link copied',
        copyLinkError: 'Could not copy the link',
        edit: 'Edit',
        origin: 'Parent location',
        code: 'Code',
        subLocationsOne: '1 Sub-location',
        subLocationsOther: '{count} Sub-locations',
        scopedTo: 'Viewing: {name}',
      },
      dateFilter: { title: 'Filter by date' },
      viewAll: 'View all',
      dragToReorder: 'Drag to reorder',
      dragHandleAriaLabel: 'Reorder {name}. Press space and use the arrow keys.',
      inheritedLabel: 'Inherited',
      close: 'Close',
      seeMore: 'See {count} more',
      seeLess: 'See less',
      searchPlaceholder: 'Search',
      errorLoading: 'We could not load this block.',
      retry: 'Retry',
      accessDenied: 'You do not have access to this location.',
      blocks: {
        users: {
          title: 'Users',
          searchPlaceholder: 'Search by name or role',
          empty: 'There are no users in this scope.',
          emptySearch: 'No users found',
          emptySearchHint: 'Try searching with a different name.',
          noPermission: "You do not have permission to view this location's users.",
        },
        answers: {
          title: 'Form Responses',
          searchPlaceholder: 'Search by ID or form name',
          empty: 'There are no responses in this scope.',
          emptySearch: 'No responses found',
          emptySearchHint: 'Try searching with a different name.',
          editAnswer: 'Edit response',
          downloadPdf: 'Download PDF',
          noState: 'No state',
        },
        assets: {
          title: 'Assets',
          searchPlaceholder: 'Search by asset name or type',
          empty: 'There are no assets in this location.',
          emptySearch: 'No assets found',
          emptySearchHint: 'Try searching with a different name.',
          noMeter: 'Not applicable',
          noReading: '-',
          countOne: '1 asset',
          countOther: '{count} assets',
          columnAsset: 'Asset',
          columnLastMeasurement: 'Last measurement',
          noPermission: "You do not have permission to view this location's assets.",
        },
        tickets: {
          title: 'Tickets',
          searchPlaceholder: 'Search by ID or name',
          empty: 'There are no tickets in this scope.',
          emptySearch: 'No tickets found',
          emptySearchHint: 'Try searching with a different name.',
          createdBy: 'Created by {name}',
        },
        signatures: {
          title: 'Signatures',
          searchPlaceholder: 'Search by user or form name',
          empty: 'There are no signatures in this scope.',
          emptySearch: 'No signatures found',
          emptySearchHint: 'Try searching with a different name.',
          countOne: '{count}/{total} signature',
          countOther: '{count}/{total} signatures',
          showingLimited: 'Showing {shown} of {total}',
        },
        tasks: {
          title: 'Assigned tasks',
          searchPlaceholder: 'Search by ID or form name',
          overdue: 'Overdue',
          completed: 'Completed',
          empty: 'There are no assigned tasks in this scope.',
          emptySearch: 'No tasks found',
          emptySearchHint: 'Try searching with a different name.',
          dueToday: 'Today',
          daysRemainingOne: '1 day left',
          daysRemainingOther: '{count} days left',
          daysOverdueOne: '1 day ago',
          daysOverdueOther: '{count} days ago',
          showingLimited: 'Showing {shown} of {total}',
        },
        plannings: {
          title: 'Plannings',
          searchPlaceholder: 'Search by name or asset',
          empty: 'There are no plannings in this scope.',
          emptySearch: 'No plannings found',
          emptySearchHint: 'Try searching with a different name.',
          supervisorsCount: '{count} supervisors',
          showingLimited: 'Showing {shown} of {total}',
        },
      },
    },
    planLimits: {
      actionBlocked1: 'This action is blocked by the limits of your current plan.',
      actionBlocked2: 'Upgrade your plan to unlock it.',
    },
    nestableLocationsBanner: {
      title: 'Have you tried the new locations?',
      description:
        'Create hierarchical location lists for a more organized, precise operation with access control. ',
      link: 'Create locations',
    },
    title: 'Locations',
    searchPlaceholder: 'Search',
    header: {
      export: 'Export',
      import: 'Import',
      createPlace: 'Create location',
    },
    export: {
      success:
        'Locations exported successfully. We will email the file to you as soon as it is ready.',
      error:
        'Error exporting locations. Please try again or contact support if the problem persists.',
    },
    import: {
      title: 'Import Locations',
      description: 'Import locations from an Excel file',
      step1Title: 'Step 1: Download the file',
      step1Description: 'Use our Excel template to ensure your locations have the correct format',
      downloadExample: 'Download example',
      step2Title: 'Step 2: Complete the Excel',
      step2Description: 'Add your locations and sublocations following the example format.',
      step3Title: 'Step 3: Upload the file',
      step3Description: 'Drag and drop your file here or select it from your computer.',
      dragDropText: 'Drag and drop your Excel file here',
      browseText: 'or browse for file',
      replaceText: 'Replace',
      fileUploadedText: 'Your file has been uploaded',
      invalidFileType: 'Please select a valid Excel file (.xlsx)',
      importError: 'Error importing locations',
      importButton: 'Import',
      cancel: 'Cancel',
      importing: 'Importing...',
      importingDescription: 'Just a moment, we are organizing everything...',
      errorTitle: 'We detected an error.',
      errorMessage: 'Please check that your data has the correct format.',
      templateDownloadError: 'Failed to download template',
      downloadingTemplate: 'Downloading...',
      templateUrlV2:
        'https://s3-us-west-2.amazonaws.com/data-scope/templates/nestable_locations/import_template_en_v2.xlsx',
      instructions: {
        maxSheets: 'The file must contain no more than {maxSheets} sheets for location nesting',
        maxRows: 'The file must contain no more than {maxRows} rows per sheet',
        maxColumns: 'The file must contain no more than {maxColumns} columns per row',
        maxLengthSheetName: 'The sheet name must be no more than {maxLengthSheetName} characters',
        nestingSheetName: 'The nesting sheet name must be the name of the location being nested',
      },
      errors: {
        templateDownloadError: 'Failed to download template',
        invalidFileType: 'Please select a valid Excel file (.xlsx)',
        importError: 'Error importing locations',
        importButton: 'Import',
        cancel: 'Cancel',
        importing: 'Importing...',
        errorTitle: 'We detected an error.',
        errorMessage: 'Please check that your data has the correct format.',
      },
    },
    table: {
      locationName: 'Location name',
      users: 'Users',
      lastActivity: 'Last activity',
      actions: 'Actions',
      resultsCount: 'Results: {start}-{end} of {total}',
      loadMore: 'Load more locations',
      loadMoreError: 'Error loading more locations. Please try again.',
      noResults: 'No results found',
    },
    row: {
      location: 'Location',
      locations: 'Locations',
      selected: 'selected',
      selected_plural: 'selected',
      address: 'Address: ',
      phone: 'Phone: ',
      viewLocation: 'View location',
      users: 'users',
      today: 'Today',
      sublocation: 'Sublocation',
      sublocations: 'Sublocations',
      sublocationTooltip:
        'To create more sublocations you need a higher plan. Upgrade your plan and unlock this and other features',
      viewDetails: 'View details',
      edit: 'Edit',
      delete: 'Delete',
      view: 'View location',
      deselectAll: 'Deselect all',
      selectAll: 'Select all',
    },
    deleteConfirmation: {
      title: 'Are you sure you want to delete this location?',
      message:
        'The location and all its sublocations will be deleted, but responses, signatures and issues will not be lost.',
      confirmButton: 'Delete',
      cancelButton: 'Cancel',
      success: 'Location deleted successfully',
      error: 'Error deleting location',
    },
    create: {
      title: 'Create location',
      success: 'Location created successfully',
      error: 'Error creating location',
    },
    update: {
      title: 'Update location',
      success: 'Location updated successfully',
      error: 'Error updating location',
    },
    form: {
      displayDescription: 'Location information',
      createDescription: 'Create new location',
      updateDescription: 'New location',
      sections: {
        locationInfo: 'Location Information',
        contactInfo: 'Contact Information',
        ubication: 'Location',
      },
      name: {
        label: 'Name',
        placeholder: 'Enter location name...',
        required: 'Location name is required',
        maxLength: 'Name must be 1000 characters or less',
      },
      code: {
        label: 'Location code',
        placeholder: 'Enter location code...',
        required: 'Location code is required',
        maxLength: 'Code must be 255 characters or less',
        tooltip: 'Optional. If left empty, a unique code will be generated automatically.',
      },
      type: {
        label: 'Location type',
        required: 'Location type is required',
        placeholder: 'Select the type of facility you are creating...',
        options: {
          plant: 'Plant',
          enterprise: 'Enterprise',
          warehouse: 'Warehouse',
          production_line: 'Production Line',
          office: 'Office',
          branch: 'Branch',
          distribution_center: 'Distribution Center',
          other: 'Other',
        },
      },
      origin: {
        label: 'Origin',
        required: 'Location origin is required',
        placeholder: 'Select an existing location to associate...',
        tooltip:
          'By choosing an Origin location, this new location will be placed within another one, forming part of a structure.',
        options: {
          main: 'Main Location',
          subsidiary: 'Subsidiary',
          remote: 'Remote Location',
          temporary: 'Temporary Location',
          partner: 'Partner Location',
        },
      },
      phone: {
        label: 'Phone',
        placeholder: 'Enter phone number...',
        validation: {
          missingCountryCode: 'Number must include country code (e.g. +1)',
          invalidCountryCode: 'Invalid country code',
          invalidFormat: 'Invalid number format',
          invalidLength: 'Invalid number length for this country',
        },
      },
      description: {
        label: 'Description',
        placeholder: 'Enter description...',
        helper: 'Optional details for this location',
        validation: {
          tooLong: 'Description must be 1000 characters or less',
        },
      },
      users: {
        title: 'Users and groups',
        label: 'Users',
        placeholder: 'Enter users information...',
        helper: 'Add information about users assigned to this location',
        showLess: 'Show less',
        showAll: 'Show all',
      },
      emails: {
        label: 'Emails',
        placeholder: 'Enter email addresses...',
        helper: 'Add relevant email addresses for this location',
        inputHint: 'Separate emails with commas or press Enter',
        validation: {
          tooMany: 'Maximum character limit exceeded.',
        },
      },
      coordinates: {
        fetchAddressError: 'Could not retrieve address for the entered coordinates.',
        latitude: {
          label: 'Latitude',
          invalid: 'Latitude must be between -90 and 90.',
          placeholder: 'Enter latitude...',
        },
        longitude: {
          label: 'Longitude',
          invalid: 'Longitude must be between -180 and 180.',
          placeholder: 'Enter longitude...',
        },
      },
      ubication: {
        label: 'Location',
        search: 'Search direction',
        hideMap: 'Hide map',
        showMap: 'Show map',
        placeholder: 'Enter location address...',
        address: 'Address',
        city: 'City',
        region: 'State/Region',
        country: 'Country',
        postalCode: 'Postal Code',
        noLocationsFound: 'No locations found',
        clearData: 'Clear data',
        optionalLabel: 'Optional',
        coordinatesInfoTooltip:
          'You can enter the location by searching for an address or by manually entering latitude and longitude coordinates. Both options are valid.',
      },
      buttons: {
        create: 'Create',
        creating: 'Creating…',
        update: 'Update',
        updating: 'Updating…',
        cancel: 'Cancel',
      },
    },
    emptyState: {
      noLocations: 'No locations found',
      suggestion: 'Try different keywords or check your spelling',
      noLocationsCreated: "You don't have any locations created yet",
      createNewLocation: 'Create a new location',
      migration: {
        title: "Still haven't migrated your locations?",
        description: 'Now you can group your locations by type and view everything in one place.',
        button: 'Migrate my locations',
        close: 'Close',
        imgAlt: 'Representation of a worker with a calendar, a checklist and a PC floating around',
        viewTitle: 'Migrate your locations to the new structure',
        backButton: 'Back to locations',
        whyMigrate: 'Why migrate?',
        reason1Title: 'Gather all recent activity in one place:',
        reason1Description: 'issues, completed forms, signatures, users and associated groups.',
        reason2Title: 'Organize your spaces:',
        reason2Description:
          'adding up to four sublevels per location, to represent how your sites really work.',
        reason3Title: 'Easily decide which users or groups can view and work in each location.',
        reason3Description: 'Users will only see the locations they have been assigned to.',
        stepsTitle: 'Step by step to migrate your locations',
        step1Title: 'Use your current locations as a base',
        step1Description:
          'Download an Excel with the locations you already have in DataScope from here and use it as a base to complete the template and save time.',
        step2Title: 'Download the template',
        step2Description:
          'Use our Excel template to ensure your locations are loaded correctly. In the first sheet you define all locations. If you need hierarchy, create additional sheets to assign sublocations.',
        step3Title: 'Upload the new template to the platform',
        step3Description:
          'When you complete the template, import it here to update your locations with the new structure.',
        faqTitle: 'Frequently asked questions',
        faq1Question: 'What will happen to my previously created locations?',
        faq1Answer:
          'Old locations will continue to work for a while. We will soon begin a gradual closure process to make way for the new location structure.',
        faq2Question: 'Can I still access the old locations?',
        faq2Answer:
          'Yes! You will still be able to access your old locations. They will remain in the same place, they will only change their name to List (Old locations) to differentiate them from the new ones.',
        faq3Question: 'Will my previous forms continue to work?',
        faq3Answer:
          'Yes, forms created with old locations will remain active. In the form builder you will clearly see the old locations differentiated from the new ones.',
        faq3Gif:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/locations/old_locations_en.gif',
        faq4Question: 'How do I assign locations to users?',
        faq4Answer:
          'For new Locations you can assign users individually from the Users section. For bulk assignments, download and upload the user Excel.',
        faq5Question: 'Can I associate a form with multiple locations?',
        faq5Answer:
          'Yes, as long as the locations are on the same hierarchical level. It is not possible to associate a form with locations of different levels.',
        faq6Question: 'Can I use the new locations without having migrated all the previous ones?',
        faq6Answer:
          'Yes, you can migrate partially, as long as the parent locations are already created on the platform. Old locations will continue to work while you complete the migration.',
        faq7Question: 'How do I identify if a location has already been migrated?',
        faq7Answer:
          'In the locations table you will be able to see which sublocations were migrated under each parent location. If any error occurs during migration, we will notify you directly in the process.',
        helpTitle: 'Questions or need help?',
        helpDescription:
          'If you have questions about the process, contact us and we will help you complete the migration.',
        helpButton: 'Request help',
        accessBanner: 'All users will have access to the locations you migrate',
        bannerImageUrl:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/locations/location-migration-banner-en.png',
        modal: {
          title: 'Migrate your locations',
          step1: 'Step 1: Use your existing locations as a base',
          step1Description:
            'If you already have locations created in DataScope, you can download them and use them as a base to complete the template.',
          downloadExistingButton: 'Download your existing locations',
          downloading: 'Downloading...',
          step2: 'Step 2: Download the template',
          step2Description:
            'Use the template format to ensure your locations are loaded correctly.',
          downloadTemplateButton: 'Download the template',
          step3: 'Step 3: Upload your file',
          step3Description:
            'When you have the template ready, upload it here to migrate your locations.',
          cancel: 'Cancel',
          migrateButton: 'Migrate locations',
          migrating: 'Importing...',
          exportSuccess: 'Locations exported successfully',
          exportError: 'Error exporting locations',
          helpAccordion: {
            title: 'How does the template work?',
            videoTitle: 'Step-by-step video',
            videoPlaceholder: '0:00 / 0:10',
            videoUrlV2:
              'https://fast.wistia.net/embed/iframe/9tbrdiuq6r?web_component=true&seo=true',
            fileStructureTitle: 'File structure:',
            fileStructure1: 'Import sheet:',
            fileStructure1Description:
              'Here you import all your locations and sublocations from a single file.',
            fileStructure2: 'Do you want a location to have sublocations?',
            fileStructure2Description:
              'In the Source Location column, enter the location they belong to.',
            fileStructure3: 'Remember to complete the required fields:',
            fileStructure3Description: 'Name and Location Type.',
            fileStructure4: 'Latitude and longitude optional:',
            fileStructure4Description:
              'You can obtain them by searching the address on Google Maps or from',
            fileStructure4Link: 'here',
            fileStructure4Note: 'Use the same location to avoid import errors.',
            technicalLimitsTitle: 'Technical limits for importing:',
            technicalLimit1: 'You can import up to 2,500 locations per file.',
          },
        },
      },
      utility: {
        title: 'Structure and control your operation with locations',
        preConfigTitle: 'For what does locations serve?',
        utilityTitle1: 'Centralize information:',
        utilityDescription1:
          'gather all recent activity, including issues, forms, signatures and users, in one place.',
        utilityTitle2: 'Create place hierarchies:',
        utilityDescription2:
          'add up to four sublocations per place to represent the real structure of your operations.',
        utilityTitle3: 'Assign access easily:',
        utilityDescription3: 'define which users can view and work in each place.',
      },
      reasons: {
        title: 'Why use locations?',
        cardTitle1: 'Flexible structure',
        cardDescription1: 'Adapt the place levels to how your operation works in the real world.',
        cardTitle2: 'Information by levels and types',
        cardDescription2:
          'You can view and manage forms, issues, users and signatures associated with each place.',
        cardTitle3: 'Assign users in each place',
        cardDescription3: 'Assign responsible users to each location.',
      },
      carousel: {
        title: 'Create your first location',
        gifAlt: 'Demostration gif for creating locations',
        step1Title: 'Create location',
        step1Description:
          'Create a location by clicking Create location and define a name, level of place, its type and if applicable, associate it with an existing one.',
        step2Title: 'Complete the data',
        step2Description:
          'Add a phone number, email and a brief description will help you identify it later.',
        step3Title: 'Add the location',
        step3Description:
          'Enter the address and extra details to better identify it on the map. To finish, click Create.',
        nextStep: 'Next',
        previousStep: 'Previous',
      },
      legacy: {
        title: 'Legacy locations (Temporary)',
        description:
          'You can still access them here, although they are not compatible with all new functionalities',
        button: 'View legacy locations',
      },
      createNewTitle: 'Create a new way to organize your operation',
      oldLocationsTitle: 'Your locations are old.',
      oldLocationsDescription: 'Create new ones and take advantage of the benefits',
      createButton: 'Create locations',
      selectorEmptyIllustrationAlt: 'Illustration of the locations empty state',
      noLocationsAvailable: 'No locations available',
      searchPlaceholder: 'Search locations...',
      loadingLocations: 'Loading locations...',
    },
  },
  tasksForms: {
    activateScroll: 'Activate scroll in the app',
    disableScroll: 'Disable scroll in the app',
    scrollActiveSuccess: 'Scroll activated successfully',
    scrollDisabledSuccess: 'Scroll disabled successfully',
    templates: 'Forms Templates',
    useTemplate: 'Use template',
    newVersion: 'Switch to new version',
    oldVersion: 'Switch to old version',
    uniq: 'Question name must be unique',
    title: 'Forms',
    preview: 'Preview',
    export: 'Export',
    export_help: 'You can copy this source code and paste into another form',
    import: 'Import',
    import_confirm: 'Are you sure you want to import this form?',
    importSuccessSync: 'Your form was imported successfully',
    import_success: 'Your form is being imported,  it can take some minutes',
    start_testing: "It's time to test your first form!",
    test_button: 'Test form',
    start_testing_desc:
      'Congrats you have a new form. Now you can start testing it on our mobile App.',
    import_error:
      "Failed to import the form. Please check if it's a valid form or is already imported.",
    clone: 'Duplicate',
    default_title: 'My Form',
    default_question: 'Question',
    drag_questions:
      "You don't have questions in your form yet, drag and drop the questions you want here",
    new: 'New form',
    new_ai: 'Form with AI',
    google_forms: 'Import Google Form',
    are_you_sure: 'Are you sure?',
    status: 'Status',
    active: 'Published',
    inactive: 'Unpublished',
    publish: 'Publish',
    unpublish: 'Unpublish',
    last_info: 'Add HTML at the end of PDF',
    current_logo: 'Current form Logo',
    form_logo: 'Form Logo',
    form_name: 'Name',
    // Labels of the Status sort control of the paginated forms tables. Ascending
    // is active forms first, matching the service.
    sortByStatus: {
      unsorted: 'Sort by status',
      ascending: 'Active forms first',
      descending: 'Hidden forms first',
    },
    actions: 'Configure',
    answer_form: 'Fill Out',
    edit_app: 'Configure Form',
    edit_share: 'Share',

    delete: 'Delete',
    error_form: 'There was an error',
    success_form: 'Success',
    date: 'Date/Time',
    date_type: 'Date Type',
    date_type_date: 'Date',
    date_type_datetime: 'Datetime',
    date_type_time: 'Time',
    text: 'Text',
    number: 'Number',
    multi_option: 'Single Choice',
    signature: 'Signature',
    barcode: 'Scanner',
    photo: 'Photo',
    select_metadata: 'Single Option Data',
    select_option_metadata: 'Checklist',
    track_code: 'Tracking Code',
    static_text: 'Static Text',
    select_check_metadata: 'Checkbox',
    select_number_metadata: 'Number Data',
    select_text_metadata: 'Text Data',
    table: 'Group of Repeatable Fields',
    name: 'Question Title',
    description: 'Question Descriptions',
    label: 'Question Section Name',
    choices: 'Choices',
    choice: 'Choice',
    add_choice: 'Add Choice',
    list_values: 'List Values',
    add_list_value: 'Add List Value',
    add_question: 'Add Question',
    delete_choice: 'Delete',
    drop_question: 'Drop repeatable-questions here',
    metadata_type: 'Data List Source',
    create_metadata: 'Create New Data List Source',
    change_metadata: 'Change Data List Source',
    save_form: 'Save Form',
    version: 'version',
    no_name: 'No Name',
    no_questions: 'Must have at least one question',
    no_data: 'No forms available',
    blank_table: 'SubForm must to have',
    sub_questions: 'Sub Questions',
    disable_gallery: 'Disable Gallery',
    required: 'Required',
    back: 'Back',
    location: 'List of Locations',
    help_title: 'Need help creating your form?',
    help_instruction: 'Request form creation',
    help_description:
      '***Please explain the information you want to gather and attach a picture of the form you want to convert mobile',
    example_title_1: 'Build Your Own Digital Forms',
    example_description_1:
      "With the Form Builder you can create perfect forms. It's easy, intuitive, and powerful.",
    success_created: 'Task form was successfully created.',
    hide_logic: 'Skip question based on answer',
    show_price: 'Show price',
    show_avg: 'Show Average',
    show_factor: 'Show Multiplication',
    show_percent: 'Show percent',
    equal: 'Equal',
    not_equal: 'Not Equal',
    if: 'IF',
    is: 'IS',
    to: 'TO',
    go_to: 'GO TO',
    next_question: 'Next Question',
    finish_form: 'Finish Form',
    standard_pdf: 'Standard PDF',
    customized_pdf: 'Customized PDF',
    open_editor: 'Open PDF Editor',
    own_pdf: 'Build your own PDF Layout',
    need_your_pdf: 'Need your own PDF design?',
    pdf_description:
      'The most flexible PDF Builder to create your own documents with the data collected',
    folders: 'Folders',
    manage_folders: 'New folder',
    manage_states: 'Form states',
    view_all_folders: 'View All Folders',
    searchSend: 'Search',
    searchForm: 'Search forms...',
    custom_pdf: {
      step1: 'New template',
      step1_desc:
        'First step is to create your own template using the PDF editor. Is possible to use all the questions of the form. The last answer will be used as example.',
      step2: 'Activate template',
      step2_desc:
        'Next step is to activate the template when is ready. When you activate this, all the new PDFs are going to be generated with this format.',
    },
    help: {
      multi_option: 'Select alternatives into fixed options provided by you',
      select_metadata: 'Select one item of a custom list',
      select_option_metadata: 'Select fixed alternatives for each item of a custom list',
      track_code: 'Provide the option to change or select the tracking code of each form',
      static_text: 'Add static text (Form Instructions)',
      select_check_metadata: 'Check multiple items of a custom list',
      select_number_metadata: 'Select a number for multiple items of a custom list',
      select_text_metadata: 'Select a text for multiple items of a custom list',
      table:
        'Create loops for a specific set of questions that can be answered as many times as needed',
      description:
        'Longer text to show in the App. Does not appear when exporting data. (Optional)',
      title: 'Short title to identify the question. Appears when exporting data.',
    },
    share: {
      title: 'Generate Link Google Forms',
      link: 'Link:',
      edit_link: 'Edit Google Form',
      export: 'Export Google Form',
      sendgrid_template_id: 'd-6603328bc6e14ab284a0bee8ba373651',
      inactive_public_form: 'This form is no longer accessible using this link.',
      success_message: 'We have received your answer correctly',
      make_form_private: 'Remove public access to this form',
      make_form_private_notice:
        'This form is now private. Previously shared public links are now invalid.',
      make_form_public: 'Make this form public',
      make_form_public_notice:
        'This form is now public. You can now share it with people outside your organization!',
      share_via_email: 'Share this form with an email ',
      share_email_tooltip:
        'A public link, accessible to anybody, will be sent to those emails that are not associated with this account. A private use link will be sent to those emails that belong to registered users of this account.',
      share_public_link: 'Share this form with a public link',
      share_public_link_tooltip:
        'Anyone, registered users and non-registered persons alike, will be able to fill out this form if you share the public link with them. Their answers will be registered under the name of a generic user, webforms_user_',
      share: 'Share',
      copy: 'Copy',
      trigger: 'Trigger not installed. Limit of 20 Reached.',
      loading: 'Loading Form...',
      failed: 'Exporting Form Failed.',
      auth: "TIP: 'If you have problems, try logging out of all your Google Accounts (from google.com), and then login with the account you want the form to be exported to.'",
      add_all_permissions: 'Add this form to all users',
      permission_success:
        'Permission added to all users, you need to logout and login again in the App to refresh forms',
    },
    delete_form_confirm: 'Are you sure you want to delete the form?',
    delete_form_warning: 'Once deleted it cannot be recovered',
    delete_form_success: 'Form deleted successfully',
    delete_form_failure: 'Form deletion failed',
    clone_form_success: 'Form duplicated successfully',
    clone_form_failure: 'Form duplication failed',
    publish_form_success: 'Form published successfully',
    publish_form_failure: 'Form publication failed',
    unpublish_form_success: 'Form unpublished successfully',
    unpublish_form_failure: 'Form unpublishing failed',
    rename: 'Rename',
    rename_folder: 'Rename folder',
    folder_name: 'Folder name',
    new_name: 'New name',
    update: 'Update',
    cancel: 'Cancel',
    rename_success: 'Folder renamed successfully',
    rename_failure: 'Folder renaming failed',
    delete_folder_confirm: 'Are you sure you want to delete the folder ',
    delete_warning: 'Once the folder is deleted, all forms inside will be moved to "Forms" table',
    delete_folder_success: 'Folder deleted successfully',
    delete_folder_failure: 'Folder deletion failed',
    move_to_folder: 'Move to folder',
    lockEditing: 'Lock editing',
    unlockEditing: 'Enable editing',
    unlockEditingSuccess: 'Form enabled successfully for editing',
    unlockEditingFailure: 'Failed to enable form for editing',
    editingLocked: 'Editing Locked',
    editingLockedBy: 'Editing locked by:',
    unknownUser: 'Unknown User',
    lockEditingConfirmModal: {
      title: 'Lock form editing',
      message:
        'If you lock it, no one else will be able to edit this form. Only you or support can unlock it.',
      confirmButton: 'Lock',
      cancelButton: 'Cancel',
      successMessage: 'Form locked successfully for editing',
      failureMessage: 'Failed to lock form for editing',
    },
    remove_from_folder: 'Remove from folder',
    move: 'Move',
    warn_empty_folder: 'This action will delete the folder as it would leave it empty.',
    move_form_success: 'Form moved successfully',
    move_forms_success: 'Forms moved successfully',
    move_form_failure: 'Form movement failed',
    move_forms_failure: 'Form movement failed',
    create: 'Create',
    create_form_folder: 'Create form folder',
    create_folder_success: 'Folder created successfully',
    create_folder_failure: 'Folder creation failed',
    how_to_create_folder: 'How do you want to create your folder?',
    next: 'Next',
    form_selection: 'Form selection',
    no_forms_available: 'No forms available at this moment',
    forms: 'Forms',
    form: 'form',
    bulk_action: {
      publish: {
        confirm: 'Are you sure you want to publish',
        info: 'Once published, you can unpublish them again.',
        success: 'Forms published successfully',
        failure: 'Forms publication failed',
      },
      unpublish: {
        confirm: 'Are you sure you want to unpublish',
        info: 'Once unpublished, you can publish them again.',
        success: 'Forms unpublished successfully',
        failure: 'Forms unpublishing failed',
      },
      delete: {
        confirm: 'Are you sure you want to delete',
        info: 'Once deleted, they cannot be recovered.',
        success: 'Forms deleted successfully',
        failure: 'Forms deletion failed',
      },
    },
    formResults: 'Results: ',
    formResultsOf: 'of',
    current_folder: 'Current folder:',
    formLimitReachedTooltip: 'You have reached the form limit. ',
    upgradePlanTooltipLink: 'Upgrade your subscription',
    upgradePlanTooltip: ' to create forms',
    importPermissionError: 'You do not have permission to import templates.',
    projectLimitReachedError:
      'There was an error importing the form. You have reached the maximum number of allowed forms.',
    folder: 'Folder',
    new_form_create: 'Form',
    form_ai: 'Form with AI',
    forms_limit: {
      title: 'Forms limit reached',
      description:
        'You have reached the limit of 3 forms in your current plan. To create more forms, upgrade your plan and access more features:',
      benefit1: 'Unlimited forms',
      benefit2: 'More customization options',
      benefit3: 'Greater storage capacity',
      confirm: 'Unlock more forms now',
      cancel: 'Continue with free version',
      confirm_chat_message: 'Hello, I need to create more forms. How can I upgrade my plan?',
    },
  },
  mobileUsers: {
    users: 'Users',
    new: 'New User',
    import: 'Import',
    import_users: 'Import Users',
    how_import: 'How to Import users?',
    bulk_actions: 'Bulk Actions',
    add_users_to_group: 'Add users to group',
    deactivate_users: 'Deactivate users',
    add: 'Add',
    add_to_group: 'Add to group',
    selectAGroup: 'Select a group',
    identifier_help: 'Needed to sign in in the mobile and web app',
    advanced: 'Advanced Config',
    location_perm: 'Location Permissions',
    forms_perm: 'Forms Permissions',
    activated: 'Activated',
    you: 'You',
    deactivated: 'Deactivated',
    modifications_history: 'History',
    duplicate_user:
      'A deleted User with same email already exists. Please reactivate that user instead',
    old_password_required: 'not valid. For changing admin password confirmation required.',
    group_users: 'User Groups',
    group_new: 'New Group',
    noGroups: 'You have no user groups',
    infoNotice: "Users will only have access to their groups' forms and answers",
    delete_group: 'Delete group',
    cancel: 'Cancel',
    delete: 'Delete',
    rename: 'Rename',
    rename_group: 'Rename group',
    group_name: 'Group Name',
    new_name: 'New Name',
    update: 'Update',
    confirm_group_delete: 'Are you sure you want to delete user group ',
    confirm_group_delete2:
      'Once it has been deleted, users left without a group will go back to their individually assigned permissions.',
    update_groups_success: 'Changes saved successfully',
    update_groups_error: 'An error occurred while saving changes',
    userInfo: 'User Information',
    userGroupsHelp: 'This user belongs to the following groups:',
    manageGroupModalTitle: 'Permissions in',
    searchForm: 'Search form...',
    searchUser: 'Search user...',
    groupUpdateSuccess: 'Group updated successfully',
    permissions_title: 'Permissions',
    forms_title: 'Forms',
    group_name_exists: 'Group name already exists',
    edit_group_permissions: 'Form Permissions',
    edit_groups: 'Assign to a group',
    save: 'Save',
    editGroupsInfo:
      'Users assigned to one or more groups will be granted permissions to access the forms of those groups. Consequently, they will not be able to have individually assigned forms at the same time.',
    modifiedGroup: 'Modified Group',
    modificationAuthor: 'Modified by',
    modificationDate: 'Date',
    modification: 'Modification',
    added: 'Added',
    removed: 'Removed',
    group: 'Group',
    createdGroup: 'Created Group',
    deletedGroup: 'Deleted Group',
    renamedGroup: 'Renamed Group',
    emptyHistory: 'No history available',
    previousName: 'Previous Name',
    assetAssigned: 'Permission assigned to asset',
    assetRemoved: 'Permission removed from asset',
    removeFromGroup: 'Remove from group',
    remove: 'Remove',
    removeUsersConfirm: 'Are you sure you want to remove',
    removeUsersConfirm2: 'user(s) from group',
    onceUsersRemoved:
      'Once users are removed, they will be kept in other groups where they belong or stay as users without group.',
    noUsersInGroup: "You haven't added any users to this group yet",
    searchGroups: 'Search for groups...',
    pendingConfirmationTitle: 'Pending confirmation',
    pendingConfirmationSubtitle: 'Share this link only with this user',
    copy: 'Copy',
    linkCopied: 'Link copied!',
    resendInvitation: 'Resend',
    deleteGroupPendingSignatureError: 'Group has pending signatures',
    invite_user: {
      title: 'Invite Users',
      placeholder: 'example@example.com',
      help: 'If you want to change user permissions, click on configure permissions',
      btn: 'Invite',
      config: 'Configure permissions',
      successSingular: 'Invitation successfully sent',
      successPlural: 'Invitations successfully sent',
      error: 'Failed to invite users, please check that the emails are valid and not used before',
      emailFormatError: 'Wrong email format, please follow example@example.com',
      emails: 'Emails',
    },
    permissions: {
      answers: 'Show Form Answers',
      evaluate: 'Allow to change status of form answers',
      chat: 'Chat',
      tasks: 'Answer Forms',
      assigned: 'View Assigned Forms',
      users: 'Show and Create Users',
      export: 'Export Data',
      metadata: 'Create List of Custom Data',
      modify: 'Modify Form Answers',
      edit_forms: 'Edit Forms',
      evaluate_delete: 'Delete/Recover Form Answers',
      access_to_charts: 'Access to charts',
      admin_account_config: 'Manage account configuration',
      admin_signatures: 'Manage signatures',
      admin_findings: 'Manage issues',
      admin_assets: 'Manage assets',
      admin_places: 'Manage places',
      assign_new_places: 'Assign new places automatically',
    },
    roles: {
      customized: 'Customized',
      administrator: 'Administrator',
      superadmin: 'Account Owner',
      supervisor: 'Supervisor',
      editing_operator: 'Editing-enabled operator',
      operator: 'Operator',
    },
    table: {
      name: 'Name',
      user: 'User',
      role: 'Role',
      lastConnection: 'Last Connection',
      noLastConnection: 'Last Connection not available',
      actions: 'Actions',
      configure: 'Configure',
      edit: 'Edit',
      deactivate: 'Deactivate',
      activate: 'Activate',
      no_data: 'No users available',
      groups: 'Groups',
      viewMore: 'View more',
      noForms: 'This user group has no assigned forms',
      not_confirmed: 'Confirmation pending',
    },
    logs: {
      user: 'Modified User',
      author: 'Modification Author',
      date: 'Date',
      modification: 'Modification',
      activated: 'Activated',
      deactivated: 'Deactivated',
    },
    deactivation: {
      cancel: 'Cancel',
      confirmationTitle: 'Are you sure you want to deactivate this user?',
      revokesAllTitle: 'This removes their access to ALL of their accounts',
      revokesAllMessage:
        'Their login lives in this account, so deactivating them here locks them out of the other %{count} accounts they work in, not just this one. They will not be able to undo it themselves.',
      revokesAllMessageNoCount:
        'Their login lives in this account, so deactivating them here locks them out of every other account they work in, not just this one. They will not be able to undo it themselves.',
      confirmationMessage:
        'Data will not be lost. You can activate the user again in the Deactivated section.',
      bulkConfirmationTitle: 'Are you sure you want to deactivate',
      bulkConfirmationMessage:
        'Data will not be lost. You can activate them again in the Deactivated section.',
      bulkRevokesAllTitle: 'Some of them lose access to ALL of their accounts',
      bulkRevokesAllMessageOne:
        'One of the users you selected has their login in this account (%{emails}). Deactivating them here locks them out of every other account they work in, and they will not be able to undo it themselves.',
      bulkRevokesAllMessage:
        '%{count} of the users you selected have their login in this account (%{emails}). Deactivating them here locks them out of every other account they work in, and they will not be able to undo it themselves.',
      bulkRevokesAllMore: 'and %{count} more',
      bulkImpactPartial:
        'We could only check the first %{count} of the selected users, so there may be more.',
      bulkImpactUnavailable:
        'We could not check whether any of them lose access to their other accounts.',
      impactUnavailable:
        'We could not check whether this removes their access to all of their accounts.',
      success: 'User(s) deactivated successfully',
      error: 'There was an error deactivating the user(s)',
    },
    activation: {
      error: 'There was an error activating the user',
    },
    createUser: {
      information: {
        title: 'Information',
        name: 'Name',
        lastName: 'Last Name',
        email: 'Email',
        example: 'example@example.com',
        password: 'Password',
        passwordHelper: 'Password must be at least 6 characters long',
        emailBelongsToIdentity:
          'This user already has a DataScope account. They will sign in with their own credentials',
        phone: 'Telephone',
      },
      group: {
        title: 'Group',
        selectHelper: 'Select an existing group (you can choose more than one)',
        noGroup: 'Without group',
        newGroup: 'New group',
        newGroupHelper: 'Write the name of the group',
        newGroupSuccess: 'New Group created successfully!',
        newGroupError: 'There was an error creating the new group',
        configuration: 'You must configure form permissions for this group',
        formsHelp: 'Forms that this user will have access to:',
        cantEditPermissions:
          'You cannot change your own group permissions. Have someone else do it if you want to change them.',
      },
      forms: {
        title: 'Forms',
        allForms: 'Forms',
        addForm: 'Add form',
        formsHelper: 'The user will only see the forms (and answers) you select. ',
        formsHelperDisabled: 'The user will only see these forms (and answers). ',
        formsGroupHelper:
          'The forms and places to which this user will have access are those belonging to the previously chosen groups.',
        seeMore: 'see more',
        groupsAlert: 'You cannot add forms because you assigned or created a group previously',
        back: 'Back',
        folders: 'Folders',
        close: 'Close',
        formHasPendingSignature:
          "This user has pending signatures. You won't be able to modify the permissions until they are responded to or deleted.",
        massSelectionBlockedByPendingSignature:
          'Mass selection is disabled due to pending signatures',
        foldersBlockedByPendingSignature:
          'Folder selection is disabled due to pending signatures. Open the folder to select forms.',
        cantEditPermissions:
          'You cannot change your own form permissions. Have someone else do it if you want to change them.',
      },
      permissions: {
        title: 'Permissions',
        editingMyself:
          'You cannot change your own permissions. Have someone else do it if you want to change them.',
        basic: {
          title: 'Basic',
          viewFormAnswers: 'View Form Answers',
          chat: 'Chat',
          submitFormAnswers: 'Answer Forms',
          viewAssignedForms: 'View Assigned Forms',
        },
        advanced: {
          title: 'Advanced',
          changeFormStatus: 'Change status of forms',
          createMetadata: 'Create Lists of Custom Data',
          editFormAnswers: 'Edit Form Answers',
          editForms: 'Edit Forms',
          evaluateDelete: 'Delete and recover form responses',
          accessToCharts: 'Access to charts',
          assignNewPlaces: 'Assign new places automatically',
        },
        admin: {
          title: 'Administration',
          viewAndCreateUsers: 'View and Create Users',
          exportData: 'Export Data',
          adminAccountConfig: 'Manage account configuration',
          adminSignatures: 'Manage signatures',
          adminFindings: 'Manage issues',
          adminAssets: 'Manage assets',
          adminPlaces: 'Manage places',
        },
        editFormsTooltip1: 'This user does not have permission to edit forms. ',
        editFormsTooltipLink: 'Upgrade your subscription',
        editFormsTooltip2: ' and unlock full productivity for your team!',
      },
      locations: {
        title: 'Locations (Optional)',
        helper:
          'When this option is activated, the user will only see the forms associated to the selected locations',
        locations: 'locations',
        andOthers: ', and others...',
        cantEditPermissions:
          'You cannot change your own location permissions. Have someone else do it if you want to change them.',
        allLocationsAccessBanner:
          'This user has access to all existing locations. If you want to restrict the locations they can see, you must manually select them from this section.',
        allNewLocationsAccessBadge: 'Access to all new locations',
      },
      signature: {
        name: 'Full Name',
        companyName: 'Company Name',
        pronoun: 'Your',
        userIdNumber: {
          default: 'National ID Number',
          CL: 'RUT',
          PE: 'DNI',
          MX: 'CURP/RFC',
          CO: 'CC',
          AR: 'DNI',
          PY: 'CI',
          ES: 'DNI/NIE',
          BR: 'CPF',
          UY: 'CI',
          BO: 'CI',
          EC: 'Cedula',
          VE: 'National ID Card',
          US: 'SSN/DL/PP/ID',
          CA: 'SIN',
          DO: 'National ID and Electoral Card',
          CR: 'Cedula',
          PA: 'Cedula',
          GT: 'DPI',
          SV: 'DUI',
          HN: 'DNI',
          NI: 'Cedula',
          PR: 'SSN',
          CU: 'CI',
          JM: 'TRN',
          PT: 'NIF',
          FR: 'INSEE',
          DE: 'Personalausweisnummer/Steuer-ID',
          IT: 'Codice Fiscale',
          GB: 'National Insurance Number',
          IE: 'PPS Number',
          NL: 'BSN',
          BE: 'National Number',
          CH: 'AHV Number',
          AT: 'Social Security Number',
          SE: 'Personal Number',
          NO: 'National ID',
          DK: 'CPR Number',
          FI: 'Personal Identity Code',
          IS: 'Kennitala',
          PL: 'PESEL',
          CZ: 'Birth Number',
          SK: 'Birth Number',
          HU: 'Tax Number',
          RO: 'CNP',
          BG: 'EGN',
          GR: 'AMKA/AFM',
          HR: 'OIB',
          SI: 'EMSO',
          RS: 'JMBG',
          BA: 'JMBG',
          ME: 'JMBG',
          MK: 'EMBG',
          MT: 'ID Card',
          CY: 'ID Number',
          LU: 'National ID',
          LT: 'Personal Code',
          LV: 'Personal Code',
          EE: 'Personal Code',
          TR: 'TC Kimlik No',
          IL: 'ID Number',
          SA: 'National ID',
          AE: 'Emirates ID',
          QA: 'QID',
          KW: 'Civil ID',
          BH: 'CPR',
          OM: 'Civil ID',
          JO: 'National ID',
          LB: 'ID Number',
          EG: 'National ID',
          MA: 'CIN',
          TN: 'CIN',
          DZ: 'National ID',
          ZA: 'ID Number',
          NG: 'NIN',
          KE: 'ID Number',
          GH: 'Ghana Card',
          UG: 'National ID',
          TZ: 'NIDA',
          RW: 'National ID',
          BW: 'Omang',
          NA: 'ID Number',
          ZM: 'NRC',
          ZW: 'National ID',
          ET: 'National ID',
          CN: 'National ID',
          IN: 'Aadhaar',
          PK: 'CNIC',
          BD: 'NID',
          JP: 'My Number',
          KR: 'RRN',
          SG: 'NRIC/FIN',
          MY: 'MyKad',
          ID: 'KTP',
          PH: 'UMID',
          TH: 'National ID',
          VN: 'CCCD',
          HK: 'HKID',
          TW: 'National ID',
          LK: 'NIC',
          NP: 'National ID',
          AU: 'TFN/Medicare',
          NZ: 'IRD Number',
          RU: 'SNILS',
          UA: 'Tax Number',
          BY: 'National ID',
          KZ: 'IIN',
          UZ: 'PINFL',
          GE: 'Personal Number',
          AM: 'Social Card',
          AZ: 'FIN',
        },
        country: 'Country',
        selectCountry: 'Select a country',
        noResults: 'No countries found',
        userEmail: 'Personal Email',
        legalRepresentative: 'Legal Representative',
        companyIdNumber: {
          default: 'Tax ID Number',
          CL: 'RUT',
          PE: 'RUC',
          MX: 'RFC',
          CO: 'NIT',
          AR: 'CUIT',
          PY: 'RUC',
          ES: 'NIF',
          BR: 'CNPJ',
          UY: 'RUT',
          BO: 'NIT',
          EC: 'RUC',
          VE: 'RIF',
          US: 'EIN',
          CA: 'BN',
          DO: 'RNC',
          CR: 'Cédula Jurídica',
          PA: 'RUC',
          GT: 'NIT',
          SV: 'NIT',
          HN: 'RTN',
          NI: 'RUC',
          PR: 'EIN',
          CU: 'NIT',
          JM: 'TRN',
          PT: 'NIPC',
          FR: 'SIREN',
          DE: 'Tax Number',
          IT: 'Partita IVA',
          GB: 'Number',
          IE: 'Number',
          NL: 'KvK',
          BE: 'BCE/KBO',
          CH: 'UID',
          AT: 'Tax Number',
          SE: 'Org Number',
          NO: 'Org Number',
          DK: 'CVR',
          FI: 'Y-tunnus',
          IS: 'Kennitala',
          PL: 'NIP/REGON',
          CZ: 'IČO',
          SK: 'IČO',
          HU: 'Tax Number',
          RO: 'CUI',
          BG: 'UIC',
          GR: 'Tax Number',
          HR: 'OIB',
          SI: 'Tax Number',
          RS: 'PIB',
          BA: 'Tax Number',
          ME: 'Tax Number',
          MK: 'Tax Number',
          MT: 'VAT Number',
          CY: 'Tax Number',
          LU: 'Tax Number',
          LT: 'Code',
          LV: 'Reg Number',
          EE: 'Reg Code',
          TR: 'Tax Number',
          IL: 'Number',
          SA: 'CR Number',
          AE: 'Trade License',
          QA: 'CR Number',
          KW: 'CR Number',
          BH: 'CR Number',
          OM: 'CR Number',
          JO: 'Tax Number',
          LB: 'Tax Number',
          EG: 'Tax Number',
          MA: 'RC',
          TN: 'Tax Number',
          DZ: 'NIS',
          ZA: 'Registration Number',
          NG: 'RC Number',
          KE: 'PIN',
          GH: 'TIN',
          UG: 'TIN',
          TZ: 'TIN',
          RW: 'TIN',
          BW: 'Tax Number',
          NA: 'Tax Number',
          ZM: 'TPIN',
          ZW: 'Tax Number',
          ET: 'TIN',
          CN: 'USCI',
          IN: 'CIN/GSTIN',
          PK: 'NTN',
          BD: 'TIN',
          JP: 'Number',
          KR: 'Registration Number',
          SG: 'UEN',
          MY: 'SSM Number',
          ID: 'NPWP',
          PH: 'TIN',
          TH: 'Tax ID',
          VN: 'Tax Code',
          HK: 'BR Number',
          TW: 'UBN',
          LK: 'BRC Number',
          NP: 'PAN',
          AU: 'ABN/ACN',
          NZ: 'NZBN',
          RU: 'INN/OGRN',
          UA: 'EDRPOU',
          BY: 'UNP',
          KZ: 'BIN',
          UZ: 'Tax Number',
          GE: 'Tax Number',
          AM: 'Tax Number',
          AZ: 'Tax Number',
        },
        companyLabel: 'Company',
        address: 'Address',
        companyEmailError: "You must use an email that's different from the user's email",
        userIdNumberError: 'invalid',
        userIdNumberSuccess: 'has been verified',
        companyIdNumberError: 'invalid',
        companyIdNumberSuccess: 'has been verified',
      },
      cancel: 'Cancel',
      save: 'Save',
      success: 'Mobile user created successfully!',
      error: 'There was an error creating the new mobile user',
    },
    editUser: {
      information: {
        oldPassword: 'Current Password',
        newPassword: 'New Password',
        passwordChange: 'Change password',
        error: 'There was an error updating the user',
        success: 'Mobile user updated successfully!',
      },
    },
    createGroup: {
      button: 'Create group',
      title: 'Create user group',
      chooseHeader: 'How do you want to create the group?',
      name: 'Group name',
      nameHelper: 'Group name',
      userSelection: 'User selection',
      formSelection: 'Form selection',
      importExcelNote: "*You'll need to assign permissions to forms later",
      warning:
        'Users assigned to a group will access the forms of that group and cannot have individually assigned forms at the same time.',
      empty_state: {
        title: 'Segment forms and tasks by user groups',
        subtitle: 'What is a user group?',
        descriptionPart1:
          'User groups allow you to control what information each person can see. When you assign forms to a group, only their members will have access to those forms and their data.',
        descriptionPart2:
          'This ensures that each user only sees what they should according to their role or area, improving control and security of information.',
        block1: {
          title: 'Why use user groups?',
          card1: {
            title: 'Information control and security',
            description:
              'Group users with special permissions and access. Protect sensitive data and ensure confidentiality.',
          },
          card2: {
            title: 'Simplified team management',
            description:
              'Assign permissions by group to manage teams easily. Save time and avoid manual errors.',
          },
          card3: {
            title: 'Optimize team experience',
            description:
              'Show only relevant information for each user. Streamline processes and improve fieldwork.',
          },
        },
        block2: {
          title: 'Create your first user group',
          demo1: {
            title: 'Via DataScope',
            description:
              'Create a user group directly from DataScope by manually selecting users and associated forms.',
          },
          demo2: {
            title: 'Importing your user list',
            description:
              'Download the Excel template from DataScope, fill in your user data, and upload it back to the platform. Important! Do not modify the headers and respect the format to ensure a successful upload.',
          },
          next: 'Next',
          previous: 'Previous',
        },
        block3: {
          title: 'Group, assign, and simplify',
          description:
            'Now that you know how groups work, create one, start using them in your daily tasks, and begin optimizing your operations.',
        },
      },
    },
    setProfile: {
      completeProfile: 'Complete your profile',
      completeProfileDescription: 'Please complete the following information to enter DataScope',
      newPassword: 'New password',
      name: 'Name',
      lastName: 'Last name',
      phone: 'Phone',
      save: 'Finish',
      updateSuccess: 'Profile updated successfully',
      updateError: 'There was an error updating the profile',
      identifier: 'Identifier',
    },
    exportUsers: {
      export: 'Export',
      success: 'Users exported successfully!',
      error: 'Failed to export users',
    },
    importUsers: {
      blockedUsersTitle: '%{blocked} email(s) cannot be imported',
      blockedUsersBody:
        'These addresses are already in use in DataScope and cannot be created in this account. The rest of the file is imported as usual.',
      blockedUsersListTitle: 'Addresses that cannot be imported',
      previewUnavailable:
        'We could not check whether any of these users already has a DataScope account. The import continues either way.',
      previewTooLarge:
        'This file is too large to preview, so we could not check who already has a DataScope account. The import itself will work.',
      existingUsersTitle: '%{linked} of %{total} users already have a DataScope account',
      existingUsersBody:
        'These users will keep their current credentials. The password in the file will only apply to the other %{new} user(s).',
      existingUsersListTitle: 'Users who already have a DataScope account',
      invalidFileType: 'Invalid file type. Please upload an .xlsx file',
      dragDropHere: 'Drag and drop your Excel file here',
      orBrowse: 'or browse',
      downloadSuccess: 'Template downloaded successfully!',
      downloadError: 'Failed to download template',
      uploadSuccess: 'File uploaded successfully!',
      uploadError: 'Failed to upload file',
      importTitle: 'Import Users',
      upload: 'Import',
      downloadStep: 'Step 1: Download the template file',
      downloadStepHelper: 'Download the template file to fill in the user information',
      editStep: 'Step 2: Edit the file',
      editStepHelper: 'Edit the Excel file and fill in the required fields *.',
      uploadStep: 'Step 3: Upload the file',
      uploadStepHelper: 'Upload the edited file to import users.',
      downloadTemplate: 'Download Example',
      afterUploadInfo:
        'After uploading, users will be processed and you will be notified if there are errors.',
      replace: 'Replace',
      fileLoadedMessage: 'Your file has been uploaded',
    },
  },
  login: {
    greeting: 'Hi again!',
    loginHelper: 'To continue, enter your credentials',
    googleLogin: 'Login with Google',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    login: 'Log in',
    noAccount: "Don't have an account?",
    signUp: 'Register here',
    success: 'Login successful',
    error: 'Login failed',
    wrongCredentials: 'Email or password is incorrect. Check your credentials and try again.',
    logoutError: 'Logout failed',
    recaptchaError: 'Captcha verification failed. Please try again.',
    mfaTitle: 'Two-Factor Authentication',
    mfaSubtitle: 'Enter the 6-digit code from your authenticator app',
    mfaCodeLabel: 'Verification Code',
    verify: 'Verify',
    backToLogin: '← Back to login',
    invalidMfaCode: 'Please enter a valid 6-digit code',
    invalidMfaCodeError: 'Invalid verification code. Please try again.',
    mfaStatusError: 'Error checking 2FA status',
    mfaEnableError: 'Error enabling MFA',
    mfaEnabledSuccess: 'MFA enabled successfully',
    mfaVerifyError: 'Error verifying MFA',
    mfaDisableError: 'Error disabling MFA',
    mfaDisabledSuccess: 'MFA disabled successfully',
    mfaSetupTitle: 'Set up your authenticator app',
    mfaScanQr: 'Scan the QR code with your authenticator app.',
    mfaSecretCode: 'Secret code',
    mfaCancel: 'Cancel',
    mfaClose: 'Close',
    mfaSetup: 'Set up MFA',
    mfaDisable: 'Disable MFA',
    ssoLogin: 'SSO Login',
    ssoSubtitle: 'To continue, enter your company email adress',
    ssoCompanyEmail: 'Company Email',
    ssoCompanyEmailPlaceholder: 'Enter your company email address',
    ssoValidating: 'Validating your email...',
    ssoContinue: 'Continue with SSO',
    ssoHelpText: "We'll redirect you to your company's login page",
    ssoBackToLogin: 'Login with password',
    ssoSignInWithSSO: 'Sign in with SSO',
    ssoCompletingAuth: 'Completing authentication...',
    ssoVerifyingCredentials: 'Verifying your credentials',
    ssoAuthSuccessful: 'Authentication Successful!',
    ssoAuthFailed: 'Authentication failed',
    ssoRedirecting: 'Redirecting you back...',
    ssoError: 'SSO authentication failed. Please try again.',
    ssoTooManyAttempts: 'Too many login attempts. Please try again later.',
    ssoInvalidIdentifier: 'Invalid email address. Please check your company email and try again.',
    ssoNoAccountsFound: 'No SSO-enabled accounts found for this email domain.',
    ssoFailedValidation: 'Email validation failed. Please check your company email and try again.',
    ssoFailedStatus: 'Failed to check SSO status. Please try again.',
    secureLoginMessage: 'You are logging in with your corporate account through a secure login.',
    ssoFailedInitiate: 'Failed to initiate SSO login. Please try again.',
    checkingAuthentication: 'Checking authentication...',
    ssoConnecting: 'Connecting with your corporate account...',
    ssoRedirectingToSSO:
      "We are redirecting you to your company's secure login page to complete access.",
    ssoNoSSO: 'This account does not use Single Sign-On (SSO).',
    ssoContinueWith: 'Continue with',
    ssoAuthenticationFailed: 'Authentication failed. Please try again.',
    ssoAuthenticationError: 'An error occurred during authentication.',
    ssoAuthenticationProcessing: 'Processing authentication...',
    ssoAuthenticationFailedRedirect: 'Authentication failed. Redirecting to login...',
    ssoAuthenticationCompleting: 'Completting authentication...',
    ssoFailedProviderLogin: 'Error initiating login with selected provider.',
    ssoSelectProvider: 'Select an option to continue',
  },
  forgotPassword: {
    title: 'Reset your password',
    description: 'Enter your email and we will send you a link to reset your password.',
    email: 'Email',
    continue: 'Continue',
    backToLogin: 'Back to login',
    success:
      'If the email entered is valid, we will send you a message with the steps. If you do not see it, check your spam folder.',
    error: 'An error occurred while sending the email, please try again.',
    recaptchaError: 'Captcha verification failed. Please try again.',
  },
  resetPassword: {
    title: 'Change password',
    description: 'Enter your new password and confirm it.',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    continue: 'Reset password',
    passwordsMatchError: 'Passwords do not match',
    success: 'Password updated successfully',
    error: 'An error occurred while updating the password, please try again.',
  },
  changePassword: {
    title: 'Change your password',
    description: 'You signed in with a temporary password. Set a new password to continue.',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    continue: 'Change password',
    passwordsMatchError: 'Passwords do not match',
    minLengthError: 'Password must be at least 6 characters',
    success: 'Password updated. You can continue now.',
    error: 'An error occurred while changing your password, please try again.',
  },
  signUp: {
    emailExistsTitle: 'This email already exists',
    emailExistsBody:
      'Sign in with %{email} to add this account to your identity and switch between your accounts without logging in again.',
    useAnotherEmail: 'Use another email',
    title: 'Create your account',
    subtitle: 'No credit card required, cancel anytime',
    templatePreviewTitle: "You're one step away from using:",
    name: 'Name',
    lastName: 'Last name',
    email: 'Email',
    password: 'Password',
    companyName: 'Company',
    role: 'Role',
    phoneNumber: 'Country and phone number',
    alreadyHaveAccount: 'Already have an account?',
    signUp: 'Create account',
    error: 'An error occurred while creating the account, please try again.',
    privacyPolicyText: 'By clicking you agree to our',
    privacyPolicyLink: 'Privacy Policy',
    emailError: 'Invalid email',
    phoneNumberError: 'Invalid phone number',
    passwordError: 'Password must be at least 6 characters long',
  },
  templates: {
    total_templates: 'Total Form Templates: ',
    see_all: 'See all',
    showing_results: 'Showing results for',
    categories: 'Categories',
    in: 'in',
    useTemplate: 'Use template',
    loginToAnswerTemplate: 'You can answer this template after logging into your account',
    backToDataScope: 'Back to DataScope',
    noResults: 'We have not found what you were looking for, but we would love to find a solution!',
    contactSupport: 'Tell us about the form you need via chat',
    next: 'Next',
    back: 'Back',
    useCase: 'Can be used for:',
    createdBy: 'Created by',
    anonymousUser: 'Anonymous user',
    preview: 'Preview',
    editableTemplate: 'This template can be modified after importing it.',
    allTemplates: 'All Templates',
    noDescription: 'No description',
    bannerSlogan: 'Collect all your data from any mobile device',
    templateView: 'Template View',
    seeLess: 'See less',
    seeMore: 'See more',
    importError: {
      formLimitReached: 'Form limit reached. Please upgrade your plan to import more forms.',
      alreadyImported: 'This form has already been imported.',
      validationError: 'Validation error occurred while importing the template.',
      loginRequired: 'You must be logged in to import templates.',
      genericError: 'An error occurred while importing the template. Please try again.',
      invalidUrl: 'Invalid template URL. Please check the link and try again.',
    },
  },
  navbar: {
    features: 'Features',
    solutions: 'Solutions',
    work_orders: 'Work Orders',
    safety: 'Safety',
    inspections: 'Inspections',
    quality: 'Quality',
    resources: 'Resources',
    blog: 'Blog',
    ds_academy: 'DataScope Academy',
    digitize: 'Digitize your form',
    roi: 'ROI Calculator',
    pricing: 'Pricing',
    sales: 'Talk to Sales',
    wapp: '',
    call: '',
    demo: '',
    sign_in: 'Sign In',
    sign_up: 'Sign up Free',
    log_out: 'Log Out',
    paths: {
      work_orders: 'work-orders',
      safety: 'safety',
      inspections: 'inspections',
      quality: 'quality',
      blog: 'blog',
      ds_academy: 'digitalize-your-operations-with-datascope-2',
      digitize: 'upload-form',
      roi: 'roi',
    },
  },
  uiComponents: {
    search: 'Search',
    showingResultsFor: 'Showing search results for',
    found: 'found',
    cancel: 'Cancel',
    selected: 'selected',
    confirm: 'Confirm',
    close: 'Close',
    chooseMethodDialog: {
      fromDatascope: 'From DataScope',
      importExcel: 'Import Excel',
    },
    signature: {
      title: 'Electronic Signature',
      alert:
        'Complete the following fields to create your signature. Name and last name in the information area are required to create your signature.',
      accountAlert: 'Remember to click "Save Signature".',
      saveSignature: 'Save Signature',
      completeSignatureWarning: 'You must fill out all the required fields to save your signature',
      signatureRequiredFieldError: 'This field is required to create the electronic signature',
      updateSuccess: 'Signature saved successfully!',
      updateError: 'There was an error saving the signature',
      invalidEmailError: 'Invalid email',
      emailExistsError: 'Email address is already in use',
      validatingRut: 'Validating RUT...',
      emailErrors: {
        REGEX_INVALID: 'Invalid email',
        IN_USE: 'Email address is already in use',
      },
    },
  },
  formEmailBuilder: {
    message: 'Message',
    subject: 'Subject',
    senderName: "Sender's Name",
    addFooter: 'Add Signature',
    footerTitle: 'Signature',
    notification: 'Notification',
    autoNotify: 'Notify fixed emails',
    save: 'Save',
    cancel: 'Cancel',
    linkName: 'PDF Form Download Link',
    linkNamePlaceholder: 'Enter the name you want the link to have',
    linkNameHelp:
      'The name you configure will be the one in the download link that will arrive in the email.',
    saveSuccess: 'Configurations saved successfully',
    saveError: 'There was an error saving the configurations',
    autoGeneratePdf: 'Generate PDF Automatically',
  },
  accountConfig: {
    information: {
      title: 'Account Configuration',
      name: 'Company Name',
      description: 'Company Description',
      email: 'Company Email',
      phone: 'Company Phone',
      address: 'Company Address',
      timezone: 'Timezone',
      locale: 'Language',
      dateFormat: 'Date format',
      dateFormatDescription: 'Select the date format that will be used throughout the application',
      dateFormatDdMm: 'dd/mm/YYYY',
      dateFormatDdMmExample: 'Example: 25/12/2024',
      dateFormatMmDd: 'mm/dd/YYYY',
      dateFormatMmDdExample: 'Example: 12/25/2024',
      dateFormatPreview: 'Preview',
      logo: 'Logo',
      uploadLogo: 'Image',
      logoDescription:
        'Only .PNG or .JPG files. Image size should be 400x400px with a maximum file size of 2MB.',
      logoSizeError: 'The maximum file size allowed is 2MB.',
      saveSuccess: 'Account information updated successfully!',
      saveError: 'There was an error updating the account information',
      pdfAlert: 'The following information will be displayed in the header of the standard PDF.',
      confirmDeleteLogo: 'Are you sure you want to delete the logo?',
      languages: {
        es: 'Español',
        en: 'English',
        pt: 'Português',
      },
      exampleLabel: 'Example:',
      dateLabel: 'Date:',
      timeLabel: 'Time:',
      dateTimeLabel: 'Date and time:',
      dateFormatProfiles: {
        european: 'European',
        english: 'English',
      },
    },
    advancedConfig: {
      title: 'Advanced Configuration',
      activateSupportUser: 'Grant Access to DataScope Support User',
      securityConfig: 'Security Configuration',
      deactivateAccount: 'Disable Account',
      confirmTitle: 'Are you sure you want to disable your account?',
      confirmMessage:
        'This action cannot be undone. All your users and data will also be deactivated.',
    },
    mfaConfig: {
      title: 'Account Security (2FA)',
      subtitle:
        'Protect your account with an additional security level.\nWhen activated, a temporary code will be requested from your authenticator app when logging in.',
      activateMfa: 'Activate two-factor authentication',
      configMode: 'How do you want to configure it for your account users?',
      optional: 'Optional',
      mandatory: 'Mandatory',
      optionalDescription: 'Each user can activate it from their user settings',
      mandatoryDescription: 'All members must configure it to access the platform',
    },
  },
  notifications: {
    title: 'Notifications',
    searchPlaceholder: 'Search by form name...',
    viewFormAnswer: 'View Form Answer',
    viewExcel: 'View Excel',
    viewPdf: 'View PDF',
    downloadZip: 'Download ZIP',
    tableHeaders: {
      date: 'Date',
      type: 'Type',
      form: 'Form',
      formCode: 'Code',
      user: 'User',
      location: 'Location',
      actions: 'Actions',
    },
    formExport: 'Form Export',
    formAnswer: 'Form Answer',
    bulkPdfZip: 'Bulk PDF download',
    filters: {
      title: 'Filters',
      filterByType: 'By type',
      filterByLocation: 'By location',
      filterByUser: 'By user',
      filterByDateRange: 'By date range',
      startDate: 'Start',
      endDate: 'End',
      invalidDate: 'Invalid date',
      invalidDateRange: 'Invalid date range',
      to: 'to',
      eraseAll: 'Erase all',
      apply: 'Apply',
      formAnswers: 'Form Answers',
      formExports: 'Exports',
      clear: 'Clear',
      locationPlaceholder: 'Select a location',
      userPlaceholder: 'Select a user',
      showingResultsFor: 'Showing results for',
    },
    noNotifications: 'No notifications available',
    noResults: 'No results found with the selected filters',
    limitReached:
      'Your account reached the limit. You must activate your account to enable this feature.',
    zipDownloadError: 'Could not download the ZIP. Please try again.',
  },
  formSignatureBuilder: {
    signatureTitle: 'E-Signature activation',
    checkboxSignatureActivate: 'Activate electronic signature',
    settingsTitle: 'General settings',
    save: 'Save',
    cancel: 'Cancel',
    saveSuccess: 'Settings saved successfully',
    saveError: 'An error occurred while saving the settings',
    saveErrorReload:
      'An error occurred while saving the settings. Please reload the page and try again',
    accountSignatureConfigError: "The account's electronic signature configuration is missing",
    generalSettings: 'General Settings',
    mandatorySignature:
      'Mandatory signature (All configured users must respond to the request, either by signing or rejecting it)',
    optionalSignature: 'Optional signature (One of the configured signers must sign)',
    signersSettings: 'Signers Settings',
    authorMustSign: 'The user submitting a response must also sign',
    fixedSignerTitle: 'Fixed signer',
    changeSelection: 'Change selection',
    quorumBlockedTitle: 'Signature quorum',
    quorumBlockedEnterpriseChip: 'Enterprise',
    quorumBlockedDescription:
      'Let a document move forward once a minimum number of signatures is reached, without requiring every signer to sign. Available on the Enterprise plan.',
    quorumBlockedCta: 'See the plans',
    pricingEmptyStateTag: 'Available on Professional and Enterprise',
    pricingEmptyStateTitle: 'Manage signatures and approvals in one place',
    pricingEmptyStateIntro:
      'Ensure traceability of every approval and reduce errors in your signature processes.',
    pricingEmptyStateFeature1: 'Request signatures and send automatic notifications.',
    pricingEmptyStateFeature2: 'Define approval and tracking processes.',
    pricingEmptyStateFeature3: 'Keep traceability of every signed document.',
    pricingEmptyStateDtBanner: 'Electronic signature validated by the Dirección del Trabajo',
    pricingEmptyStateKnowPlans: 'See the plans',
    pricingEmptyStateContactSales: 'Talk to sales',
    pricingEmptyStateContactSalesMessage:
      "Hi, I'm interested in electronic signature. Can you tell me about the plans?",
    pricingEmptyStateDemoTitle: 'See the signing process from start to finish',
    pricingEmptyStateEnterpriseChip: 'Enterprise',
    pricingEmptyStatePrev: 'Previous',
    pricingEmptyStateNext: 'Next',
    pricingEmptyStateSlide1Title: 'Define who signs and in what order',
    pricingEmptyStateSlide1Description:
      'Set up one or more signers for each document. Request simultaneous signatures or define an approval sequence to match your process.',
    pricingEmptyStateSlide2Title: 'Track every request',
    pricingEmptyStateSlide2Description:
      'Check the status of your signature requests and see who needs to sign next. Keep visibility of every document without leaving DataScope.',
    pricingEmptyStateSlide3Title: 'Access documents and signature history',
    pricingEmptyStateSlide3Description:
      'Review signed documents, dates, and participants to keep a centralized record of every approval.',
    pricingEmptyStateSlide4Title: 'Dynamic signing and approval quorums',
    pricingEmptyStateSlide4Description:
      'Define signers automatically from form answers, or let a document move forward once the required minimum number of signatures is reached.',
    dynamicSignerTooltip:
      'Dynamic signers are available in the Enterprise plan. Upgrade your plan and access this and more advanced features.',
    upgradePlan: 'Upgrade your plan',
    assignOwner: 'Assign responsible',
    searchPlaceholder: 'Search user or group',
    usersTab: 'Users',
    groupsTab: 'Groups',
    addButton: 'Add',
    cancelButton: 'Cancel',
    externalUsers: 'External users',
    externalUsersDescription: 'External users will be able to view and sign the form',
    selectResponsible: 'Select the request responsible',
    addResponsible: 'Add responsible',
    selectUsersToSign: 'Select the users who must sign the document',
    selectResponsibleTooltip:
      'The selected user will be able to track the status of all requests and edit them, but will not be able to sign. To sign, they must be added to the signers list',
    simultaneousSign: 'Simultaneous Sign',
    sequentialSign: 'Signature sequence',
    simultaneousSignInfo: 'The request will be sent simultaneously to all users',
    sequentialSignInfo: 'The request will be sent in the order you establish',
    simultaneousEmptyState: 'Drag users here to remove them from the sequence',
    sequentialEmptyState: 'Drag users here to create a signature sequence',
    sequentialWarningInfo: 'You must add all users to generate a request - {value} users',
    sequentialSignSuccess: 'Sequence complete',
    automatedSignature: 'Activate automatic signature request',
    locationUser: 'Location emails',
    locationUserTooltip:
      'By selecting "Location Connection", the request will be sent to all emails configured in the first associated place.',
    locationUserViewEmails: 'View emails',
    locationConnection: 'Location Connection',
    locationConnectionTooltip1:
      'If the form includes a question to select a location, a request will be sent to the emails configured there',
    locationConnectionTooltip2:
      'If you assign a task with this form and choose a location, the emails configured there will receive a request when the task is completed',
    optionalSignatureOrderDisabled:
      'This option is not available for optional signature configuration',
    author: "Response's author",
    authorMustSignFirst:
      'This position is fixed within the sequence, but you can move it to Simultaneous Signature',
    deleteSigner: 'Delete user',
    unGroupSigner: 'Ungroup',
    authorUserTooltip:
      'If the response author is already part of the sequence, their original position will be maintained instead of the one assigned for the author',
    addSigners: 'Add Signers',
    addSignersTitle: 'Add Signers',
    selectConfigurationType:
      'Select the type of configuration you need. You can choose one or both.',
    fixedSigner: 'Fixed Signer',
    fixedSignerDescription: 'Internal or external users',
    dynamicSignerCardDescription: 'Based on form responses',
    dynamicSigner: 'Dynamic Signer',
    dynamicSignerDescription: 'Dynamic signers are defined from responses in questions type',
    dynamicSignerDescriptionBold:
      'Data list selection with location lists or custom, or Text with email validation.',
    formQuestionsTitle: 'Questions from this form',
    noDynamicSignatureQuestionsAvailable: 'You have no questions of this type\nat this time',
    selectedSignerSingular: 'selected',
    selectedSignersPlural: 'selected',
    quorumLabel: 'At least',
    quorumSuffix: 'must sign',
    quorumAll: 'All',
    quorumTooltip:
      'The request will be sent following the defined order. Each stage will advance when the required number of people have signed.',
    quorumTooltipSimultaneous:
      'All users will receive the request at the same time. The process will finish when the required number of people have signed.',
    quorumError: 'The quorum must be between 1 and the number of participants',
    rejectReasonsTitle: 'Rejection reasons configuration',
    rejectReasonsInfoBanner: 'They will be shown when a signer rejects a request',
    rejectReasonsSaveError: 'These reasons could not be saved (check duplicates or length): {reasons}',
    rejectReasonsEmptyError: 'The reason cannot be empty',
    rejectReasonsAddPlaceholder: 'Write the rejection reason',
    rejectReasonsAddButton: '+ Add rejection reason',
    rejectReasonsEmptyText: "You haven't added any rejection reasons yet. If you don't add any, the signer will write the reason as free text.",
    rejectReasonsDuplicateError: 'A reason with that text already exists on this form',
    rejectReasonsDeleteTitle: 'Are you sure you want to delete this rejection reason?',
    rejectReasonsDeleteDescription: 'Previously sent requests will not be affected and will remain on the platform',
    rejectReasonsDeleteConfirm: 'Delete',
    rejectReasonsDeleteCancel: 'Cancel',
  },
  pricing: {
    title: 'Perfect for exploring DataScope features',
    basic: {
      title: 'Basic',
      subtitle: 'Limited users, 60 form answers per month, answer storage for 30 days',
      features: [
        'Unlimited users',
        '60 form responses/month',
        'Data stored for 30 days',
        'Basic form builder',
        'Task assigner',
        'Standard dashboard',
        'Standard photo resolution',
        'Offline functionality',
      ],
      buttonText: 'Actual plan',
    },
    standard: {
      title: 'Standard',
      subtitle: 'Ideal for teams taking their first steps in process digitization',
      features: [
        'Everything included in the Basic Plan +',
        'Unlimited form responses',
        'Data stored forever',
        'Advanced form builder',
        'Custom PDF report generator',
        'Editable user permissions',
        'Data integration with other platforms',
        'In-app user chat',
        'Email/phone/chat support',
      ],
    },
    premium: {
      title: 'Premium',
      subtitle: 'For businesses requiring a comprehensive, real-time view of all their operations',
      features: [
        'Everything included in the Standard Plan +',
        'Advanced dashboards',
        'API support',
        'Configurable photo resolution',
        'Assigned account executive',
        'Workflow support',
      ],
      buttonText: 'Change to premium',
    },
    enterprise: {
      title: 'Enterprise',
      subtitle: 'For large companies seeking a personalized solution and support',
      features: [
        'Everything included in the Premium Plan +',
        'Custom implementation',
        '24/7 preferential support',
      ],
      buttonText: 'Talk to Sales',
    },
    features: 'Features',
    start: 'Start',
    currentPlan: 'Current plan',
    mostPopular: 'Most popular',
    free: 'Free',
    monthlyPerUser: 'monthly per user',
    users: 'users',
    standardBold: 'Standard',
    off: 'off',
    finishesIn: 'Finishes in',
    ofDiscount: 'discount.',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    salesLink: 'https://meetings.hubspot.com/andres-rivera4',
    activePayment: {
      demoSubscription: 'Paid subscription',
      demoSubscriptionDescription: 'Your current plan includes 30 users.',
      demoSubscriptionDescription1: ' user(s).',
      demoSubscriptionDescription2: 'You can invite more by clicking the button below.',
      inviteUsers: 'Invite users',
      demoBannerDescription: 'You have no pending payments!',
      demoBannerDescription2:
        "If you have any questions about your subscription, don't hesitate to contact our team.",
      moreInfo: 'More information',
      viewBillingDetails: 'View billing details',
      changeUsers: 'Change number of users',
      modify: 'Modificar',
      monthlyValue: 'Monthly value',
      annualValue: 'Annual value',
      total: 'Total',
      valuesMayDiffer: '*Values may differ based on your local currency.',
      modifyUsersSuccess: 'Subscription updated successfully!',
      modifyUsersError:
        'Encontramos problemas ao atualizar sua assinatura. Por favor, tente novamente ou entre em contato com nossa equipe de vendas.',
      confirmModifyUsers: 'Are you sure you want to change the number of users?',
      confirmModifyUsersDescription:
        'This action will change the value of your subscription and any difference will be charged immediately.',
      numberOfUsers: 'Number of users',
      paymentDetails: 'Payment details',
    },
  },
  sensors: {
    tabs: { map: 'Map', list: 'Sensors', inbox: 'Inbox', connection: 'Connection' },
    enterpriseOnlyMessage: 'The sensors module is not enabled on this account. Write to us if you want more information.',
    map: {
      showing: 'Showing the {shown} sensors with the most recent data, of {total}',
      previousPage: 'Previous',
      nextPage: 'Next',
      pageLabel: 'Page {page} of {pages}',
      empty: 'No sensor has sent data from a place with coordinates yet.',
    },
    inbox: {
      viewFullBody: 'View the full message',
      fullBodyTitle: 'Received message',
      fullBodyClose: 'Close',
      unmappedTitle: 'Entries waiting to be mapped',
      unmappedHint: "They reached your account but don't feed any sensor yet",
      unmappedEmpty: 'No entries are waiting to be mapped.',
      mappedTitle: 'Entries already assigned',
      mappedEmpty: 'No entry feeds a sensor yet.',
      mappedHint: 'Each one feeds the sensor shown in its row',
      mapAction: 'Map',
      viewAction: 'View',
      editMappingAction: 'Edit mapping',
      columnMapping: 'Mapped by',
      mappingIdentifierShort: 'ID: {path}',
      mappingDateShort: 'Date: {path}',
      mappingDateNone: 'no date field',
      columnWhen: 'When',
      columnOutcome: 'Outcome',
      columnMessage: 'Message',
      columnSensor: 'Sensor',
      outcomeAccepted: 'Accepted',
      outcomeRejected: 'Rejected',
      outcomeUnknownDevice: 'No identifier',
      unknownDeviceHint:
        "No device identifier could be recognized in this message. You can review it and map it manually from here.",
      previousPage: 'Previous',
      nextPage: 'Next',
      pageLabel: 'Page {page} of {pages}',
      footnote:
        "Only the last 100 entries are shown. Nothing is lost: a device that sends data without being mapped still keeps its full history. Mapping it only decides what's copied to an asset's meter.",
    },
    assetPicker: {
      searchPlaceholder: 'Search by asset name or code',
      noResults: 'No asset matches that search.',
      noAssets: 'This account has no assets yet. Create one before linking a sensor to it.',
      noLocation: 'No place',
      previous: 'Previous',
      next: 'Next',
      pageLabel: 'Page {page} of {pages}',
      title: 'Choose an asset',
      clear: 'Leave it unlinked',
      cancel: 'Cancel',
    },
    newSensor: {
      action: 'New sensor',
      title: 'New sensor',
      firstBody:
        'You need to integrate your first sensor. Connect it with the address DataScope gives you and its entries will show up here.',
      firstAction: 'Go to Connection',
      nextBody:
        'Your sensors are already sending data. Map your new sensor from the most recent entries, where every unmapped one is waiting.',
      nextAction: 'Go to Entries',
      close: 'Close',
    },
    mapping: {
      title: 'Map device',
      editTitle: 'Edit this mapping',
      editHint:
        'Changing a field re-reads every earlier entry of the same shape, so a wrong date or identifier field gets corrected on the entries you already received.',
      changeAsset: 'Change',
      chooseAsset: 'Choose an asset',
      attributesTitle: 'Detected attributes',
      attributesHint:
        "Every attribute in the message is detected and stored on its own, including nested ones. Assigning one to a meter is optional and only decides what's copied to the asset.",
      columnAttribute: 'Attribute',
      columnLastValue: 'Last value',
      columnRole: 'Role',
      columnMeter: 'Feeds a meter',
      roleIdentifier: 'Identifier',
      roleDate: 'Reading date',
      roleLatitude: 'Latitude',
      roleLongitude: 'Longitude',
      roleData: 'Data',
      meterNone: 'Not assigned',
      meterRequiresAsset: 'Pick an asset to assign meters',
      meterNoneAvailable: 'This asset has no meters to feed. Add one to the asset first.',
      locationNoneAvailable: 'No places are configured yet.',
      howReadTitle: 'How the message is read',
      identifierFieldLabel: 'Device identifier field',
      dateFieldLabel: 'Date field (optional)',
      dateFieldNone: "Don't use one (falls back to received-at date)",
      dateFormatLabel: 'Date format',
      dateFormatIso8601: 'ISO 8601 (2026-07-29T14:32:10Z)',
      dateFormatEpochSeconds: 'Epoch seconds',
      dateFormatEpochMillis: 'Epoch milliseconds',
      latFieldLabel: 'Latitude field (optional)',
      lngFieldLabel: 'Longitude field (optional)',
      geoFieldNone: "Don't use any",
      hint: "That's the only thing to configure. Every other attribute is detected and stored on its own.",
      sensorNameLabel: 'Sensor name',
      assetLabel: 'Asset',
      assetNone: 'Not assigned',
      locationLabel: 'Location',
      locationNone: 'Not assigned',
      submit: 'Save mapping',
      cancel: 'Cancel',
      success: 'Device mapped. Earlier messages with the same shape are being backfilled.',
      error: "We couldn't save the mapping, try again.",
    },
    landing: {
      eyebrow: 'Module not enabled on this account',
      title: 'Connect your field sensors and stop writing readings down by hand',
      lead: 'The sensors you already have installed send their readings to DataScope and feed your assets\' meters on their own.',
      bullets: [
        'Register your sensors and connect them with the address DataScope gives you',
        'Link each sensor to an asset and put its meter in automatic mode',
        'Check where each asset is and which sensors stopped reporting',
      ],
      contactSupport: 'Contact support',
      contactSupportMessage: "Hi, I'd like more information about the sensors module.",
      enableHint: 'Write to us if you want more information about the sensors module.',
    },
    list: {
      columnId: 'ID',
      columnSensor: 'Sensor',
      columnStatus: 'Status',
      columnLastReading: 'Last reading',
      columnAsset: 'Linked asset',
      columnMeter: 'Automatic meter',
      noLocationGroup: 'No place',
      openAssetHint: 'Open asset in a new tab',
      changeAssetHint: 'Link this sensor to an asset',
      assetSaveSuccess: 'Sensor linked to the asset.',
      assetSaveError: "We couldn't change the asset, try again.",
      renameHint: 'Rename this sensor',
      renameSave: 'Save',
      renameCancel: 'Cancel',
      renameSuccess: 'Sensor renamed.',
      renameError: "We couldn't rename the sensor, try again.",
      unlinked: 'Not linked',
      none: '—',
      footnote:
        "A sensor can receive data without being linked to an asset. The link decides what's copied to the meter, not what's stored.",
      showing: 'Showing {from} to {to} of {total} sensors',
      previousPage: 'Previous',
      nextPage: 'Next',
      pageLabel: 'Page {page} of {pages}',
      empty: 'No sensors reporting yet.',
      // Standalone empty state of Sensores > Sensores (SensorsListTab): no
      // table, no technical footnote, just the message and the fix.
      emptyStateMessage: 'No sensor is reporting data yet.',
      emptyStateAction: 'Connect your first sensor',
      adminOnly: "Only administrators can see and manage an asset's sensors.",
      linkSensor: 'Link sensor',
      linkSensorTitle: 'Link a sensor to this asset',
      linkSensorSelectLabel: 'Sensor',
      linkSensorEmpty: 'No unlinked sensors available.',
      linkSensorSubmit: 'Link',
      linkSensorCancel: 'Cancel',
      linkSensorSuccess: 'Sensor linked to this asset.',
      linkSensorError: "We couldn't link the sensor, try again.",
      unlinkSensor: 'Unlink',
      retireSensor: 'Retire this sensor',
      retireSensorSuccess: 'Sensor retired.',
      retireSensorError: "We couldn't retire the sensor, try again.",
      retireSensorConfirmTitle: 'Retire this sensor?',
      retireSensorConfirmMessage:
        "{sensor} leaves this list and its next messages will be rejected. Nothing is deleted: its readings and the measurements they fed are kept, and you can bring it back later.",
      retireSensorConfirmAction: 'Retire',
      retireSensorCancel: 'Cancel',
      moveAssetHint: 'Move this sensor to another asset',
      moveAssetConfirmTitle: 'Move sensor to another asset',
      moveAssetConfirmBody: 'Move {sensor} from {from} to {to}?',
      moveAssetFeedsWarning:
        'It currently feeds {meters} on {from} in automatic mode. Moving it switches that off, and you set it up again on the new asset. The measurements already recorded stay on {from}.',
      moveAssetConfirmAction: 'Move',
      moveAssetCancel: 'Cancel',
      unlinkSensorFeedsWarning:
        'It currently feeds {meters} in automatic mode. Unlinking also turns that off, and the meter keeps every measurement already recorded.',
      unlinkSensorConfirmTitle: 'Unlink sensor',
      unlinkSensorConfirmBody:
        'Unlink {sensor} from this asset? It keeps its full history, but stops feeding its meters.',
      unlinkSensorConfirmAction: 'Unlink',
      unlinkSensorCancel: 'Cancel',
      unlinkSensorSuccess: 'Sensor unlinked from this asset.',
      unlinkSensorError: "We couldn't unlink the sensor, try again.",
    },
    status: { reporting: 'Reporting', silent: 'Not reporting', rejecting: 'Rejecting' },
    connection: {
      title: 'One address for all your sensors',
      endpointLabel: 'Destination address',
      credentialLabel: 'Account credential',
      info: 'All your devices send to the same address with the same credential. Each message is recognized by the device identifier inside it.',
      regenerate: 'Regenerate credential',
      regenerateConfirmTitle: 'Regenerate credential',
      regenerateConfirmBody:
        'The previous credential stops working immediately. Every device still using it will stop sending data until you update it there too.',
      regenerateConfirmAction: 'Regenerate anyway',
      cancel: 'Cancel',
      openDocs: 'View documentation',
      openDocsMessage: 'I need the sensor integration documentation.',
      whatToSendTitle: 'What to send',
      whatToSendHint: "There's no required format. Send the JSON your system already produces, as-is:",
      whatToSendFootnote: 'DataScope detects and stores every attribute on its own, including nested ones.',
    },
    catalog: {
      title: 'Other providers',
      comingSoon: 'Coming soon',
      requestButton: 'I want to integrate another software',
      requestIntercomMessage: "Hi, I'd like to integrate another software with the sensors module.",
    },
  },
  findings: {
    title: 'Issues',
    new: 'New',
    all: 'All',
    createdBy: 'Created by',
    assignees: 'Assignees',
    expires: 'Expires',
    type: 'Type',
    location: 'Location',
    description: 'Description',
    searchPlaceholder: 'Search by name, description, author or ID',
    searchPlaceholderStore: 'Search by name, description, author, ID or form content',
    noResultsWithFilters: 'You have no issues available at the moment',
    newResultsNotice: 'There are new issues. Refresh the list',
    loadError: 'We could not load the issues. Try again',
    sectionLoadError: 'We could not load this section. Try again',
    resultWindowNotice:
      'Not finding the issue you need? Try the search or the filters to narrow the list.',
    createdIn: 'Created in',
    originQuestion: 'Question',
    note: 'Note',
    viewForm: 'View form',
    createYourFirstFinding: 'Create your first issue',
    emptyState: 'Add a Checklist question to a new or existing form to start creating issues',
    goToForms: 'Go to Forms',
    detailEmptyState: 'Select an issue to view the history',
    findingDetail: 'Issue detail',
    idCopied: 'ID copied!',
    findingCodePending: 'Assigning…',
    filtersLinkCopy: {
      tooltip: 'Copy link with filters',
      success: 'Link copied to clipboard',
      error: 'Could not copy link. Check browser permissions.',
    },
    delete: 'Delete',
    deletedSuccessfully: 'Issue deleted successfully',
    tabs: {
      inProgress: 'In Progress',
      closed: 'Closed',
    },
    filters: {
      clearFilters: 'Clear filters',
      filterByPriority: 'Filter by priority',
      filterByStatus: 'Filter by status',
      filterChipAssignee: 'Assignee',
      filterChipCreator: 'Creator',
      filterChipForm: 'Form',
      filterByForms: 'Filter by forms',
      filterByAssets: 'Filter by assets',
      filterByLocations: 'Filter by locations',
      filterByCreators: 'Filter by creator',
      filterByAssignees: 'Filter by assignee',
      noSearchResultsForms: 'No forms were found',
      noSearchResultsAssets: 'No assets were found',
      noSearchResultsLocations: 'No locations were found',
      noSearchResultsCreators: 'No creators were found',
      noSearchResultsAssignees: 'No assignees were found',
      formDeleted: 'Deleted',
      formInactive: 'Inactive',
      dateFilter: {
        title: 'Date',
        popoverTitle: 'Filter by date',
        creationDate: 'Creation date',
        expirationDate: 'Due date',
      },
    },
    options: {
      viewDetails: 'View details',
      addImage: 'Add image',
      sendFormAnswers: {
        menu: 'Send form answers',
        title: 'Form answers',
        button: 'Send to issue',
        cancel: 'Cancel',
        description: 'Select the response you want to send to the issue',
        searchPlaceholder: 'Search form',
        answeredBy: 'Answered by',
        updatedAt: 'Updated at',
        noResults: 'No answers found',
        seeAnswer: 'See answer',
        noAnswers: "You don't have any answers at the moment",
      },
      sendForms: {
        button: 'Send',
        menu: 'Send form',
        sync: 'Syncing',
      },
      share: {
        menu: 'Share link',
        title: 'Share link',
        text: 'Anyone with the link can access the issue',
        activate: 'Enable',
        deactivate: 'Disable',
        loginTitle: 'Welcome to DataScope!',
        loginDescription: 'To continue, please enter your name and email address',
        loginNamePlaceholder: 'Your Name',
        loginEmailPlaceholder: 'Email address',
      },
    },
    createFindingType: 'Create Issue Type',
    createFinding: {
      title: 'Create issue',
      create: 'Create',
      requiredInformation: 'Required Information',
      optionalInformation: 'Optional Information',
      cancel: 'Cancel',
      name: 'Name',
      titleLabel: 'Title',
      titlePlaceholder: 'Describe the problem in a few words',
      descriptionPlaceholder: 'Describe the problem in more detail',
      type: 'Issue type',
      description: 'Description',
      assignees: 'Assignee(s)',
      dueDate: 'Due Date',
      location: 'Location',
      inviteParticipants: 'Invite Participants',
      asset: 'Asset',
      findingSuccess: 'Issue created successfully',
      findingError: 'Error creating issue',
      findingCreated: 'Issue created',
      editInFindings: "Go to the 'Issues' section to make changes.",
      evidence: {
        title: 'Evidence',
        required: 'Required evidence',
        optional: 'Evidence (optional)',
        addPhoto: 'Image',
        uploadError: 'Error uploading image',
        limitReached: 'You can only attach up to {{max}} photos. The rest were ignored.',
        requiredError: 'You must add at least one photo as evidence',
        invalidType: 'Only image files are allowed',
        sizeExceeded: 'File exceeds the maximum allowed size of 10 MB',
      },
      evidenceImageSelected: 'image attached',
      evidenceImagesSelected: 'images attached',
    },
    editFinding: {
      title: 'Edit issue',
      update: 'Update',
      findingSuccess: 'Issue updated successfully',
      findingError: 'Error updating issue',
    },
    closeFinding: {
      title: 'Close issue',
      instruction: 'Complete the following information to close the issue',
      closingNoteLabel: 'In what state did you close the issue?',
      cancel: 'Cancel',
      confirm: 'Close issue',
    },
    status: {
      title: 'Status',
      open: 'Open',
      in_progress: 'In Progress',
      paused: 'Paused',
      closed: 'Closed',
    },
    priority: {
      title: 'Priority',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical',
    },
    asset: {
      label: 'Asset',
      placeholder: 'Select asset',
      noAsset: 'No asset',
      searchPlaceholder: 'Search',
      clear: 'None',
      clearSelection: 'Deselect asset',
      assetsCount: '{count} assets',
      assetCount: '1 asset',
      selected: '1 selected',
      noAssets: 'No assets found',
      noType: 'No type',
      emptyStateMessage: 'Create assets and take advantage of the benefits',
      goToCreateAssets: 'Create assets',
      noSearchResults: 'No assets found',
    },
    deleteWarningConfirm: 'Are you sure you want to delete this issue?',
    deleteWarningConfirmDescription: 'This action cannot be undone.',
    chat: {
      events: {
        finding_created: 'Issue created',
        finding_closed: 'closed the issue',
        finding_closed_expired: 'closed the issue after the specified deadline',
        status: 'updated the status to',
        priority: 'updated the priority to',
        description: 'updated the issue description to',
        expiration_date: 'updated the due date to',
        name: 'updated the issue name to',
        location: 'updated the location to',
        added_assignees: 'added',
        removed_assignees: 'removed',
        assignees_singular: 'as assignee',
        assignees_plural: 'as assignees',
        added_invitees: 'added',
        removed_invitees: 'removed',
        invitees_singular: 'as invitee',
        invitees_plural: 'as invitees',
        no_expiration_date: 'no expiration date',
        asset: 'updated the issue asset to',
        deleted_asset: 'removed the issue asset',
        evidence_added: 'added {{count}} images to the evidence',
        evidence_added_singular: 'added 1 image to the evidence',
        evidence_removed: 'removed {{count}} images from the evidence',
        evidence_removed_singular: 'removed 1 image from the evidence',
        evidence_modified: 'updated the evidence',
      },
      image: {
        error: 'Error',
        sync: 'Image Syncing',
      },
      evidence: {
        attached: '{{count}} images were attached as evidence of the issue',
        attached_singular: '1 image was attached as evidence of the issue',
        viewerTitle: 'Issue Evidence',
        altMain: 'Evidence {{n}}',
        altThumb: 'Thumbnail {{n}}',
        more: '+{{count}}',
        formPhotosNote: 'Images attached from the question cannot be removed, but you can add more',
      },
      assignedForms: {
        message: 'Please fill out the following form to provide more information',
      },
    },
    export: {
      pdf: {
        title: 'Export PDF',
        tooltip: 'Export PDF',
        info: 'You will export all the information included in the issue. Once exported, the download link will be sent to your email.',
        exportSuccess: 'Issue PDF exported successfully',
        exportError: 'Error exporting issue PDF',
        buttonTitle: 'PDF',
      },
      all: {
        title: 'Export all',
        tooltip: 'Export to Excel',
        info: 'You will export the following variables in Excel format: Name, description, responsible parties, participants, expiration, priority, and location. Once exported, the download link will be sent to your email.',
        exportSuccess: 'Issues data exported successfully',
        exportError: 'Error exporting issues',
        buttonTitle: 'Excel',
      },
      emailInputLabel: 'Email',
      cancel: 'Cancel',
      confirm: 'Export',
    },
    pricing: {
      landing: {
        tagTrial: 'Try Tickets free for 30 days',
        tagPaid: 'Available on the Professional and Enterprise plans',
        titleTrial: 'Spot, report, and resolve problems in real time',
        titleExpired: 'Manage incidents and corrective actions in one place',
        intro:
          'Log tickets, assign owners, and track them through to resolution, with all evidence and conversation in one place.',
        bullet1: 'Report problems with evidence and priority.',
        bullet2: 'Assign owners and coordinate resolution.',
        bullet3: 'Keep full traceability of every ticket until it closes.',
        startTrial: 'Start free trial',
        startTrialError: 'We could not start your free trial. Please try again.',
        disclaimer:
          'When the trial ends, your tickets are kept and you can recover them by upgrading to a Professional or Enterprise plan.',
        knowPlans: 'See the plans',
        contactSales: 'Talk to sales',
        contactSalesIntercomMessage: "Hi, I'd like to know more about Tickets and which plans include it.",
        demoTitle: 'See the resolution process end to end',
        demo1Title: 'All ticket management in one place',
        demo1Description:
          'Review status, priority, and owner for every ticket. Coordinate its resolution from the same record and keep all evidence centralized.',
        demo2Title: 'Report problems from the field instantly',
        demo2Description:
          'Your team can log incidents with photos, comments, and location from the app, so they get assigned and handled right away.',
        demo3Title: 'Track it through to closure',
        demo3Description:
          'Keep visibility into each ticket\'s progress, talk with everyone involved, and log the applied solution to keep full traceability.',
        previous: 'Previous',
        next: 'Next',
        illustrationAlt: 'Tickets module illustration',
        accessLapsed: 'Your Tickets access has ended. You can stay on this screen, but you will need a Professional or Enterprise plan after reloading.',
        illustrationImage:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/ilustracion-tickets-en.svg',
        demo1Image:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-1-en.png',
        demo2Image1:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-2-1-en.png',
        demo2Image2:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-2-2-en.png',
        demo3Image:
          'https://data-scope.s3.us-west-2.amazonaws.com/assets/tickets-pricing/slide-3-en.png',
        remainingDays: '{count} days left in your trial',
      },
    },
    adminAlert:
      'You will be able to see all issues, but to receive updates you must assign yourself as assignee or participant.',
    configure: 'Settings',
    config: {
      findingTypes: 'Issue Types',
      createType: 'Create Type',
      editType: 'Edit',
      deleteType: 'Delete',
      deleteTypeDisabled: 'You cannot be left without issue types',
    },
    integrations: {
      title: 'Issues Integration',
      button: 'Integrations',
      gsheetsMenuName: 'Google Sheets',
      gsheetsIntegrationLabel: 'Go to Google Sheets',
      infoTextPart1: 'To ensure proper, private, and secure integration, share your document with',
      infoTextPart2: 'editor',
      infoTextPart3: 'permissions only to',
      inputLabel: 'New Link',
      inputPlaceholder: 'Enter the link of the document to integrate',
      save: 'Save',
      cancel: 'Cancel',
      copyUrl: 'URL copied!',
      created:
        'Integration successfully configured! Please wait a few seconds for the changes to take effect',
      saved: 'Changes saved successfully!',
      savingError: 'Error configuring the integration',
      confirmation: 'Do you want to save the changes made before exiting?',
      webhooks: 'Webhooks',
      webhookUrl: 'Webhook URL',
      infoWebhooksTextPart1:
        'Automate your workflows by allowing DataScope to trigger processes on external platforms.',
      infoWebhooksTextPart2: 'Keep everything in sync effortlessly.',
      import: 'Import',
      populateGSheet: 'Populate GSheet',
      populatingGSheet: 'Populating GSheet...',
      populateGSheetSuccess: 'Google Sheet populated successfully',
      populateGSheetError: 'Error populating the Google Sheet',
    },
    findingTypes: {
      noType: 'Other',
      createTitle: 'Create Issue Type',
      editTitle: 'Edit Issue Type',
      name: 'Name',
      assignees: 'Assignees',
      assigneesCaption: 'If you do not assign a responsible party, you can do so in the app',
      assigneesNoSearchResults: 'No users match your search',
      removeChipAriaLabel: 'Remove',
      clearAllSelectionAriaLabel: 'Clear all',
      location: 'Location',
      locationCaption: 'If you do not assign a location, you can do so in the app',
      assets: 'Assets',
      save: 'Save',
      update: 'Update',
      cancel: 'Cancel',
      dueDateAndPriority: 'Due Date and Priority',
      priorityInformationBanner:
        'You can select a priority as default (optional). The creator of the issue will not be able to change it but will see its description.',
      dueDate: 'Due Date',
      dueDateCaption: 'This configuration will start counting from the creation of the issue',
      dueDateValueRequired: 'Please enter a value greater than 0',
      dueDatePriorityRequired: 'You must configure the due date for this priority',
      dueDatePriorityCompatibility:
        'In app versions prior to v4.4.2, the closest available due date will be used ({{shortestValue}}).',
      dueDateTypes: {
        days: 'Days',
        hours: 'Hours',
      },
      dueDateTypesSingular: {
        days: 'day',
        hours: 'hour',
      },
      mandatoryRequirements: 'Mandatory requirements',
      mandatoryRequirementsTooltip: 'Select which elements will be mandatory in the issue',
      mandatoryRequirementsNoMatches: 'No options match your search',
      evidence: 'Evidence',
      evidenceDescription: 'Requires at least one image when creating the issue',
      closureComment: 'Closure comment',
      closureCommentDescription: 'Requires a mandatory comment when closing the issue',
      dueDateRequirement: 'Due date',
      dueDateRequirementDescription:
        'The date will be calculated automatically from the defined days/hours',
      configureDueDate: 'Configure due date',
      priority: 'Priority',
      description: 'Description',
      descriptionPlaceholder: 'Write the description or instruction of the priority',
      additionalInformation: 'Additional Information (Optional)',
      additionalInformationBanner:
        'Assign predefined forms for the participants in this issue to complete',
      evidenceBanner:
        'Define whether issue creators must attach photos as evidence at the time of creation.',
      evidenceOptions: {
        none: 'Not required',
        optional: 'Optional',
        required: 'Required',
      },
      typeCreatedSuccess: 'Issue type created successfully',
      typeCreatedError: 'Error creating issue type',
      typeDeletedSuccess: 'Issue type deleted successfully',
      typeDeletedError: 'Error deleting issue type',
      typeUpdatedSuccess: 'Issue type updated successfully',
      typeUpdatedError: 'Error updating issue type',
      deleteTypeAlertTitle: 'Are you sure you want to delete this type of issue?',
      deleteTypeAlertMessage:
        'If you delete it, you will not be able to recover it, but the information related to it will remain on the platform',
    },
  },
  commonComponents: {
    sortByName: {
      unsorted: 'Sort by name',
      ascending: 'Sorted A to Z',
      descending: 'Sorted Z to A',
    },
    formSelector: {
      title: 'Forms',
      addForm: 'Add form',
      searchPlaceholder: 'Search form, folder...',
      forms: 'Forms',
      folders: 'Folders',
      save: 'Save',
      cancel: 'Cancel',
      see: 'See',
      more: 'more',
      close: 'Close',
      maxFormsSelected: 'You have reached the maximum number of forms selected',
      noFormsFound: 'No forms found',
      noFoldersFound: 'No folders found',
    },
    confirmActionAlert: {
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    formDropdownSelector: {
      loading: 'Loading...',
      noFormsFound: 'No forms found',
    },
    dateRangePicker: {
      last7Days: 'Last 7 days',
      last14Days: 'Last 14 days',
      last30Days: 'Last 30 days',
      last60Days: 'Last 60 days',
      last90Days: 'Last 90 days',
      thisYear: 'This year',
      today: 'Today',
      thisWeek: 'This week',
      nextWeek: 'Next week',
      next7Days: 'Next 7 days',
      next14Days: 'Next 14 days',
      next30Days: 'Next 30 days',
      next60Days: 'Next 60 days',
      next90Days: 'Next 90 days',
      moreOptions: 'More options',
      pastRanges: 'Past Ranges',
      futureRanges: 'Future Ranges',
    },
    locationSelector: {
      loading: 'Loading...',
      noLocationsFound: 'No locations found',
      placeholder: 'Select a location',
      nestableLocations: 'Locations',
      legacyLocations: 'List of Locations (Old)',
    },
  },
  webHooks: {
    title: 'WebHooks',
    new: {
      title: 'Create new WebHook',
      token: 'Token:',
      expires_in: 'Expires in:',
      expires_at: 'Expires at:',
      form: 'Form',
      select_form: 'Select a form',
      select_all_forms: 'All Forms',
      url: 'Connection URL',
      example_url: 'http://www.yourserver.com/service',
      send_modifications: 'Send modifications',
      oauth_checkbox: 'Authenticate with OAuth2.0',
      save: 'Save',
      back: 'Back to WebHooks',
      configure_oauth: 'Configure OAuth 2.0',
      access_token: 'Access Token URL',
      client_id: 'Client ID',
      client_secret: 'Client Secret Key',
      scope: 'Scope',
      save_oauth: 'Save OAuth Configuration',
      save_oauth_success: 'OAuth Token created successfully',
      save_oauth_error: 'There was an error while creating the OAuth Token',
      token_details: 'Token Details',
      create_webhook: 'Create WebHook',
      create_webhook_success: 'WebHook created successfully',
      create_webhook_error: 'There was an error while creating the WebHook',
    },
    update: {
      update_webhook: 'Update WebHook',
      update_webhook_success: 'WebHook updated successfully',
      update_webhook_error: 'There was an error while updating the WebHook',
    },
    webhook_not_found: 'WebHook not found',
    load_webhook_error: 'There was an error while loading the WebHook',
  },
  answerView: {
    correction: {
      correct: 'Correct',
      success: 'Form corrected. The signature request was sent successfully',
      error: 'We could not resend the signature request. It is still rejected, you can try again.',
      alreadyCorrected: 'This request was already corrected and is awaiting signature. There is no need to correct it again.',
      alreadySigned: 'This answer has an open signature request and cannot be edited.',
      manualResendNotice: 'Correcting does not resend the signature request on its own: this form does not send it automatically. After saving, send it again.',
      savedResendByHand: 'Form corrected. Remember to send the signature request again: this form does not send it automatically.',
      goToRequest: 'View the request',
    },
    alreadyRejectedSignature: 'You declined to sign this form',
    rejectConfirmationTitle: 'Are you sure you want to reject this request?',
    rejectConfirmationDescription: "Once rejected, you won't be able to sign this form again.",
    reject: 'Reject',
    rejectSuccess: 'Signature request rejected!',
    rejectError: 'Could not reject the signature',
    rejectAlreadyRejected:
      'The request had already been rejected, so it could not be rejected again.',
    location: 'Location',
    address: 'Address',
    assignee: 'Assignee',
    taskInformation: 'Assigned Task Information',
    description: 'Description',
    tasks: 'Tasks',
    answeredFromMobile: 'Answered from mobile',
    answeredFromWeb: 'Answered from web',
    electronicallySignedBy: 'Electronically signed by:',
    verifySignatureAlert:
      'To sign the form you must verify your signature. You only need to do this once.',
    verifySignature: 'Verify signature',
    configureSignatureAlert:
      'To sign the form you must configure and verify your signature. You only need to do this once.',
    configureSignature: 'Configure electronic signature',
    lackOfPermissions:
      'You do not have permission to edit your profile. Please request that the administrator completes your information so you can continue.',
    sign: 'Sign',
    alreadySignedAlert: 'You have already signed this form',
    rejectedAlert: 'You rejected this signature request',
    goToSignatures: 'View all Signatures',
    signatureConfigAlert: 'Please check your signature configuration',
    reverifySignatureAlert:
      'Your account signature configuration was updated. You need to verify your signature again to sign.',
    quorumReached: {
      title: 'Done! The required signatures have been reached.',
      description:
        'This document already has the necessary signatures in your group. You do not need to sign, but you can check if you have other pending signatures.',
      button: 'Go to signatures',
    },
    signSuccess: 'Form signed successfully!',
    signError: 'There was an error signing the form',
    signatureVerifySuccess:
      'You have successfully verified your electronic signature! Now you will be able to sign all your forms',
    signatureVerifyError: 'There was an error verifying your electronic signature',
    checkedCountInfo: 'selected items',
    checkedCountListInfo: 'Elements selected from a list of',
    items: 'items',
    total: 'total',
    group: 'Group',
    nestableLocationBelongsTo: 'Belongs to',
    attachedFiles: 'These are the files attached to this question',
    editAnswer: 'Edit Answer',
    editAnswerDisabled: 'You cannot edit the answer because it has a signature request',
    editAnswerNoPermission: 'You do not have permission to edit this answer',
    viewDocumentValidation: 'View Document Validation',
    qrUniqueDocumentTitle: 'Unique document QR code',
    qrUniqueDocumentDescription:
      'This document includes an electronic signature; its authenticity can be verified by scanning the QR code.',
    metadataComments: {
      item: 'Item',
      answer: 'Answer',
      description: 'Comment',
      images: 'Images',
      issues: 'Issue created',
      viewIssue: 'View issue',
    },
    expiredLink: {
      description: 'This link has expired. Request a new one by clicking the button',
      button: 'Request link',
      newLinkRequestedSuccess: 'The link has been sent to your email',
      newLinkRequestedError: 'There was an error sending the link',
    },
    externalUserSign: {
      title: 'Register your signature',
      registeredDescription:
        'Your signature is registered, please confirm your details to continue',
      unregisteredDescription:
        'Your signature is not registered; to sign, please complete the following details',
      name: 'Full name',
      company: 'Company',
      role: 'Position',
      confirm: 'Continue',
      cancel: 'Cancel',
      success: 'Form signed successfully!',
      error: 'There was an error signing the form',
    },
    rejectModal: {
      title: 'Reject request',
      subtitle: 'Enter the reason for rejecting the signature request',
      selectSubtitle: 'Select the reason to reject the request:',
      placeholder: 'Write the reason here (Required)',
      minLength: 'Minimum 5 characters',
      otherOption: 'Other',
      cancel: 'Cancel',
      confirm: 'Reject',
    },
    locationInfo: {
      title: 'Detected location information',
      description: 'The answer was detected in a location from your list of locations',
      viewInMap: 'View in map',
      nameAndDistance: 'Name and distance',
      distanceHelpIcon:
        'The location was automatically detected. The distance between the detected location and the point from where the answer was submitted is shown.',
      awayFromLocation: 'km away from the location',
      detectedByGps: 'Detected by GPS',
    },
    formatErrors: {
      warningMessage: 'There were problems displaying certain answers. Please contact support.',
      workingWarningMessage:
        'We are aware of an error in the data registration. We are working on a solution.',
      answerListTitle: 'Answers with display issues:',
    },
    signature: {
      name: 'Name',
      idNumber: {
        CL: 'RUT',
        PE: 'DNI',
        MX: 'CURP',
        CO: 'CC',
        AR: 'DNI',
        PY: 'CI',
        ES: 'DNI/NIE',
        BR: 'CPF',
        UY: 'CI',
        BO: 'CI',
        EC: 'Cedula',
        VE: 'Cedula',
        US: 'SSN',
        CA: 'SIN',
        DO: 'Cedula',
        CR: 'Cedula',
        PA: 'Cedula',
        GT: 'DPI',
        SV: 'DUI',
        HN: 'DNI',
        NI: 'Cedula',
        PR: 'SSN',
        CU: 'CI',
        JM: 'TRN',
        PT: 'NIF',
        FR: 'INSEE',
        DE: 'Tax ID',
        IT: 'Codice Fiscale',
        GB: 'National Insurance Number',
        IE: 'PPS Number',
        NL: 'BSN',
        BE: 'National Number',
        CH: 'AHV Number',
        AT: 'Social Security Number',
        SE: 'Personal Number',
        NO: 'National ID',
        DK: 'CPR Number',
        FI: 'Personal Identity Code',
        IS: 'Kennitala',
        PL: 'PESEL',
        CZ: 'Birth Number',
        SK: 'Birth Number',
        HU: 'Tax Number',
        RO: 'CNP',
        BG: 'EGN',
        GR: 'AMKA/AFM',
        HR: 'OIB',
        SI: 'EMSO',
        RS: 'JMBG',
        BA: 'JMBG',
        ME: 'JMBG',
        MK: 'EMBG',
        MT: 'ID Card',
        CY: 'ID Number',
        LU: 'National ID',
        LT: 'Personal Code',
        LV: 'Personal Code',
        EE: 'Personal Code',
        TR: 'TC Kimlik No',
        IL: 'ID Number',
        SA: 'National ID',
        AE: 'Emirates ID',
        QA: 'QID',
        KW: 'Civil ID',
        BH: 'CPR',
        OM: 'Civil ID',
        JO: 'National ID',
        LB: 'ID Number',
        EG: 'National ID',
        MA: 'CIN',
        TN: 'CIN',
        DZ: 'National ID',
        ZA: 'ID Number',
        NG: 'NIN',
        KE: 'ID Number',
        GH: 'Ghana Card',
        UG: 'National ID',
        TZ: 'NIDA',
        RW: 'National ID',
        BW: 'Omang',
        NA: 'ID Number',
        ZM: 'NRC',
        ZW: 'National ID',
        ET: 'National ID',
        CN: 'National ID',
        IN: 'Aadhaar',
        PK: 'CNIC',
        BD: 'NID',
        JP: 'My Number',
        KR: 'RRN',
        SG: 'NRIC/FIN',
        MY: 'MyKad',
        ID: 'KTP',
        PH: 'UMID',
        TH: 'National ID',
        VN: 'CCCD',
        HK: 'HKID',
        TW: 'National ID',
        LK: 'NIC',
        NP: 'National ID',
        AU: 'TFN/Medicare',
        NZ: 'IRD Number',
        RU: 'SNILS',
        UA: 'Tax Number',
        BY: 'National ID',
        KZ: 'IIN',
        UZ: 'PINFL',
        GE: 'Personal Number',
        AM: 'Social Card',
        AZ: 'FIN',
      },
      email: 'Email',
      date: 'Date',
      of: 'of',
      rejectedInfoPartial: 'rejected this document on',
      rejectedWithReason:
        '{name} rejected this document on {date} because {reason}. We invite you to make the necessary corrections to the current document and generate a new signature request.',
      rejectedWithoutReason:
        '{name} rejected this document on {date}. We invite you to make the necessary corrections to the current document and generate a new signature request.',
      rejectedWithReasonStandardized:
        '{name} rejected this document on {date} because {reason}. The request was halted until the document is corrected and resent.',
      rejectedWithoutReasonStandardized:
        '{name} rejected this document on {date}. The request was halted until the document is corrected and resent.',
      rejectedWithReasonStandardizedSelf:
        'You rejected this document on {date} because {reason}. The request was halted until the document is corrected and resent.',
      rejectedWithoutReasonStandardizedSelf:
        'You rejected this document on {date}. The request was halted until the document is corrected and resent.',
      weInviteYouTo: 'We invite you to',
      makeCorrections:
        'make the necessary corrections to the current document and generate a new signature request.',
    },
    back: 'Back',
    paywall: {
      title: 'You have reached the limit of answers. Upgrade your plan to see more',
      button: 'Upgrade plan',
      chat_message: 'Hello, I need to see more answers. How can I upgrade my plan?',
    },
    downloadPdf: 'Download PDF',
    status: 'Status',
    noStatus: 'No status',
    activityPeriodTime: {
      startTime: 'Start Time',
      endTime: 'End Time',
      activity: 'Activity',
      duration: 'Duration',
    },
  },
  electronic_signature: {
    verifySignature: 'Verify Signature',
    annex: 'Annex',
    sendCode: 'Send code',
    errorSendingCode: 'An error occurred while sending the code',
    successSendingCode: 'Code sent successfully',
    code_sent_to_email: 'We sent the verification code to your email:',
    resendCodeLabel: "Didn't receive the code?",
    resend: 'Resend',
    incorrect_code: 'Incorrect code, you have {remaining_attempts} attempts left',
    maxAttemptsReached: 'You have reached the maximum number of attempts, a new code has been sent',
    errorVerifyingCode: 'Error verifying the code',
    back: 'Back',
    share: 'Share',
    signatures: {
      title: 'My Signatures',
      signature_date: 'Signature Date',
      noPendingSignatures: 'Congratulations! You have no pending signatures at this time',
      noCompletedSignatures: 'You have no completed signatures at this time',
      noRejectedSignatures: 'You have no rejected signatures at this time',
      noSignaturesAvailable: 'You have no signatures available at this time',
      selected: 'Selected',
      sign: 'Sign',
      downloadSigned: 'Download',
      massiveSignError: 'There was an error signing the forms',
      massiveSignSuccess: 'Forms signed successfully',
      downloadError: 'There was an error downloading the file',
    },
    documentValidation: {
      validDocumentTitle: 'Valid Document',
      formSummary: 'Form {form_name} answered by {user_name}. Response date: {answer_date}.',
      openDetails: 'Access the document details here',
      respondedByLabel: 'Answered by:',
      answerDateLabel: 'Response date:',
      signedByTitle: 'Signed by:',
      signerNameLabel: 'Name',
      signerRutLabel: 'ID',
      signerEmailLabel: 'Email',
      signerDateLabel: 'Date',
      accessRestrictionNote: 'To access the document details you must be logged in to DataScope',
      footerLegalText:
        'This document complies with the applicable regulations and its electronic signature is validated by DataScope.',
      footerOrdinanceIntro: 'Check the ordinance ',
      footerOrdinanceLinkLabel: 'here',
      footerCta: 'Digitize your documents with DataScope',
      noSigners: 'This document does not have any registered signatures yet',
      error: 'We could not validate this document. Please check the link or contact support.',
    },
    filters: {
      date: 'Date',
      datePopoverTitle: 'Filter by date',
      allDates: 'All',
      form: 'Form',
      formPopoverTitle: 'Filter by forms',
      requester: 'Owner',
      requesterPopoverTitle: 'Filter by owner',
      location: 'Location',
      locationPopoverTitle: 'Filter by location',
      participants: 'Participants',
      participantsPopoverTitle: 'Filter by participant',
      all: 'All',
      selected: 'selected',
      search: 'Search',
      noOptions: 'No results found',
      status: 'Status',
      statusPopoverTitle: 'Filter by status',
      formCode: 'Form code',
      formCodePopoverTitle: 'Filter by form code',
      formCodePlaceholder: 'Type the code',
      clearAll: 'Clear filters',
      deletedSuffix: 'Deleted',
      inactiveSuffix: 'Inactive',
      allTab: 'Users',
      groupTab: 'Groups',
      noUsers: 'No users found',
      noGroups: 'No groups found',
      formsTab: 'Forms',
      foldersTab: 'Folders',
      dateFieldRequested: 'Request date',
      dateFieldSignedMine: 'Signature date (completed signatures)',
      dateFieldSignedRequest: 'Signature date (finished signatures)',
      dateFieldSignedShort: 'Signature date',
      noForms: 'No forms found',
    },
    statusFilter: {
      allStatuses: 'All',
      rejected: 'Rejected',
      pending: 'Pending',
      completed: 'Completed',
      ongoing: 'Ongoing',
      finished: 'Finished',
    },
    statusChip: {
      pending: 'Pending',
      signed: 'Signed',
      ongoing: 'Ongoing',
      finished: 'Finished',
      rejected: 'Rejected',
    },
    lastActivity: {
      title: 'Last activity',
      signed: 'signed the document',
      rejected: 'rejected the request',
      reason: 'Reason',
      unknownUser: 'A user',
      rejectedBy: 'Rejected by',
      rejectReasonLabel: 'Rejection reason',
      nextSigner: 'Next',
      signedShort: 'Signed',
      rejectedShort: 'Rejected',
      correctedShort: 'Request corrected',
      onDate: 'On',
      andMore: 'and {count} more',
      moreSigners: 'more signers',
      sent: 'Request sent',
    },
    statusCards: {
      pending: 'Pending',
      signed: 'Signed',
      ongoing: 'Ongoing',
      finished: 'Finished',
      rejected: 'Rejected',
      requiresAction: 'Require action',
      filterHint: 'Click to filter',
      totalSignatures: 'Total signatures',
      totalRequests: 'Total requests',
    },
    requests: {
      notifyByEmail: 'Notify via email',
      title: 'Sent Requests',
      mandatory: 'Required signature',
      optional: 'Optional signature',
      ongoing: 'Ongoing',
      completed: 'Completed',
      searchPlaceholder: 'Search by user or form...',
      form: 'Form',
      requestDate: 'Request Date',
      requestDateLong: 'Request date',
      requestedBy: 'Requested by',
      goToSign: 'Go to sign',
      signatureDate: 'Signature Date',
      signatures: 'Signatures',
      signed: 'Signed',
      deleteRequest: 'Delete Request',
      viewRequestDetail: 'View request detail',
      correct: 'Correct',
      correctNoPermission: 'You do not have permission to edit this rejected signature request',
      pending: 'Pending',
      actions: 'Actions',
      deleteSuccess: 'Request deleted successfully',
      notifyByEmailSuccess: 'Users notified successfully',
      notifyByEmailError: 'There was an error notifying the users',
      loadError: 'We could not load the list. Please try again.',
      deleteError: 'There was an error deleting the request',
      noOngoingRequests: 'All set! You have no ongoing requests at the moment.',
      noCompletedRequests: 'You have no completed requests at the moment.',
      noRejectedRequests: 'You have no rejected requests at the moment.',
      noRequestsAvailable: 'You have no requests available at this time',
      noFilterResults: 'No signatures available at the moment',
      clearFilters: 'Clear filters',
      shareModal: {
        title: 'Share completed signature request',
        share: 'Share',
        infoAlert:
          'A file will be sent by email. Recipients will be able to access and review the details easily.',
        emailInstruction: 'Enter the email address where you want to send the file.',
        inputInstruction: 'You can quickly add tasks by separating them with commas ",".',
        cancel: 'Cancel',
      },
      shareSuccess: 'Request shared successfully',
      shareError: 'There was an error sharing the request',
      deleteWarningTitle: 'Are you sure you want to delete this request?',
      deleteWarningMessage:
        'Signatures that have already been completed will remain valid and will be saved in the history.',
      timeline: {
        title: 'Request details',
        close: 'Close',
        correctRequest: 'Correct request',
        createdRequired: '{user} has sent a mandatory signature request',
        createdOptional: '{user} has sent an optional signature request',
        createdRequiredSimultaneous: '{user} has sent a mandatory signature request to:',
        createdOptionalSimultaneous: '{user} has sent an optional signature request to:',
        createdQuorumSimultaneous: '{user} has sent a signature request',
        createdRequiredSequential: '{user} has sent a mandatory signature request with this order:',
        createdOptionalSequential: '{user} has sent an optional signature request with this order:',
        createdQuorumSequential: '{user} has sent a signature request with this order:',
        signed: '{user} signed the document',
        rejected: '{user} rejected the request',
        rejectReason: 'Reason',
        signatureRequested: 'Request sent to {user} ({number} signers)',
        signatureRequestedGroupSingular: 'Request sent to {users} (Signer group {group})',
        signatureRequestedGroupPlural: 'Request sent to {users} (Signers group {group})',
        completed: 'All required signatures have been completed. The document is now ready',
        corrected: 'Request corrected by {user}',
        signer: 'Signer',
        signerSingular: 'signer',
        signerPlural: 'signers',
        group: 'Group',
        quorumRequiredSingular: 'at least {min} signature required',
        quorumRequiredPlural: 'at least {min} signatures required',
      },
      tooltip: {
        signed: 'Request completed',
        rejected: 'Request rejected',
      },
    },
    promo: {
      title: 'Sign reports digitally and ensure processes',
      description:
        'With the Signatures module, you can request and sign processes simply and securely.',
      actionButton: 'I want to implement Signatures!',
      moreInfoTitle: 'Ensure full traceability and minimize errors',
      infoPoint1: 'Request signatures from your field team and send automatic notifications',
      infoPoint2: 'Ensure the compliance of your processes',
      infoPoint3: 'Approved by the Labor Department (valid only in Chile)',
      infoPoint4: 'Access your data securely from any device',
      moreInfoButton: 'I want more information!',
      moreInfoLink:
        'https://help.mydatascope.com/en/articles/8728763-verified-electronic-signature',
    },
    emptyState: {
      mainBanner: {
        title: 'Sign reports digitally and ensure processes',
        description:
          'With the "Signatures" module, you can request and sign processes simply and securely.',
        actionButton: 'I want to implement Signatures!',
        actionButtonError:
          'There was an error requesting implementation. Contact support for more information.',
        actionButtonSuccess: 'Implementation requested successfully',
        actionButtonTooltipAdminUnrequested: 'Request implementation',
        actionButtonTooltipAdminRequested: 'Implementation has already been requested',
        actionButtonTooltipUser: 'Only the account administrator can perform this action',
      },
      gallery: {
        title: 'Manage legally valid signatures',
        verifySignatures: 'Verify and save staff signatures',
        verifySignaturesAlt: 'Smartphone showing signature verification on the app',
        requestSignatures: 'Request signatures on specific forms',
        requestSignaturesAlt:
          'Smartphone showing a form response and the "request signature" button on the app',
        acceptSignatures: 'Accept or reject signatures',
        acceptSignaturesAlt:
          'Smartphone showing a response with requested signature and accept/reject buttons',
        trackSignatures: 'Track the status of each signature',
        trackSignaturesAlt:
          'Smartphone showing a list of incomplete signature requests with details on the app',
        pdfSignatures: 'Get PDF reports with digital signatures',
        pdfSignaturesAlt:
          'Smartphone showing a PDF report with digital signatures included and highlighted',
      },
      requestMoreInfo: {
        title: 'Add it to your plan today!',
        description:
          'Talk to a specialist and discover how to implement the module in your organization',
        button: 'Request more information',
        link: 'https://datascope.io/en/nueva_firma/#',
      },
      newFeatures: {
        title: 'Starting today, you can use these new features!',
        preConfigTitle: 'Preconfigure signers',
        preConfigDescription:
          'Predefine who must sign your documents to automate recurring workflows and save time.',
        externalSignatureTitle: 'Request signatures from external users',
        externalSignatureDescription:
          'Invite collaborators outside your organization to sign securely, without needing a DataScope account.',
        sequentialSignatureTitle: 'Configure signature sequence',
        sequentialSignatureDescription:
          'Set a predefined signing order for documents involving multiple signers with different levels of authority.',
      },
    },
    activation: {
      processTitle: 'Your Signatures module activation request is already in process!',
      processMessage:
        'A representative from our team will contact you to explain the details of the Signatures module activation process.',
      stepsTitle: 'Next steps',
      step1Title: 'Signatures module implementation request entered successfully.',
      step2Title: 'A specialist from DataScope will contact you.',
      step2Description: 'Maximum 1 business day',
      step3Title: 'Presentation of the Signatures module.',
      step3Description: 'Date to coordinate with the specialist',
      step4Title: 'Activation of the Signatures module',
      step4Description: 'You will be able to access it from this same tab!',
    },
  },
  resume: {
    stats: {
      assignedTasks: 'Assigned Tasks',
      completedTasks: 'Completed tasks',
      forms: 'Forms',
      totalForms: 'Total answered',
      locations: 'Visited Locations',
      totalLocations: 'Total locations',
      signatures: 'Signatures',
      completedSignatures: 'Completed signatures',
      findings: 'Issues',
      closedFindings: 'Closed issues',
      previousDays: 'previous days',
    },
    emptyState: {
      description:
        "You haven't answered any form yet! Start optimizing your processes by creating the first one",
      createFirstForm: 'Create a form now',
    },
    statuses: {
      pending: 'Pending',
      accepted: 'Accepted',
      rejected: 'Rejected',
      noStatus: 'No Status',
    },
    table: {
      configure: 'Configure',
      viewAnswer: 'View Answer',
      form: 'Form',
      code: 'Code',
      user: 'User',
      date: 'Date',
      status: 'Status',
      actions: 'Actions',
      changeLog: 'Change Log',
      modifyAnswer: 'Modify Answer',
      chat: 'Chat',
      sendToGoogleSheets: 'Send to Google Sheets',
      sendBackupToEmail: 'Send backup to email',
      downloadPdf: 'Download PDF',
      duplicateAnswer: 'Duplicate Answer',
      statusUpdateError: 'There was an error updating the status of the answer',
      noResults: 'No form answers found that match the applied filters',
      deleteAnswer: 'Delete',
      recoverAnswer: 'Recover',
    },
    bulkActions: {
      delete: 'Delete',
      changeStatus: 'Change Status',
      selected: 'selected',
      confirmDelete: 'Are you sure you want to delete {count} form answers?',
      confirmDeleteDescription: 'Once deleted, they will not be recoverable',
      cancel: 'Cancel',
      selectStatus: 'Select Status',
      select: 'Select',
      statuses: 'Statuses',
      selectStatusPlaceholder: 'Select a status',
      statusesUpdated: 'Statuses updated successfully!',
      errorUpdatingStatuses: 'Error updating statuses',
      deleteSuccess: 'Answers deleted successfully!',
      deleteError: 'Error deleting answers',
      recover: 'Recover',
      recoverSuccess: 'Answers recovered successfully!',
      recoverError: 'Error recovering answers',
    },
    filters: {
      addFilter: 'Add Filter',
      clearFilters: 'Clear Filters',
      dateRange: {
        title: 'Date',
        popoverTitle: 'Filter by date',
      },
      location: {
        title: 'Location',
        popoverTitle: 'Filter by location',
        noLocations: 'No locations found',
      },
      form: {
        title: 'Form',
        popoverTitle: 'Filter by form',
        inactive: 'Inactive',
        deleted: 'Deleted',
        folders: 'Folders',
        forms: 'Forms',
        noForms: 'No forms found',
      },
      status: {
        title: 'Status',
        popoverTitle: 'Filter by status',
      },
      user: {
        title: 'User',
        popoverTitle: 'Filter by user',
        allTab: 'Users',
        groupTab: 'Groups',
        noUsers: 'No users found',
        noGroups: 'No groups found',
      },
      formCode: {
        title: 'Form Code',
        popoverTitle: 'Filter by form code',
        placeholder: 'Enter form code',
      },
      questionAndAnswer: {
        title: 'Question and Answer',
        popoverTitle: 'Filter by question and answer',
        questionLabel: 'Question',
        questionPlaceholder: 'Select a question',
        questionTextInputPlaceholder: 'Write the question name',
        answerLabel: 'Answer',
        answerDisabledPlaceholder: 'Select a question to activate the filter',
        answerTextInputPlaceholder: 'Write a question name to activate the filter',
        answerPlaceholder: 'Write the answer',
        info: 'The filter will only apply if there is a question and an answer',
        disabledTooltip: 'To use this filter, you must first add a form filter',
      },
      finding: {
        title: 'Issue',
        popoverTitle: 'Filter by issue',
        includesFinding: 'Includes issue',
        withoutFindings: 'Without issues',
      },
      signature: {
        title: 'Signature',
        popoverTitle: 'Filter by signature',
      },
      answeredFrom: {
        title: 'Answered from',
        popoverTitle: 'Filter by answered from',
        mobile: 'Mobile',
        web: 'Web',
      },
      assets: {
        title: 'Assets',
        popoverTitle: 'Filter by assets',
        noAssets: 'No assets found',
      },
    },
    signature: {
      mandatoryIncomplete: 'Mandatory signature - Pending',
      mandatoryComplete: 'Mandatory signature - Complete',
      optionalIncomplete: 'Optional signature - Pending',
      optionalComplete: 'Optional signature - Complete',
      rejected: 'Rejected signature',
      quorumPending: 'Pending signature',
      quorumComplete: 'Complete signature',
    },
    recentTitle: 'Recent answers',
    deletedTitle: 'Deleted answers',
    searchBarPlaceholder: 'Search...',
    dateRange: 'Showing results for',
    changeLog: {
      title: 'Change Log',
      details: 'View details',
      userChangedAnswer: '{user} changed the answer',
      userChangedState: '{user} changed the status of the answer to {state}',
      userRecoveredAnswer: '{user} recovered the answer',
      userDeletedAnswer: '{user} deleted the answer',
      userDuplicatedAnswer: '{user} duplicated the answer',
      userStartedAnswer: '{user} started to answer',
      userResetState: '{user} reset the status of the answer',
      googleSheets: 'Google Sheets',
      webhookSyncErrors: '{count} errors syncing with',
      webhookSyncError: '1 error syncing with',
      webhookSyncRestored: 'Sync restored with',
      webhookSyncOk: 'Successful sync with',
      viewErrorDetails: 'View error details',
      hideErrorDetails: 'Hide errors',
    },
    close: 'Close',
    export: {
      title: 'Export',
      taskForm: 'Form',
      dateRange: 'Date range',
      downloadFormat: 'Download format',
      email: 'Email',
      downloadFormats: {
        answers: 'Excel grouped by answer',
        forms: 'Excel grouped by form',
        subforms: 'Excel grouped by repeatable fields',
        pdfs: 'Excel with PDF documents',
        pdfsZip: 'PDF documents in ZIP',
      },
      exportInfo: 'The answers will be exported according to the table filters',
      exportFormFilterRequired: 'To export the answers, you must first filter by form',
      exportDateRangeLimit: 'Export limit: 180 days (6 months). Select a shorter date range',
      cancel: 'Cancel',
      success: 'Export sent successfully',
      error: 'There was an error exporting the answers',
      disabledForFreeUser: 'Update your plan to enable data export',
      selectOrFilterToExport: 'Filter by form or select answers to export.',
      clearSelectionForExcel: 'Clear the selection to export to Excel.',
      formatPlaceholder: 'Select format',
      documentsGroup: 'Documents',
      excelGroup: 'Excel',
      excelUnavailableReason:
        'Excel exports the whole filter, not a selection. Clear the selection to export to Excel.',
      zipSelectionNotice: '{count} selected answers will be exported as a ZIP file',
      filterNotice: '{count} answers will be exported',
      zipFilterNotice: '{count} answers will be exported as a ZIP file',
      zip: {
        countNotice: '{count} answers will be downloaded as a ZIP with their PDF documents.',
        emptyNotice: 'There are no answers to download with the current filters.',
        generating:
          'We are preparing your ZIP file. This may take a few minutes, please keep this window open.',
        done: 'Your ZIP is ready. The download will start automatically. If it does not, use the link below.',
        doneWithWarnings:
          'Your ZIP is ready, but {count} documents could not be included. Check the errores.csv file inside the ZIP.',
        error: 'There was an error generating the ZIP. Please try again.',
        errorConflict:
          'You already have an export in progress. Wait for it to finish and try again.',
        errorTimeout: 'The export is taking too long. Please try again later.',
        action: 'Download ZIP',
        progressPill: 'Generating PDF files',
        downloadPart: 'Download part {n}',
      },
    },
    sendToGoogleSheets: {
      success: 'Sent to Google Sheets successfully',
      error: 'There was an error sending the answer to Google Sheets',
      gsheetBusy: 'Google Sheets is busy right now. Please wait a few minutes and try again.',
      integrationError:
        'Could not send to Google Sheets. Check your Google Sheets integration (permissions, formulas and spreadsheet link).',
      unknownError:
        'An unknown error occurred while sending to Google Sheets. Please try again later.',
      sendModifyConfirmTitle: 'This answer has already been sent to Google Sheets',
      sendModifyConfirmMessage:
        'This integration does not have the edit sync feature enabled. Re-sending manually may create duplicate rows in the spreadsheet. Do you want to continue anyway?',
      sendModifyConfirmButton: 'Yes, send anyway',
    },
    duplicateAnswer: {
      success: 'Answer duplicated successfully!',
      error: 'Error duplicating answer',
    },
    sendBackupModal: {
      title: 'Send backup to email',
      description: 'Write the email where you want to receive the backup of this form',
      send: 'Send',
      cancel: 'Cancel',
    },
    deleteAnswer: {
      title: 'Are you sure you want to delete this answer?',
      description:
        'Once deleted, it will not be recoverable. You can recover it by filtering by deleted answers and restoring it from its configuration.',
      confirm: 'Delete',
      cancel: 'Cancel',
      success: 'Answer deleted successfully!',
      error: 'Error deleting answer',
    },
    recoverAnswer: {
      success: 'Answer recovered successfully!',
      error: 'Error recovering answer',
    },
    statusSelector: {
      newStatus: 'Select or create a status',
      newStatusPlaceholder: 'Write here the new status',
      newStatusError: 'The status already exists',
      delete: 'Delete',
      color: 'Color',
      colors: {
        white: 'White',
        blue: 'Blue',
        yellow: 'Yellow',
        red: 'Red',
        green: 'Green',
        gray: 'Gray',
      },
      editStatusError: 'Error updating status',
      deleteStatusError: 'Error deleting status',
      createStatusError: 'Error creating status',
      deleteConfirmationTitle: 'Are you sure you want to delete this status?',
      deleteConfirmationMessage:
        'Once deleted, it will not be recoverable. But the answers that use it will not be affected.',
    },
    chat: {
      notifyUsersError: 'Error notifying users',
    },
    filtersLinkCopy: {
      tooltip: 'Copy link with filters',
      success: 'Link copied to clipboard',
      error: 'Could not copy link. Check browser permissions.',
    },
    answerView: {
      previous: 'Previous',
      next: 'Next',
    },
  },
  assets: {
    title: 'Assets',
    assetsSearchPlaceholder: 'Search by asset name or code',
    historySearchPlaceholder: 'Search by asset name, code or user',
    noAssets: 'No assets found.',
    noAssetMeters: 'There are no meters configured for this asset',
    noHistory: 'No history found.',
    create: 'Create',
    update: 'Update',
    createAsset: 'Create Asset',
    name: 'Name',
    configuration: 'Configuration',
    addUsers: 'Add users',
    showAll: 'Show all ({count})',
    showLess: 'Show less',
    usersAssignedSuccess: 'Users assigned successfully',
    usersAssignedError: 'Error assigning users',
    history: 'History',
    code: 'Code',
    dateAndTime: 'Date and Time',
    asset: 'Asset',
    modifiedField: 'Modified Field',
    modification: 'Modification',
    modifiedBy: 'Modified By',
    createNewAsset: 'Create new asset',
    editAsset: 'Edit asset',
    assetInformation: 'Asset information',
    metersDescription: 'Link and manage the meters of each asset to register readings accurately',
    namePlaceholder: 'Asset name',
    codePlaceholder: 'Serial number, plate or unique ID',
    location: 'Location',
    locationPlaceholder: 'Select a location',
    restrictAccess: 'Restrict access to this asset to specific users',
    usersAndGroups: 'Responsible users and groups',
    description: 'Description',
    descriptionPlaceholder: 'Write a description for the asset',
    meterType: 'Meter type',
    meterTypePlaceholder: 'Select a meter type',
    meter: 'Meter',
    lastMeasurement: 'Last Measurement',
    lastSyncedMeasurement: 'Last synced measurement: ',
    lastMeasurements: 'Last Measurement(s)',
    listFilters: {
      location: 'Location',
      lastMeasurementDate: 'Last Measurement Date',
      filterByLocation: 'Filter by location',
      customField: 'Custom field',
      selectField: 'Select a field',
      selectOption: 'Select an option',
      option: 'Option',
      dateRange: 'Date range',
      value: 'Value',
      selectDateRange: 'Select range',
      enterValue: 'Enter a value',
      clearOption: 'Clear option',
      filterByCustomField: 'Filter by custom field',
      field: 'Field',
      noOptions: 'No options available',
      search: 'Search',
    },
    actions: 'Actions',
    viewDetails: 'View details',
    edit: 'Edit',
    delete: 'Delete',
    edited: 'Edited',
    editedBy: 'Edited by',
    previousValue: 'Previous value',
    confirmDeleteTitle: 'Are you sure you want to delete this asset?',
    deactivateTitle: 'Deactivate asset',
    deactivateWithPlanningsDescription:
      'This asset has {count} active plannings that will be paused automatically until it is reactivated. It will also no longer appear in asset lists.',
    deactivateDescription: 'This asset will no longer appear in asset lists.',
    pausedMaintenanceCount: '{count} paused maintenance',
    pausedMeterTooltipInactivity: 'Meter paused due to inactivity',
    pausedMeterTooltipDeactivated: 'Maintenance paused due to deactivated asset',
    confirmDeleteDescription:
      'The asset {assetName} will be deleted, but the data registered previously will be preserved.',
    cancel: 'Cancel',
    assetCreated: 'Asset created successfully',
    assetRestored: 'Asset restored',
    assetUpdated: 'Asset updated successfully',
    assetDeleted: 'Asset deleted successfully',
    assetDeletedError: 'Error deleting asset',
    activate: 'Activate',
    deactivate: 'Deactivate',
    assetDeactivated: 'Asset deactivated successfully',
    assetDeactivatedError: 'Error deactivating asset',
    assetReactivated: 'Asset reactivated successfully',
    assetReactivatedError: 'Error reactivating asset',
    confirmDeactivateTitle: 'Are you sure you want to deactivate this asset?',
    confirmDeactivateDescription:
      'The asset {assetName} will be deactivated. It will still appear in the table but with limited access.',
    assetUpdatedError: 'Error updating asset',
    noAssetPermissions: 'You do not have permissions to view assets',
    assetCreatedError: 'Error creating asset',
    meterCreated: 'Meter created successfully',
    meterUpdated: 'Meter updated successfully',
    meterDeleted: 'Meter deleted successfully',
    meterDeactivated: 'Meter deactivated successfully',
    meterDuplicated: 'Meter duplicated successfully',
    assetLimitReachedError:
      'Asset limit reached. You cannot create more assets with your current plan.',
    assetCodeAlreadyExists: 'Asset code already exists',
    assetInfo: 'Asset Information',
    export: 'Export',
    import: 'Import',
    editTableColumns: 'Customize columns',
    selectedCount: '{count} selected',
    changeTypeButton: 'Change asset type',
    changeTypeTitle: 'Change asset type',
    changeTypeInfo: 'It will replace the current type of the selected assets',
    changeTypeApply: 'Add',
    changeTypeSearchPlaceholder: 'Search an asset type',
    confirmChangeTypeTitle: 'Are you sure you want to change the type of the selected assets?',
    confirmChangeTypeMessage:
      'The custom fields on the selected assets will no longer be visible, but the information will remain recorded.',
    usersAndGroupsTooltip:
      'These users and groups are responsible for this asset. If you also check "Restrict access", they will be the only ones who can view and manage it.',
    v1MetersDescription: 'Currently, we only support Hour meters.',
    addUsersDescription:
      'The selected users become the people responsible for this asset. Access to view and manage it depends on their permissions and on whether you turn on "Restrict access".',
    addUsersExpirationNotice:
      "These users will receive the expiration notices for this asset's documents.",
    findOutMore: 'Find out more',
    findOutMoreLink: '',
    betaBannerTitle: 'Assets is in Beta',
    betaBannerDescription:
      'We are working on the full version, which will include properties, meters and locations. Soon available in paid plans.',
    moreInfo: 'More info',
    viewMeasurements: 'View measurements',
    noMeasurements: 'No measurements',
    noData: 'No data',
    initialMeasurementPlaceholder: 'Enter the initial value',
    initialMeasurementsTitle: 'Initial meter measurements',
    initialMeasurementsDescription: 'Define the initial value for each meter of this asset',
    initialMeasurementTooltip:
      'This is the initial value defined when creating the asset. To update it, record a new measurement.',
    summaryTitle: 'Summary',
    noAssetTypeSelected: 'No asset type selected',
    noMeters: 'No meters',
    fieldRequired: 'This field is required',
    inactive: 'Inactive',
    inactiveMeterTooltip:
      'This meter is inactive for the current asset type. You can view previous readings. To activate it, add it to the asset type or change the asset type.',
    automatic: 'Automatic',
    automaticMeterTooltip: 'This meter receives its measurements automatically from a sensor.',
    blockedAssetTooltip:
      'This asset is blocked by plan limit. Upgrade your plan to access the details.',
    blockedAssetHistoryTooltip:
      'This asset is blocked by plan limit. Upgrade your plan to access the history.',
    assetStatus: 'Asset status',
    changeTypes: {
      asset_created: 'Asset created',
      asset_deleted: 'Asset deleted',
      asset_deactivated: 'Asset deactivated',
      asset_reactivated: 'Asset reactivated',
      asset_revived: 'Asset restored',
      asset_updated_by_import: 'Asset updated by import',
      added_user: 'Assigned user(s)',
      removed_user: 'Removed user(s)',
      added_group: 'Assigned group(s)',
      removed_group: 'Removed group(s)',
      added_meter: 'Assigned meter(s)',
      removed_meter: 'Removed meter(s)',
      name: 'Name changed',
      code: 'Code changed',
      description: 'Description changed',
      asset_type: 'Asset type changed',
      nestable_location: 'Location changed',
    },
    importDrawer: {
      title: 'Import Assets',
      step1Title: 'Step 1: Download template',
      step1Description:
        'Download the Excel template example. Each sheet corresponds to an asset type. Make sure to complete the fields marked with * to import your file correctly.',
      step1DescriptionPart1:
        'Download the Excel template example. Each sheet corresponds to an asset type. Make sure to complete the fields marked with',
      step1DescriptionPart2: 'to import your file correctly.',
      downloadExample: 'Download example',
      step2Title: 'Step 2: Edit the file',
      step3Title: 'Step 3: Upload your file',
      step3Description: 'Drag and drop your file here or select it from your computer.',
      dragDropText: 'Drag and drop your Excel file here',
      browseText: 'or browse for file',
      replaceText: 'Replace',
      fileUploadedText: 'Your file has been uploaded',
      invalidFileType: 'Please select a valid Excel file (.xlsx)',
      importSuccess: 'Assets imported successfully',
      importError: 'Error importing assets',
      importButton: 'Import',
      cancel: 'Cancel',
      importing: 'Importing...',
      importingDescription: 'Just a moment, we are organizing everything...',
      errorTitle: 'We detected an error.',
      errorMessage: 'Please check that your data has the correct format.',
      sheetsWithErrorsMessage: 'The file contains errors in the sheets: ',
      sheetsWithErrorsRecommendation:
        'Review the indicated sheets and correct the data to continue.',
      andMore: 'and {remainingCount} more',
      nameErrorMessage: '{errorCount} rows were submitted without asset name.',
      templateDownloadError: 'Failed to download template',
      downloadingTemplate: 'Downloading...',
      showMore: 'Show {count} more',
      showLess: 'Show less',
      errorsListTitle: 'Issues found',
      rowLabel: 'Row',
      formatLabel: 'Format',
      summary: {
        created: '{count} asset(s) created',
        restored: '{count} asset(s) restored',
        updated: '{count} asset(s) updated',
      },
    },
    googleSheets: {
      button: 'Google Sheets',
      modalTitle: 'Integrate Assets',
      infoMessage: 'For a secure integration, share your document with',
      editorPermission: 'editor',
      infoMessageTo: 'permissions to',
      linkLabel: 'New link',
      linkPlaceholder: 'Enter the document link to integrate',
      goToSheets: 'Go to Google Sheets',
      copied: 'Link copied',
      copyError: 'Unable to copy the link. Try copying it manually.',
      deleted: 'Google Sheets integration deleted successfully',
      deleteError: 'Error deleting Google Sheets integration',
      deleteConfirmTitle: 'Remove Google Sheets integration?',
      deleteConfirmMessage:
        'Your spreadsheet will no longer receive asset updates from DataScope. The document in Google Drive is not deleted.',
      deleteConfirmAction: 'Remove',
      cancel: 'Cancel',
      save: 'Save',
      success: 'Google Sheets integration created successfully',
      error: 'Error creating Google Sheets integration',
    },
    exportSuccess: 'Assets exported successfully',
    exportError: 'Error exporting assets',
    exporting: 'Exporting...',
    exportModal: {
      title: 'Export Assets',
      assetTypesLabel: 'Select the asset types to export',
      assetTypesPlaceholder: 'Select asset types',
      selectAll: 'Select all asset types',
      confirm: 'Export',
      cancel: 'Cancel',
      infoBanner: 'The export will only include asset types that have assets associated.',
    },
    origin: 'Source',
    meters: {
      title: 'Meters',
      subtitle: 'Manage the meters available for your assets',
      create: 'Create',
      createMeter: 'Create meter',
      automaticHintTitle: 'This meter can be fed by a sensor',
      automaticHintBody:
        'Once created and added to an asset, put it in automatic mode from the asset and pick which sensor field feeds it.',
      automaticHintDisabled:
        'The sensors module is not enabled on this account, so meters can only be filled in by hand. Write to us if you want more information.',
      editMeter: 'Edit meter',
      deactivateMeter: 'Deactivate meter',
      backToAssets: 'Back to Assets',
      cancel: 'Cancel',
      update: 'Update',
      metersSearchPlaceholder: 'Search by meter name',
      noResults: 'No results',
      feedDialogTitle: 'Feed {meter} from a sensor',
      feedSensorLabel: 'Sensor',
      feedAttributeLabel: 'Attribute that feeds the meter',
      feedAlreadyAutomatic: 'This meter is already in automatic mode. Remove it to pick a different sensor.',
      feedNoSensorsLinked: 'This asset has no linked sensors yet.',
      feedAdminOnly: 'Only administrators can put a meter in automatic mode.',
      feedNoSensorsTitle: 'This asset has no sensors linked yet',
      feedNoSensorsBody:
        'A meter can only be fed by a sensor linked to this asset. Link one from the Sensors tab and come back.',
      feedNoSensorsAction: 'Go to Sensors',
      feedNoAttributesTitle: "This sensor hasn't sent data yet",
      feedNoAttributesBody:
        'There are no fields to choose from until its first message arrives. Check the Entries screen to see what it is sending.',
      feedNoAttributes: "This sensor hasn't sent data yet.",
      feedCancel: 'Cancel',
      feedSubmit: 'Turn on automatic mode',
      feedRemove: 'Turn off automatic mode',
      feedConfigureSuccess: 'Meter set to automatic mode.',
      feedConfigureError: "We couldn't turn on automatic mode, try again.",
      feedRemoveSuccess: 'Automatic mode turned off.',
      feedRemoveError: "We couldn't turn off automatic mode, try again.",
      table: {
        name: 'Name',
        unit: 'Unit of Measure',
        usage: 'Usage',
        actions: 'Actions',
        usedInAssetTypes: 'Used in {count} type(s)',
        notUsed: 'Not used',
        edit: 'Edit',
        duplicate: 'Duplicate',
        deactivate: 'Deactivate',
        activate: 'Activate',
      },
      pagination: {
        results: 'Results: {start}-{end} of {total}',
      },
      noMeters: 'No meters found',
      confirmDeactivateDescription:
        'The meter {meterName} will be deactivated. When deactivated, it will no longer be available for new assets. If you wish, you can activate it again later.',
      meterInUseError:
        'Cannot deactivate meter that is currently used in asset types. Please remove it from asset types first.',
      deactivationDisabled:
        'This meter cannot be deactivated because it is currently in use by one or more asset types. Please remove it from asset types first.',
      units: {
        hour: 'Hour',
        minute: 'Minute',
        seconds: 'Second',
        day: 'Day',
        mile: 'Mile',
        kilometer: 'Kilometer',
        meter: 'Meter',
        foot: 'Foot',
        yard: 'Yard',
        inch: 'Inch',
        centimeter: 'Centimeter',
        millimeter: 'Millimeter',
        nautical_mile: 'Nautical Mile',
        celsius: 'Celsius',
        fahrenheit: 'Fahrenheit',
        kelvin: 'Kelvin',
        volt: 'Volt',
        megavolt: 'Megavolt',
        megavolts: 'Megavolt',
        kilovolt: 'Kilovolt',
        kilovolts: 'Kilovolt',
        millivolt: 'Millivolt',
        millivolts: 'Millivolt',
        microvolt: 'Microvolt',
        microvolts: 'Microvolt',
        bar: 'Bar',
        pascal: 'Pascal',
        psi: 'PSI',
        kilogram: 'Kilogram',
        ton: 'Ton',
        pound: 'Pound',
        kilometer_per_hour: 'Kilometer per Hour',
        mile_per_hour: 'Mile per Hour',
        meter_per_second: 'Meter per Second',
        newton_meter: 'Newton Meter',
        pound_foot: 'Pound Foot',
        liter: 'Liter',
        gallon: 'Gallon',
        cubic_meter: 'Cubic Meter',
        cubic_foot: 'Cubic Foot',
        rpm: 'RPM',
        hertz: 'Hertz',
        watt: 'Watt',
        kilowatt: 'Kilowatt',
        ampere: 'Ampere',
        square_meter: 'Square Meter',
        square_foot: 'Square Foot',
        hectare: 'Hectare',
        farad: 'Farad',
        ohm: 'Ohm',
        siemens: 'Siemens',
        lux: 'Lux',
        radian_per_second: 'Radian per Second',
        coulomb: 'Coulomb',
        unit: 'Unit',
      },
      assetTypeModal: {
        title: 'Asset types linked to ',
        description: 'This meter is linked to the following asset types:',
        close: 'Close',
      },
    },
    value: 'Value',
    assetsCreated: 'assets created',
    duplicatesSkipped: 'duplicates skipped',
    errorsCount: 'errors',
    readings: 'Readings',
    meterHistory: {
      containsEditedReading: 'Contains an edited reading',
      containsEditedReadings: 'Contains {count} edited readings',
      clickGoesToEdited: 'The click goes to the one on {reading}',
      dayDetail: 'Day detail',
      // Plural and lowercase, for inline use after a value and as the chart's
      // axis label. assets.meters.units holds the SINGULAR Title Case names the
      // meters table and drawer need, which would read as "2179 Hora" here.
      unitNames: {
        hour: 'hours',
        minute: 'minutes',
        day: 'days',
        mile: 'miles',
        kilometer: 'kilometers',
        meter: 'meters',
        foot: 'feet',
        yard: 'yards',
        nautical_mile: 'nautical miles',
        celsius: 'degrees Celsius',
        fahrenheit: 'degrees Fahrenheit',
        kelvin: 'kelvin',
        volt: 'volts',
        megavolt: 'megavolts',
        megavolts: 'megavolts',
        kilovolt: 'kilovolts',
        kilovolts: 'kilovolts',
        millivolt: 'millivolts',
        millivolts: 'millivolts',
        microvolt: 'microvolts',
        microvolts: 'microvolts',
        bar: 'bar',
        pascal: 'pascals',
        psi: 'psi',
        kilogram: 'kilograms',
        ton: 'tons',
        pound: 'pounds',
        kilometer_per_hour: 'kilometers per hour',
        mile_per_hour: 'miles per hour',
        meter_per_second: 'meters per second',
        newton_meter: 'newton meters',
        pound_foot: 'pound-feet',
        liter: 'liters',
        gallon: 'gallons',
        cubic_meter: 'cubic meters',
        cubic_foot: 'cubic feet',
        rpm: 'rpm',
        hertz: 'hertz',
        watt: 'watts',
        kilowatt: 'kilowatts',
        ampere: 'amperes',
        square_meter: 'square meters',
        square_foot: 'square feet',
        hectare: 'hectares',
        farad: 'farads',
        ohm: 'ohms',
        siemens: 'siemens',
        lux: 'lux',
        radian_per_second: 'radians per second',
        coulomb: 'coulombs',
        unit: 'units',
      },
      readingsHistoryTitle: 'Readings history',
      chartTitle: 'Readings visualization',
      viewLabel: 'View',
      emptyNoHistoryTitle: 'No readings recorded yet',
      emptyNoHistoryBody:
        'Record a reading from a form or manually to see this meter\u2019s readings.',
      emptyNoResultsTitle: 'No readings in the selected period',
      emptyNoResultsBody: 'Adjust or clear the date filter to view other readings.',
      errorTitle: 'The history could not be loaded',
      retry: 'Retry',
      accumulatedView: 'Accumulated',
      usageView: 'Usage',
      groupedByDay: 'Grouped by day',
      groupedByWeek: 'Grouped by week',
      groupedByMonth: 'Grouped by month',
      readingsCountOne: '1 reading',
      readingsCountOther: '{count} readings',
      noReadingInBucket: 'No reading in this period',
      nearestReading: 'Nearest reading',
      editedReading: 'Edited reading',
      usageNeedsPreviousReading: 'At least one earlier reading is needed to compute usage.',
      dateFilterTitle: 'Date',
      dateFilterPopoverTitle: 'Filter by date',
    },
    configure: 'Configure',
    initialMeasurement: 'Initial measurement',
    measurementUpdated: 'Edited successfully',
    measurementUpdatedError: 'Error editing',
    measurementDeleted: 'Deleted successfully',
    measurementDeletedError: 'Error deleting',
    confirmDeleteMeasurementTitle: 'Are you sure you want to delete this measurement?',
    confirmDeleteMeasurementDescription:
      'This action is permanent and the measurement will no longer appear in the table.',
    mustEnterNumber: 'You must enter a number',
    action: 'Action performed',
    newValue: 'New value',
    measurements: 'Measurements',
    historyTitle: 'Change history',
    deleted: 'Deleted',
    measurementsHistoryEmptyState: "This meter's measurements have not been modified yet",
    formCustomFieldsLabel: 'Asset Details',
    imageDragDropText: 'Drag and drop an image here',
    filesDragDropText: 'Drag and drop files here',
    uploadFileError: 'Error uploading file',
    uploadErrorDismiss: 'Upload failed. Remove it and add the file again.',
    removeFileLabel: 'Remove file',
    discardFileLabel: 'Discard file',
    maxWeightError: 'You reached the 100 MB limit per asset. Adjust your selection.',
    maxFilesReached: 'You reached the maximum number of files for this field.',
    savingDisabledUploadsTooltip: 'Wait for the files to finish uploading before saving.',
    cancelWithUploadsConfirm: 'There are files still uploading. Are you sure you want to leave?',
    filesQuotaUsed: '{used} of {total} MB used',
    filesQuotaUnknownWarning: 'Some files could not be measured; the real total may be higher.',
    filesQuotaExceededError: 'The files exceed the 100 MB limit per asset.',
    filesItemFallbackName: 'File {number}',
    documents: {
      addExpirationDate: 'Add expiration date',
      singleFileNotice: 'Turning the expiration on limits this field to a single file.',
      remindersTitle: 'Notify before the expiration',
      reminderDays: '{days} days',
      reminderOnDueDate: 'On the expiration day',
      noRemindersSelected: 'With no notice times selected, no email will be sent.',
      expirationDateLabel: 'Expiration date',
      replaceLabel: 'Replace',
      replaceDocumentLabel: 'Replace document',
      editDocumentLabel: 'Edit document',
      removeLabel: 'Delete',
      clearDateLabel: 'Clear date',
      openCalendarLabel: 'Open calendar',
      documentRequired: 'You must attach a document.',
      singleFileDropzone: 'This field takes a single file because it carries an expiration date.',
      dateBlockedByMultipleFiles:
        'This field has more than one file. Leave only one to be able to set its expiration date.',
      noRecipientsFieldNotice:
        'Nobody will receive notices for this expiration date: the asset has no one assigned.',
      expiresOn: 'Expires:',
      expiredOn: 'Expired:',
      withoutExpirationDate: 'Expiration date not set',
      status: {
        valid: 'Valid',
        expiring: 'Expiring',
        expired: 'Expired',
        noDate: 'No date',
      },
      countOne: '{count} document',
      countMany: '{count} documents',
      banner: {
        attentionOne: 'This asset has {documents} that needs attention.',
        attentionMany: 'This asset has {documents} that need attention.',
        attentionAction: 'Manage documents',
        expiringOne: 'This asset has {documents} about to expire.',
        expiringMany: 'This asset has {documents} about to expire.',
        expiringAction: 'Review documents',
        noDate: 'This asset has {documents} without an expiration date.',
        noDateAction: 'Fill in dates',
      },
      noRecipientsWarning:
        'Nobody will receive the expiration notices for this asset\'s documents until you assign a user or a group.',
      noRecipientsAction: 'Assign a user',
      listTooltip: {
        attentionOne: '{documents} needs attention:',
        attentionMany: '{documents} need attention:',
        expiringOne: '{documents} about to expire:',
        expiringMany: '{documents} about to expire:',
        noDateOne: '{documents} needs an expiration date:',
        noDateMany: '{documents} need an expiration date:',
      },
    },
    assetLimitReachedTitle: 'Asset limit reached',
    assetLimitReachedDescription:
      'You have reached the asset limit in your plan. To add or manage more assets, upgrade your plan and get access to more features:',
    assetLimitFeature1: 'More assets available',
    assetLimitFeature2: 'Complete asset history',
    assetLimitFeature3: 'Complete asset information',
    assetLimitUpgradeButton: 'Unlock more assets now',
    assetLimitContinueButton: 'Continue with my current plan',
    limitedFeaturesAlert:
      'Some features are not available in your current plan. Upgrade your plan to see all assets and their measurements.',
    changePlan: 'Change plan',
    landing: {
      headerTitle: 'Start managing your assets in one place',
      headerSubtitle: 'What are assets for?',
      headerBullet1Bold: 'Customize fields by asset type: ',
      headerBullet1: 'define what data you need and create fields for each type of asset.',
      headerBullet2Bold: 'Easily link multiple meters: ',
      headerBullet2: 'assign one or more meters to each asset type according to your needs.',
      headerBullet3Bold: 'Centralized resource management: ',
      headerBullet3:
        'create and organize your assets from a single platform, viewing key information such as status, location, and meter readings.',
      headerButton: 'Use assets',
      carouselTitle: 'Create your first asset',
      carouselStep1Title: 'Create asset type',
      carouselStep1Description:
        'Create an asset type and define a category for your assets, like Equipment or Vehicles. Then you can ',
      carouselStep1DescriptionBold: 'customize the fields each asset should have.',
      carouselStep2Title: 'Select meters',
      carouselStep2Description: 'Choose the meters you want to use for this asset type, such as ',
      carouselStep2DescriptionBold:
        'hour meter, mileage, temperature or create new ones if needed.',
      carouselStep3Title: 'Create your first asset',
      carouselStep3Description: 'After configuring the asset type, press ',
      carouselStep3DescriptionBold: 'Create asset',
      carouselStep3DescriptionEnd: ' and complete the corresponding information.',
      carouselStep4Title: "Can't find the meter you need?",
      carouselStep4Description:
        'If the meter you need is not available, you can create it from the ',
      carouselStep4DescriptionBold: 'Meters tab.',
      carouselNext: 'Next',
      carouselPrevious: 'Previous',
      footerTitle: 'Organize, measure, and manage',
      footerDescription:
        'Now that you know how assets work, create an asset type, customize its information, and start linking them to your forms and readings.',
      footerButton: 'Create asset type',
    },
    assetTypes: {
      title: 'Asset Types',
      noAssetType: 'No asset type selected',
      noAssetTypes: 'No asset types found',
      create: 'Create',
      createAssetType: 'Create Asset Type',
      createAssetTypeSuccess: 'Asset type created successfully',
      createAssetTypeError: 'Error creating asset type',
      createAssetTypeErrorDuplicateName: 'Asset type name already exists',
      type: 'Asset Type',
      description: 'Description',
      createdAssets: 'Created Assets',
      actions: 'Actions',
      confirmDeleteTitle: 'Are you sure you want to delete this asset type?',
      confirmDeleteDescription:
        'The asset type {assetTypeName} will be deleted. This action cannot be undone.',
      assetTypeDeleted: 'Asset type deleted successfully',
      assetTypeDeletedError: 'Error deleting asset type',
      searchPlaceholder: 'Search asset type',
      viewAssets: 'View assets',
      assetTypeDeleteSuccess: 'Asset type deleted successfully',
      assetTypeDeleteError: 'Error deleting asset type',
      assetTypeUpdateSuccess: 'Asset type updated successfully',
      assetTypeUpdateError: 'Error updating asset type',
      formTitleEdit: 'Edit Asset Type',
      formSubtitleCreate: 'Provide details for every asset type attribute.',
      formSubtitleEdit: 'Update the asset type attributes and save your changes.',
      formNameLabel: 'Name',
      formDescriptionLabel: 'Description',
      formCustomIdLabel: 'Custom ID Name',
      formIconLabel: 'Icon',
      formLoadError: 'Unable to load this asset type.',
      formBackToList: 'Back to Asset Types',
      formReset: 'Reset',
      formSave: 'Save',
      formCancel: 'Cancel',
      formMeterSelectLabel: 'Select a meter',
      formCustomIdTooltip:
        'For a better experience, your assets should have a unique identifier. Call it whatever you want: ID, Plate, Serial, etc',
      iconSelectorColors: 'Colors',
      iconSelectorIcons: 'Icons',
      addMeterTitle: 'Add Meter',
      addMeterDescription:
        'Add meters according to the use of your asset. You can edit them when you need them',
      addMeterPlaceholder: 'Select a meter for your asset type',
      addFieldsTitle: 'Add Custom Fields',
      addFieldsDescription: 'Define the fields that will appear in the asset creation form',
      addFieldButton: 'Add field',
      requiredField: 'Required field',
      dragFieldLabel: 'Drag field {name}',
      backToAssets: 'Back to Assets',
      fieldNameAlreadyExists: 'Field name already exists',
      reachedAssetTypeFieldsLimit:
        'You have reached the maximum number of fields for an asset type',
      selectType: 'Select an asset type',
      search: 'Search asset types...',
      fieldTypes: {
        text: 'Text',
        number: 'Number',
        date: 'Date',
        image: 'Image',
        files: 'Files',
      },
      fileTypeSelector: {
        label: 'File Type',
        allFormats: 'All formats',
        audio: 'Audio',
        video: 'Video',
      },
    },
  },
  mainMenu: {
    home: 'Home',
    forms: 'Forms',
    integrations: 'Integrations',
    taskAssigner: 'Task Assignments',
    plannings: 'Plannings',
    findings: 'Issues',
    signatures: 'Signatures',
    lists: 'Lists',
    locations: 'Locations',
    assets: 'Assets',
    charts: 'Charts',
    map: 'Map',
    sensors: 'Sensors',
    training: 'Training',
    settings: {
      main: 'Settings and help',
      changelog: 'Alerts',
      account: 'Accounts settings',
      users: 'Users',
      billing: 'Billing',
      invite: 'Invite',
      helpCenter: 'Help center',
      news: 'News',
      upgrade: 'Upgrade',
    },
    new: 'New',
    askDataScope: 'Ask DataScope',
    whatsapp: 'WhatsApp',
    myDashboards: 'My Dashboards',
  },
  dashboards: {
    title: 'My Dashboards',
    empty: 'No dashboards saved yet.',
    emptyHint: 'Ask for a chart in Ask DataScope and save it here.',
    delete: 'Delete dashboard',
    refresh: 'Refresh',
    loading: 'Loading...',
    loadError: 'Could not load dashboards.',
    addTo: 'Add to My Dashboards',
    viewIn: 'View in My Dashboards',
    saving: 'Saving...',
    saveError: 'Error saving',
    noDataToSave: 'No data to save',
    updatedAt: 'Updated',
    back: 'Back',
  },
  whatsappModule: {
    title: 'WhatsApp Module',
    subtitle: 'Fill out forms and receive responses directly through WhatsApp.',
    loadError: "We couldn't load the module status. Please try again.",
    onboarding: {
      title: 'Try the WhatsApp Module',
      intro: 'Your users fill out forms by chatting on WhatsApp: text, audio and photos.',
      trialOffer: 'Start with a free trial of {limit} forms for {days} days.',
      startTrial: 'Start free trial',
      phoneTitle: 'Confirm your WhatsApp number',
      phoneHint: "Include the country code. We'll activate it so you can talk to the bot.",
      confirm: 'Confirm and activate',
      confirming: 'Activating...',
      readyTitle: 'Done! Send the bot a message',
      readyDetail: 'Scan the QR or open WhatsApp with the button and send "{greeting}".',
      openWhatsapp: 'Open WhatsApp',
      noBotNumber: "Your number is activated. The bot's number will be configured soon.",
      done: 'Go to panel',
      invalidPhone: "That number doesn't look valid. Check the country code.",
      enrolledElsewhere: 'That number is already activated in another account.',
      genericError: "We couldn't activate the number. Please try again.",
    },
    usage: {
      title: 'Period usage',
      responses: 'Responses',
      messagesSent: 'Messages sent',
      messagesReceived: 'Messages received',
      quota: 'Quota',
    },
    trial: {
      title: 'Free trial',
      usedOfLimit: '{used} of {limit} forms used',
      daysRemaining: '{days} trial days left.',
      active: 'Active',
      exhausted: 'Ended',
      exhaustedHint: 'You used all trial forms. Activate the module to continue.',
      expiredHint: 'Your trial period is over. Activate the module to continue.',
    },
    price: {
      title: 'Price',
      activationTitle: 'Activation',
      pitch: 'Enjoying the module? Write to us and we will activate it for your operation.',
      contactCta: 'Talk to us',
      activate: 'Talk to us',
      activeBadge: 'Module active',
      trialBadge: 'On trial',
      inactiveBadge: 'Inactive',
      contactHint: "You're on a trial. Whenever you want to activate it, write to us.",
      trialEndedPitch: 'Your trial ended. Write to us to activate the module for your operation.',
      contactMessage: 'Hi, I want to activate the WhatsApp Module on my account.',
    },
    start: {
      title: 'Start using it',
    },
    users: {
      title: 'Users',
      enabledSection: 'Activated',
      readySection: 'Ready to activate',
      noPhoneSection: 'No phone number',
      enable: 'Activate',
      disable: 'Deactivate',
      noPhoneHint: 'Add a phone number to this user to activate them.',
      cutoverWarning: 'Once you activate the first user, only activated users can use the bot.',
      empty: 'No users in this group.',
    },
    responses: {
      title: 'WhatsApp responses',
      form: 'Form',
      code: 'Code',
      user: 'User',
      date: 'Date',
      empty: 'No WhatsApp responses yet.',
    },
  },
  askDataScope: {
    title: 'Ask DataScope',
    placeholder: 'Ask anything about your data...',
    placeholderWithActions: 'Ask about your data, or ask me to create accounts...',
    newChat: 'New Chat',
    modules: {
      all: 'All',
      forms: 'Forms',
      tasks: 'Tasks',
      locations: 'Locations',
      assets: 'Assets',
      signatures: 'Signatures',
      tickets: 'Issues',
    },
    mentions: {
      categories: {
        forms: 'Forms',
        users: 'Users',
        locations: 'Places',
        assets: 'Assets',
        groups: 'Groups',
      },
      noResults: 'No results',
      back: 'Back',
      loading: 'Searching...',
      loadError: 'Could not load. Please try again.',
    },
    chartTypePrompt: {
      question: 'Which chart type would you like?',
      types: {
        bar: 'Bar',
        line: 'Line',
        pie: 'Pie',
        donut: 'Donut',
        stat: 'Number',
        heatmap: 'Heatmap',
      },
    },
    export: {
      chooseFormat: 'Which format would you like?',
      chooseRecord: 'Signatures download one document at a time. There are {count}; pick which one:',
      exportObject: 'Export {object}',
      periodPrompt: 'This export needs a date range. Pick the period you want in the file.',
      working: 'Exporting…',
      success: 'The data was exported successfully',
      objects: {
        tasks: 'tasks',
        form_answers: 'responses',
        plannings: 'plannings',
        assets: 'assets',
        locations: 'places',
        lists: 'lists',
        tickets: 'tickets',
        signatures: 'signatures',
      },
      download: 'Download {module}',
      preparing: 'Preparing the file…',
      stillPreparing: "The file is still being generated. We'll email you when it's ready.",
      expired: 'The download link expired. Request the export again.',
      expiredOrFailed: 'The download is no longer available.',
      retry: 'Try again',
      limitWarning:
        'The export supports up to {max} days and you are asking for {requested}, so the file will only cover the last {max} days of the range.',
      droppedFilters: 'The file does not apply these filters: {fields}.',
      droppedFiltersGeneric: 'The file does not apply all of the filters of the query.',
      // Backend field names -> readable labels. The warning used to print them raw
      // ("form_state_id"). Person fields are absent on purpose: the backend strips
      // them from every declaration, so they cannot reach this note.
      filterFields: {
        form_id: 'form',
        form_ids: 'form',
        task_form_id: 'form',
        form_name: 'form name',
        form_state_id: 'status',
        form_state_ids: 'status',
        status: 'status',
        acceptance_status: 'acceptance status',
        priority: 'priority',
        asset_id: 'asset',
        asset_ids: 'asset',
        asset_type_id: 'asset type',
        location_id: 'place',
        location_ids: 'place',
        location: 'place',
        nestable_location_id: 'place',
        location_type: 'place type',
        place_type_id: 'place type',
        planning_type_id: 'planning type',
        signer_type: 'signer type',
        active: 'active or inactive',
        name: 'name',
        code: 'code',
        city: 'city',
        region: 'region',
        country: 'country',
      },
      droppedPeriod: 'The file does not apply the date range of the query.',
      caveats: {
        search_not_ids:
          'The export searches by text, so it may include records other than the ones counted.',
        whole_account_only: 'The export covers the whole account, without the filters of the query.',
        nestable_only: 'The export only covers the places of the current module.',
        pdf_index_not_files:
          'You will get a spreadsheet with a link to each response\u2019s PDF, not the PDFs together.',
      },
      formats: {
        excel: 'Excel',
        excel_by_question: 'Excel by question',
        excel_by_form: 'Excel by form',
        excel_by_repeatable: 'Excel by repeatable table',
        excel_all: 'Full Excel',
        pdf_single: 'PDF',
        pdf_documents: 'PDF of the documents',
      },
      reasons: {
        export_failed: "We couldn't generate the file. Try again in a few minutes.",
        export_not_in_plan: 'Your plan does not include exports.',
        export_module_has_none: 'This module has no export.',
        export_module_unknown: "I can't export this module.",
        export_not_available_yet: "I can't hand you this file from the chat yet.",
        export_no_data_yet: 'I need to query the data you want to download first.',
        export_needs_form_scope:
          'I cannot export every form at once. Mention them with @ or tell me what data you need.',
        export_form_scope_ambiguous:
          'That name matches more than one form. Tell me which one or ones you want to export.',
        export_format_unknown: 'That format is not available for this module.',
        export_needs_single_record:
          'This format covers a single record. Tell me which one you want.',
        export_period_required: 'I need a date range to export.',
        export_requires_places_admin: 'You need places-admin permissions to export.',
        export_already_in_progress: 'You already have an export running. Wait for it to finish.',
        export_not_permitted: "You don't have permission to export this module.",
        export_upload_failed: "The file was generated but we couldn't upload it. Try again.",
        empty_export: 'There are no records to export.',
      },
    },
    chartRefine: {
      personalize: 'Customize',
      states: { na: 'N/A', fixed: 'Fixed', recomputing: 'Recomputing…' },
      value: { title: 'Value', count: 'Count', percent: 'Percentage' },
      period: { title: 'Period', day: 'Day', week: 'Week', month: 'Month' },
      order: {
        title: 'Order',
        none: 'Chronological',
        desc: 'High to low',
        asc: 'Low to high',
      },
      breakdown: {
        title: 'Break down by',
        none: 'No breakdown',
        user: 'By user',
        status: 'By status',
        location: 'By location',
      },
    },
    chartDetail: {
      record: 'response',
      records: 'responses',
      close: 'Close',
      loading: 'Loading…',
      empty: 'No responses at this point.',
      viewIn: 'View in {module} →',
      viewCountIn: 'View the {count} records in {module} →',
      goToRecord: 'Go to response →',
      modules: {
        form_answers: 'Responses',
        tasks: 'Tasks',
        tickets: 'Tickets',
        assets: 'Assets',
        locations: 'Locations',
        signatures: 'Signatures',
      },
    },
    // It.3 "Source of the data": the line declaring what the answer was computed
    // on. `dateFormat` is the (date-fns) pattern the period is shown with in this
    // language.
    sourceLine: {
      prefix: 'Base:',
      separator: '·',
      dateFormat: 'MM/dd/yyyy',
      allTime: 'all time',
      periodRange: '{start} to {end}',
      periodFrom: 'from {start}',
      periodTo: 'until {end}',
      viewIn: 'View in {module} →',
      viewFilteredIn: 'View in {module} with these filters →',
      summaryOrigins: '{count} origins',
      summaryTotal: '{count} records in total',
      expand: 'View the detail by origin',
      collapse: 'Hide the detail by origin',
      modules: {
        form_answers: 'Responses',
        tasks: 'Tasks',
        tickets: 'Tickets',
        assets: 'Assets',
        locations: 'Locations',
        lists: 'Lists',
        plannings: 'Plannings',
        signatures: 'Signatures',
      },
      records: {
        form_answers: { one: 'response', other: 'responses' },
        tasks: { one: 'task', other: 'tasks' },
        tickets: { one: 'ticket', other: 'tickets' },
        assets: { one: 'asset', other: 'assets' },
        locations: { one: 'location', other: 'locations' },
        lists: { one: 'list', other: 'lists' },
        plannings: { one: 'planning', other: 'plannings' },
        signatures: { one: 'signature', other: 'signatures' },
      },
    },
    errors: {
      timeout: 'Request timed out. Please try again.',
      rateLimit: 'Daily message limit reached.',
      generic: 'Something went wrong. Please try again.',
    },
    typing: 'Thinking...',
    readOnly: 'I can only help you query data. I cannot make changes.',
    greeting: 'Hello',
    howCanIHelp: 'How can I help you today?',
    suggestions: 'Suggestions',
    recentChats: 'Recent chats',
    noRecentChats: 'No recent conversations.',
    conversationKind: {
      action: 'Account creation',
      query: 'Query',
    },
    moduleLockedNote:
      'Module filter is fixed for this conversation. Start a new chat to change it.',
    dateFilter: {
      from: 'From',
      to: 'To',
      clear: 'Clear',
      selectRange: 'Select date range',
    },
    prompts: [
      'Summarize the answers from [form name]',
      'Create a chart with form answers per month',
      'How many signatures are still pending?',
      'Show me all tasks completed this month',
      'Give me a general overview of my account stats',
    ],
    report: {
      buttonInline: 'Report this issue',
      title: 'Report an issue',
      description: "Tell us what went wrong or what you'd like to see.",
      defaultText: 'I would like to request a feature',
      yourQuestion: 'Your question:',
      cancel: 'Cancel',
      send: 'Send report',
      sending: 'Sending...',
      successDescription: "Thank you for your feedback. We'll look into it.",
      close: 'Close',
    },
    trial: {
      title: 'Free trial',
      description:
        'Explore Ask DataScope at no cost. Ask questions about your data in natural language and get answers in seconds.',
      expired: 'The free trial has ended.',
      feedback:
        "Your feedback helps us improve it. Use the {icon} icon next to any answer to tell us what you'd change.",
      timeRemaining: 'Time remaining:',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Min',
      seconds: 'Sec',
      gotIt: 'Start exploring',
      expiredDismiss: 'Got it',
    },
    supportHandoff: {
      openChat: 'Open support chat',
      connectWithPerson: 'Yes, talk to a person',
      fromLabel: 'Sent from Ask DataScope AI',
    },
    feedback: {
      helpful: 'Helpful answer',
      notHelpful: 'Not helpful',
    },
    aiDisclaimer: 'This feature uses AI. Verify the data before making decisions.',
    actions: {
      folders: {
        title: 'Folders you can replicate (in this account)',
        forms: 'forms',
      },
      result: {
        successTitle: 'Done, everything loaded',
        partialTitle: 'Batch partially completed',
        successBody: 'Each form was linked to its source master form.',
        partialBody: 'What was already loaded was left untouched. You can retry what is pending.',
        failedTitle: 'Pending due to an error',
        credentialsTitleOne: 'Information about the created account',
        credentialsTitleMany: 'Information about the created accounts',
        emailLabel: 'Email',
        passwordLabel: 'Password',
        copyAll: 'Copy all',
        copied: 'Copied',
        emailNote: 'An email with the one-time password was sent to the administrator; it must be changed on first sign-in.',
        retry: 'Retry what is pending',
      },
      progress: {
        title: 'Loading in queue',
        of: 'of',
        sequentialNote:
          'Sequential processing: one company at a time.',
        status: {
          queued: 'Queued',
          processing: 'Processing…',
          done: 'Done',
          failed: 'Failed · still pending',
        },
      },
      excel: {
        attach: 'Attach Excel',
        title: 'Attach Excel',
        description:
          'Upload your spreadsheet with the companies, their admin email and the folders to replicate. The AI reads it and shows you a summary before running.',
        dropzone: 'Drag your Excel here or click to browse',
        formats: '.xlsx or .xls files',
        ready: 'Ready to interpret',
        invalidType: 'Invalid format. Attach a .xlsx or .xls file',
        cancel: 'Cancel',
        use: 'Use this file',
      },
      summary: {
        title: 'Request summary',
        awaitingConfirm: 'Awaiting your confirmation',
        statNew: 'new accounts',
        statExisting: 'already exist',
        statFolders: 'folders in total',
        statForms: 'forms',
        colCompany: 'Company',
        colAccount: 'Account',
        colFolders: 'Folders',
        colForms: 'Forms',
        badgeExisting: 'Already has an account',
        badgeNew: 'New',
        inferred: 'inferred',
        moreCompanies: 'Show {n} more companies',
        showLess: 'Show less',
        existingNote:
          'Companies that already have an account are not created again: their folders are only replicated in their current account.',
        queueNote:
          'The load is processed in a queue, one by one. Each form is linked to its source master form.',
        adjust: 'Adjust',
        confirm: 'Confirm and run',
        confirmed: 'Confirmed',
        adjustNote: 'Request reopened for changes. Type the adjustments in the chat.',
        errorNote: 'The action could not be processed. Reload the conversation and try again.',
        excludedTitle: 'These accounts were not included',
        excludedItem: '{company}: will not be created because these do not exist in your account: {items}',
      },
      manage: {
        title: 'Create and manage accounts',
        createAccounts: 'Create accounts for multiple companies',
        replicableFolders: 'Which folders can I replicate?',
        exampleFolder: 'Field inspections',
        createExample:
          'Set up these companies with {folder}: Constructora del Valle (constructoradelvalle@example.cl), Minera San Rafael (minerasanrafael@example.cl), Transportes Andes (transportesandes@example.cl).',
      },
    },
  },
  mainTopBar: {
    accountSwitcher: {
      switchingTitle: 'Switching to {{account}}...',
      switchingSubtitle: 'We are moving you over, this may take a few seconds',
      title: 'Switch account',
      error: "We couldn't switch accounts. You are still in the current one.",
      unnamedAccount: 'Account {{id}}',
      currentAccount: 'Current account',
      searchPlaceholder: 'Search by name',
      searchAction: 'Search',
      seeAllAccounts: 'See all accounts ({{count}})',
      noResults: 'No accounts match that name.',
      back: 'Back',
      close: 'Close',
    },
    createIssue: 'Create issue',
    featureRequest: 'Send us your idea!',
    featureRequestText: 'Do you need a tool that we dont have yet?',
    logout: 'Logout',
    languageOptions: {
      es: 'Spanish',
      en: 'English',
      pt: 'Portuguese',
    },
    newNotifications: 'New message in {formName}',
    companySettings: 'Company settings',
    myAccount: 'My account',
  },
  notFound: {
    title: '404',
    description:
      'Sorry, but the page you are looking for has note been found. Try checking the URL for error, then hit the refresh button on your browser or try found something else in our app.',
    button: 'Go to home',
  },
  actionsOverview: {
    title: 'Monthly actions available',
    explanation: 'What are actions?',
    actionsUsed: 'Actions used',
    exceedActionsInfo:
      'If you exceed the number of actions included in your plan, an additional charge will be applied for each one.',
    moreInfo: 'More info',
    error: 'Error loading actions information',
    explanationLink:
      'https://help.mydatascope.com/en/articles/11321884-datascope-plans-how-do-they-work-and-what-s-included#h_dff3b3e159',
    moreInfoLink:
      'https://help.mydatascope.com/en/articles/11321884-datascope-plans-how-do-they-work-and-what-s-included#h_2f5fc832f3',
  },
  billing: {
    externalIframe: {
      tokenAuthorizeError: 'We could not authorize your session. Please refresh the page.',
    },
  },
  maps: {
    title: 'Find your answers on the map',
    emptyState: {
      title: 'Map your answers easily',
      subtitle: 'What is the purpose of the maps function?',
      description: 'With this functionality it is possible:',
      feature1:
        'Visualize in real time where forms are completed, tasks are executed or issues are reported.',
      feature2: 'Detect areas with low or high coverage to make strategic operational decisions.',
      feature3: 'Get traceability and geographic control of daily operations.',
      demo: {
        title: 'Visualize your answers on the map',
        mobile: {
          title: 'Answer from the field with the app',
          description:
            'Answer from the app with GPS enabled and validate that the answers were sent from the assigned location.',
          description2:
            'Important! Ensure that your team registers answers using the app with location enabled.',
        },
        web: {
          title: 'Visualize your answers on the map',
          description:
            'Once you have answered your forms from the App you can visualize your answers on an interactive map.',
        },
      },
    },
  },
  lists: {
    banner: {
      message:
        'New Locations are now available! Now you can organize, assign users and visualize activity in one place.',
      action: 'Try now',
    },
  },
  mfa: {
    title: 'Enable 2FA',
    next: 'Next',
    finish: 'Finish',
    close: 'Close',
    scanQr: 'Scan QR code',
    scanQrDescription: 'Scan the QR code with your preferred authentication app',
    manualEntry: 'Or enter the code manually',
    verifying: 'Verifying...',
    verifyCode: 'Enter the authentication code',
    verifyCodeDescription: 'Write the 6-digit code that appears in your authentication app',
    verifyCodeInvalid: 'Invalid code. Try again.',
    verifyCodeError: 'Error verifying the code',
    verifyCodeCognitoError:
      'We had an internal error. Please contact us through the chat to solve it.',
    successTitle: 'Authentication configured successfully',
    successDescription:
      'From now on, each time you log in, you will be asked for a temporary code from your authentication app for greater security',
    successDescriptionMobile: 'To continue, please close the DataScope app and open it again.',
    maybeLater: 'Maybe later',
    activateNow: 'Activate now',
    protectAccount: 'Protect your account with an extra layer of security',
    protectAccountDescription:
      'With two-factor authentication, you will need a temporary code from your authenticator app to log in. You can manage this setting later from your user profile.',
    organizationRequires: 'Your organization requires activating two-factor authentication (2FA)',
    organizationRequiresDescription:
      'Use an authenticator app to generate the temporary code that will be asked when you log in',
    userSettings: {
      title: 'Account security (2FA)',
      descriptionActive:
        'Add an extra layer of security to your account.\n When you activate two-factor authentication (2FA), you will be asked for a code from your authenticator app when you log in.',
      descriptionDisable:
        'You have two-factor authentication enabled. To log in, you need a temporary code from your authentication app.\n You can disable it, but your account will be less secure.',
      activate: 'Enable 2FA',
      disableConfig: 'Disable 2FA',
      disableDialogTitle: 'Are you sure you want to disable two-factor authentication?',
      disableDialogDescription:
        'If you disable it, your account will be less secure. You can enable it again whenever you want.',
      disableDialogConfirm: 'Disable',
      disableDialogCancel: 'Cancel',
      justSameUserCanActivate: 'Only the same user can activate two-factor authentication (2FA)',
    },
  },
  scheduledSend: {
    sendNow: 'Send now',
    sameDay: 'At task start',
    dayBefore: 'day before',
    daysBefore: 'days before',
    weekBefore: '1 week before',
    monthBefore: '1 month before',
    blockTitle: 'Schedule task send',
    blockDescription:
      'Define how many days before the task starts it will be sent to the responsible',
    statsLabel: 'Scheduled',
    scheduled: 'Scheduled',
    onboardingModal: {
      title: 'You can now schedule task delivery',
      description:
        'You can now decide when the operator will receive the task: on the same day or in advance, to improve planning and execution.',
      primaryButton: 'Got it',
      secondaryButton: 'Learn how it works',
      helpCenterUrl:
        'https://help.mydatascope.com/en/articles/14536340-scheduling-of-assigned-tasks',
    },
    tooltip: {
      sendNow: 'The task will be sent today',
      sameDay: 'The task will be sent at task start',
      nDaysBefore: 'The task will be sent on {{dates}}',
      sentOn: 'The task was sent on {{dates}}',
      disabledSingular: '{{count}} selected date does not allow scheduling this send: {{dates}}',
      disabledPlural: '{{count}} selected dates do not allow scheduling this send: {{dates}}',
      noStartDate: 'Select at least one start date and time',
    },
  },
};
